import axios from 'axios';
import collect from 'collect.js';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _library = true;

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var _redefine = _hide;

var _iterators = {};

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: 'pure',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

var TO_STRING_TAG = _wks('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
  _iterators[NAME] = _iterators.Array;
}

var f$1 = _wks;

var _wksExt = {
	f: f$1
};

var iterator = _wksExt.f('iterator');

var iterator$1 = createCommonjsModule(function (module) {
module.exports = { "default": iterator, __esModule: true };
});

unwrapExports(iterator$1);

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var defineProperty = _objectDp.f;
var _wksDefine = function (name) {
  var $Symbol = _core.Symbol || (_core.Symbol = {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
};

var f$2 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$2
};

var f$3 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$3
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys(it);
  var getSymbols = _objectGops.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$4
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
	f: f$5
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$6
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;



















var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$2 = 'prototype';
var HIDDEN = _wks('_hidden');
var TO_PRIMITIVE = _wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared('symbol-registry');
var AllSymbols = _shared('symbols');
var OPSymbols = _shared('op-symbols');
var ObjectProto$1 = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = _global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto$1, key);
  if (protoDesc) delete ObjectProto$1[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto$1) dP$1(ObjectProto$1, key, protoDesc);
} : dP$1;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
  _anObject(it);
  key = _toPrimitive(key, true);
  _anObject(D);
  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$1(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject(it);
  var keys = _enumKeys(P = _toIobject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$1;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto$1) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };
    if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag(_global.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core.Symbol;

var symbol$1 = createCommonjsModule(function (module) {
module.exports = { "default": symbol, __esModule: true };
});

unwrapExports(symbol$1);

var _typeof_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _iterator2 = _interopRequireDefault(iterator$1);



var _symbol2 = _interopRequireDefault(symbol$1);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
});

var _typeof = unwrapExports(_typeof_1);

// 19.1.2.1 Object.assign(target, source, ...)





var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var assign = _core.Object.assign;

var assign$1 = createCommonjsModule(function (module) {
module.exports = { "default": assign, __esModule: true };
});

var _Object$assign = unwrapExports(assign$1);

var classCallCheck = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});

var _classCallCheck = unwrapExports(classCallCheck);

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var $Object = _core.Object;
var defineProperty$1 = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$2 = createCommonjsModule(function (module) {
module.exports = { "default": defineProperty$1, __esModule: true };
});

unwrapExports(defineProperty$2);

var createClass = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});

var _createClass = unwrapExports(createClass);

var Client = function () {
  function Client() {
    _classCallCheck(this, Client);
  }

  _createClass(Client, null, [{
    key: 'delete',


    /** @return {Promise<any>} */
    value: function _delete(url) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request('DELETE', url, args);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'get',
    value: function get(url) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request('GET', url, args);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'patch',
    value: function patch(url) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request('PATCH', url, args);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'post',
    value: function post(url) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request('POST', url, args);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'put',
    value: function put(url) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request('PUT', url, args);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'request',
    value: function request(method, url) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return Client.HTTP_CLIENT.request(_Object$assign({
        method: method,
        url: url,
        timeout: 10000
      }, args));
    }
  }, {
    key: 'BASE_URL',

    /** @type {string} */
    get: function get() {
      if ((typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && _typeof(process.env) === 'object' && process.env.DISPLET_API_URL) {
        return process.env.DISPLET_API_URL;
      }

      return 'https://api-v3.displet.com/';
    }

    /** @type {object} */

  }]);

  return Client;
}();

Client.HTTP_CLIENT = axios.create({
  baseURL: Client.BASE_URL
});

var userRoles = {
  admin: 'Administrator',
  agent: 'Agent',
  lender: 'Lender',
  staff: 'Staff',
  super: 'Super User'
};

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$1 = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var ITERATOR$3 = _wks('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$3]();
  riter['return'] = function () { SAFE_CLOSING = true; };
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$3]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$3] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export(_export.S + _export.F * !_iterDetect(function (iter) { }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var from = _core.Array.from;

var from$1 = createCommonjsModule(function (module) {
module.exports = { "default": from, __esModule: true };
});

unwrapExports(from$1);

var toConsumableArray = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _from2 = _interopRequireDefault(from$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
});

var _toConsumableArray = unwrapExports(toConsumableArray);

var Container = function () {
  function Container() {
    _classCallCheck(this, Container);

    this._bindings = {};
  }
  /** @type {object} */


  /** @type {object} */


  _createClass(Container, [{
    key: "bind",


    /** @return {void} */
    value: function bind(key, concrete) {
      this._bindings[key] = concrete;
    }

    /** @return {object} */

  }, {
    key: "resolve",
    value: function resolve(concrete) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var concreteImplementation = this._bindings[concrete.name] || concrete;

      // eslint-disable-next-line new-cap
      return new (Function.prototype.bind.apply(concreteImplementation, [null].concat(_toConsumableArray(args))))();
    }
  }], [{
    key: "getInstance",


    /** @return {object} */
    value: function getInstance() {
      if (this._instance === null) {
        this._instance = new Container();
      }

      return this._instance;
    }
  }]);

  return Container;
}();

Container._instance = null;

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.9 Object.getPrototypeOf(O)



_objectSap('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return _objectGpo(_toObject(it));
  };
});

var getPrototypeOf = _core.Object.getPrototypeOf;

var getPrototypeOf$1 = createCommonjsModule(function (module) {
module.exports = { "default": getPrototypeOf, __esModule: true };
});

var _Object$getPrototypeOf = unwrapExports(getPrototypeOf$1);

var possibleConstructorReturn = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});

var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

// 19.1.3.19 Object.setPrototypeOf(O, proto)

_export(_export.S, 'Object', { setPrototypeOf: _setProto.set });

var setPrototypeOf = _core.Object.setPrototypeOf;

var setPrototypeOf$1 = createCommonjsModule(function (module) {
module.exports = { "default": setPrototypeOf, __esModule: true };
});

unwrapExports(setPrototypeOf$1);

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
_export(_export.S, 'Object', { create: _objectCreate });

var $Object$1 = _core.Object;
var create = function create(P, D) {
  return $Object$1.create(P, D);
};

var create$1 = createCommonjsModule(function (module) {
module.exports = { "default": create, __esModule: true };
});

unwrapExports(create$1);

var inherits = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf$1);



var _create2 = _interopRequireDefault(create$1);



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});

var _inherits = unwrapExports(inherits);

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES = _wks('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES]) == undefined ? D : _aFunction(S);
};

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var process$1 = _global.process;
var setTask = _global.setImmediate;
var clearTask = _global.clearImmediate;
var MessageChannel = _global.MessageChannel;
var Dispatch = _global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof(process$1) == 'process') {
    defer = function (id) {
      process$1.nextTick(_ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
    defer = function (id) {
      _global.postMessage(id + '', '*');
    };
    _global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
    defer = function (id) {
      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
        _html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
var process$2 = _global.process;
var Promise$1 = _global.Promise;
var isNode = _cof(process$2) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction(resolve);
  this.reject = _aFunction(reject);
}

var f$7 = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$7
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator = _global.navigator;

var _userAgent = navigator && navigator.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject(C);
  if (_isObject(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else _hide(target, key, src[key]);
  } return target;
};

var SPECIES$1 = _wks('species');

var _setSpecies = function (KEY) {
  var C = typeof _core[KEY] == 'function' ? _core[KEY] : _global[KEY];
  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
    configurable: true,
    get: function () { return this; }
  });
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global.TypeError;
var process$3 = _global.process;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global[PROMISE];
var isNode$1 = _classof(process$3) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE$1 = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else if (handler = _global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global, function () {
    var handler;
    if (isNode$1) {
      process$3.emit('rejectionHandled', promise);
    } else if (handler = _global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE$1) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance(this, $Promise, PROMISE, '_h');
    _aFunction(executor);
    Internal.call(this);
    try {
      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$3.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx($resolve, promise, 1);
    this.reject = _ctx($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE$1, { Promise: $Promise });
_setToStringTag($Promise, PROMISE);
_setSpecies(PROMISE);
Wrapper = _core[PROMISE];

// statics
_export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export(_export.S + _export.F * (_library), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve(_library && this === Wrapper ? $Promise : this, x);
  }
});
_export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

_export(_export.P + _export.R, 'Promise', { 'finally': function (onFinally) {
  var C = _speciesConstructor(this, _core.Promise || _global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

// https://github.com/tc39/proposal-promise-try




_export(_export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = _newPromiseCapability.f(this);
  var result = _perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

var promise = _core.Promise;

var promise$1 = createCommonjsModule(function (module) {
module.exports = { "default": promise, __esModule: true };
});

var _Promise = unwrapExports(promise$1);

var runtime = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = module.exports;

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);
});

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

var runtimeModule = runtime;

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

var regenerator = runtimeModule;

var asyncToGenerator = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _promise2 = _interopRequireDefault(promise$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var keys = _core.Object.keys;

var keys$1 = createCommonjsModule(function (module) {
module.exports = { "default": keys, __esModule: true };
});

var _Object$keys = unwrapExports(keys$1);

var semver = createCommonjsModule(function (module, exports) {
exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = '(?:^|[^\\d])' +
              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:$|[^\\d])';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(new SemVer(b, loose));
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};

Comparator.prototype.intersects = function(comp, loose) {
  if (!(comp instanceof Comparator)) {
    throw new TypeError('a Comparator is required');
  }

  var rangeTmp;

  if (this.operator === '') {
    rangeTmp = new Range(comp.value, loose);
    return satisfies(this.value, rangeTmp, loose);
  } else if (comp.operator === '') {
    rangeTmp = new Range(this.value, loose);
    return satisfies(comp.semver, rangeTmp, loose);
  }

  var sameDirectionIncreasing =
    (this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '>=' || comp.operator === '>');
  var sameDirectionDecreasing =
    (this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '<=' || comp.operator === '<');
  var sameSemVer = this.semver.version === comp.semver.version;
  var differentDirectionsInclusive =
    (this.operator === '>=' || this.operator === '<=') &&
    (comp.operator === '>=' || comp.operator === '<=');
  var oppositeDirectionsLessThan =
    cmp(this.semver, '<', comp.semver, loose) &&
    ((this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '<=' || comp.operator === '<'));
  var oppositeDirectionsGreaterThan =
    cmp(this.semver, '>', comp.semver, loose) &&
    ((this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '>=' || comp.operator === '>'));

  return sameDirectionIncreasing || sameDirectionDecreasing ||
    (sameSemVer && differentDirectionsInclusive) ||
    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};


exports.Range = Range;
function Range(range, loose) {
  if (range instanceof Range) {
    if (range.loose === loose) {
      return range;
    } else {
      return new Range(range.raw, loose);
    }
  }

  if (range instanceof Comparator) {
    return new Range(range.value, loose);
  }

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

Range.prototype.intersects = function(range, loose) {
  if (!(range instanceof Range)) {
    throw new TypeError('a Range is required');
  }

  return this.set.some(function(thisComparators) {
    return thisComparators.every(function(thisComparator) {
      return range.set.some(function(rangeComparators) {
        return rangeComparators.every(function(rangeComparator) {
          return thisComparator.intersects(rangeComparator, loose);
        });
      });
    });
  });
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  var max = null;
  var maxSV = null;
  try {
    var rangeObj = new Range(range, loose);
  } catch (er) {
    return null;
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) { // satisfies(v, range, loose)
      if (!max || maxSV.compare(v) === -1) { // compare(max, v, true)
        max = v;
        maxSV = new SemVer(max, loose);
      }
    }
  });
  return max;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  var min = null;
  var minSV = null;
  try {
    var rangeObj = new Range(range, loose);
  } catch (er) {
    return null;
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) { // satisfies(v, range, loose)
      if (!min || minSV.compare(v) === 1) { // compare(min, v, true)
        min = v;
        minSV = new SemVer(min, loose);
      }
    }
  });
  return min;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0');
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

exports.intersects = intersects;
function intersects(r1, r2, loose) {
  r1 = new Range(r1, loose);
  r2 = new Range(r2, loose);
  return r1.intersects(r2)
}

exports.coerce = coerce;
function coerce(version) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  var match = version.match(re[COERCE]);

  if (match == null)
    return null;

  return parse((match[1] || '0') + '.' + (match[2] || '0') + '.' + (match[3] || '0')); 
}
});
var semver_1 = semver.SEMVER_SPEC_VERSION;
var semver_2 = semver.re;
var semver_3 = semver.src;
var semver_4 = semver.parse;
var semver_5 = semver.valid;
var semver_6 = semver.clean;
var semver_7 = semver.SemVer;
var semver_8 = semver.inc;
var semver_9 = semver.diff;
var semver_10 = semver.compareIdentifiers;
var semver_11 = semver.rcompareIdentifiers;
var semver_12 = semver.major;
var semver_13 = semver.minor;
var semver_14 = semver.patch;
var semver_15 = semver.compare;
var semver_16 = semver.compareLoose;
var semver_17 = semver.rcompare;
var semver_18 = semver.sort;
var semver_19 = semver.rsort;
var semver_20 = semver.gt;
var semver_21 = semver.lt;
var semver_22 = semver.eq;
var semver_23 = semver.neq;
var semver_24 = semver.gte;
var semver_25 = semver.lte;
var semver_26 = semver.cmp;
var semver_27 = semver.Comparator;
var semver_28 = semver.Range;
var semver_29 = semver.toComparators;
var semver_30 = semver.satisfies;
var semver_31 = semver.maxSatisfying;
var semver_32 = semver.minSatisfying;
var semver_33 = semver.validRange;
var semver_34 = semver.ltr;
var semver_35 = semver.gtr;
var semver_36 = semver.outside;
var semver_37 = semver.prerelease;
var semver_38 = semver.intersects;
var semver_39 = semver.coerce;

/**
 * Basic utilities module.
 * @module utils/basic
 */

/**
 * Formats a message replacing placeholders with variables values.
 * @param {string} message - A message that can contain placeholders.
 * @param {Object} [variables] - Variables for replacing message placeholders.
 *
 * @example
 * formatMessage("Hello {name}", {name: "John"});
 * // > "Hello John"
 *
 * formatMessage("Hello {{name}}", {name: "John"});
 * // > "Hello \"John\""
 */
function formatMessage(message, variables) {
  return (
    message
      // Replace {{variable}} with `JSON.stringify(variableValue)`.
      .replace(/{{([0-9a-zA-Z-_. ]+)}}/g, function(_, variable) {
        // JSON.stringify(NaN) yields 'null', so we need a special case for NaN
        if (
          typeof variables[variable] === "number" &&
          isNaN(variables[variable])
        ) {
          return "NaN";
        }
        return JSON.stringify(variables[variable]);
      })
      // Replace {variable} with `variableValue`.
      .replace(/{([0-9a-zA-Z-_. ]+)}/g, function(_, variable) {
        return variables[variable];
      })
  );
}

/**
 * Checks if passed *object* is a plain object.
 * @param {*} object - Value subject to test.
 * @returns {boolean} Returns `true` if *object* is a plain object or `false`.
 *
 * @example
 *
 * isPlainObject(); // > false
 * isPlainObject(null); // > false
 * isPlainObject(new Date()); // > false
 * isPlainObject([]); // > false
 * isPlainObject(1); // > false
 * isPlainObject(true); // > false
 * isPlainObject("foo"); // > false
 * isPlainObject(function() {}); // > false
 * isPlainObject({a: 1}); // > true
 */
function isPlainObject(object) {
  // Inspired by jQuery Core, but reduced to our use case.
  return (
    object !== null &&
    "" + object === "[object Object]" &&
    object.constructor === Object
  );
}

/**
 * @param {Array} array - The list of strings to glue together as an English formatted list string.
 * @param {string} conjunction - Conjunction value, e.g., `'and'`, `'or'`.
 * @returns {string} Returns an English formatted list string using the passed *conjunction*.
 *
 * @example
 *
 * listFormat([], 'or'); // > ''
 * listFormat(['foo'], 'or'); // > 'foo'
 * listFormat(['foo', 'bar'], 'or'); // > 'foo or bar'
 * listFormat(['foo', 'bar', 'baz'], 'or'); // > 'foo, or bar, or baz'
 */
function listFormat(array, conjunction) {
  if (array.length === 0) {
    return "";
  }
  if (array.length === 1) {
    return array[0];
  }
  if (array.length === 2) {
    return array.join(" " + conjunction + " ");
  }
  if (array.length > 2) {
    return array.join(", " + conjunction + " ");
  }
}

/**
 * Returns the type of a variable with additional types than native `typeof`.
 * @param {*} variable - A variable to deduce its type.
 *
 * @example
 * smarterTypeof(null); // > "null"
 * smarterTypeof({a: 1}); // > "plain object"
 * smarterTypeof([]); // > "array"
 * smarterTypeof(new Date()); // > "date"
 * smarterTypeof(<anything else>); // > result of regular typeof.
 */
function smarterTypeof(variable) {
  if (variable === null) {
    return "null";
  }
  if (isPlainObject(variable)) {
    return "plain object";
  }
  if (Array.isArray(variable)) {
    return "array";
  }
  if (variable instanceof Date) {
    return "date";
  }
  return typeof variable;
}

/**
 * Returns `true` is *element* belongs to *collection*.
 * @param {*} element - The key of an Object or the element of an Array.
 * @param {(Array| Object)} Where to search for element at.
 *
 * @example
 *
 * withinRange("bar", ["foo", "bar", "baz"]);
 * // > true
 * withinRange("quax", ["foo", "bar", "baz"]);
 * // > false
 *
 * @example
 *
 * withinRange("bar", {foo: 1, bar: 2, baz: 3});
 * // > true
 * withinRange("quax", {foo: 1, bar: 2, baz: 3});
 * // > false
 */
function withinRange(element, collection) {
  return Array.isArray(collection)
    ? collection.indexOf(element) !== -1
    : element in collection;
}

/**
 * Assertion utilities module.
 * @module utils/assertion
 *
 * @example
 *
 * function myFunction(foo, bar) {
 *   assertType(foo, 'foo', ['string']);
 *   assertType(bar, 'bar', ['plain object']);
 * }
 *
 * myFunction(1);
 * // > TypeError: Parameter `foo` must be a string, not number `1`
 *
 * myFunction("1", []);
 * // > TypeError: Parameter `bar` must be a plain object, not array `[]`
 */

/**
 * Asserts values that are assumed to be true.
 * @param {boolean} condition - Won't throw if true, will throw if false.
 * @param {string} errorMessage - The error message. Can contain placeholders for variable
 *        replacement, e.g., 'Hello {name}' where the value for name comes from `options.name`.
 * @param {Object} [options]
 * @param {Object} [options.errorClass=Error] The class of the error to throw.
 * @param {string} [options.*] Any other option will be used for variable replacement in
 *        errorMessage.
 * @returns Returns `true` if *condition* if `true`.
 * @throws Will throw *option.errorClass* if *condition* if `false`.
 *
 * @example
 *
 * // This will not throw and return true.
 * assert(truthyValue, 'error message');
 * // > true
 *
 * @example
 *
 * // This will throw an error with this error message.
 * assert(falseyValue, 'error message');
 * // > throw Error('error message')
 */
function assert(condition, errorMessage, options) {
  var error, errorClass;

  if (condition) {
    return true;
  }

  options = options || {};
  // Assign errorClass and remove it from options.
  errorClass = options.errorClass || Error;

  errorMessage = formatMessage(errorMessage, options);
  error = new errorClass(errorMessage);
  error.attributes = options;

  throw error;
}

/**
 * Throw a TypeError in case *parameterValue* isn't any of *expectedTypes*.
 *
 * @param {*} parameterValue - Used in the error message as *parameterValue* and the deduced *parameterType* variables.
 * @param {string} parameterName - Used in the error message as *parameterName* variable.
 * @param {Array} expectedTypes - A list of expected (smart) typeofs.
 * @param {Object} [options]
 * @param {boolean} [options.condition] An optional condition that overrides the default logic, in which case *expectedTypes* values are completely ignored.
 * @param {String} [options.errorMessage] An optional error message that overrides the default one. Note the error message can use the following automatically set variables: parameterName, parameterValue, parameterType.
 *
 * @example
 *
 * myParam = "foo";
 * assertType(
 *   myParam,
 *   'myParam',
 *   ["number"]
 * );
 * // > TypeError: Parameter `myParam` must be a number, not string `"foo"`
 *
 * myParam = [];
 * assertType(
 *   myParam,
 *   'myParam',
 *   ["number", "string"]
 * );
 * // > TypeError: Parameter `myParam` must be a number or string, not array `[]`
 */
function assertType(
  parameterValue,
  parameterName,
  expectedTypes,
  options
) {
  var parameterType = smarterTypeof(parameterValue);

  options = options || {};
  var condition =
    options.condition || expectedTypes.indexOf(parameterType) !== -1;
  var errorMessage =
    options.errorMessage ||
    "Parameter `{parameterName}` must be a {expectedTypesMessage}, not {parameterType} `{{parameterValue}}`";

  assert(condition, errorMessage, {
    errorClass: TypeError,
    expectedTypesMessage: listFormat(expectedTypes, "or"),
    parameterName: parameterName,
    parameterType: parameterType,
    parameterValue: parameterValue
  });
}

/**
 * Throw a RangeError in case *element* isn't included in the *collection*.
 *
 * @param {*} element - The key of an Object or the element of an Array.
 * @param {(Array|Object)} collection - Where to search for element at.
 * @param {string} errorMessage - See assert().
 * @param {Object} [options] - See assert().
 *
 * @example
 * assertRange("quax", ["foo", "bar", "baz"], "Invalid element");
 * // > RangeError: Invalid element
 *
 * assertRange("quax", {"foo": 1, "bar": 2, "baz": 3}, "Invalid key");
 * // > RangeError: Invalid key
 */
function assertRange(element, collection, errorMessage, options) {
  assert(
    withinRange(element, collection),
    errorMessage,
    Object.assign({ errorClass: RangeError }, options)
  );
}

var src = /*#__PURE__*/Object.freeze({
	assert: assert,
	assertType: assertType,
	assertRange: assertRange
});

let assert$1, assertType$1;
const shouldAssert = process.env.NODE_ENV === "development";

if (shouldAssert) {
  ({ assert: assert$1, assertType: assertType$1 } = src);
}

function asyncPool(poolLimit, array, iteratorFn) {
  if (shouldAssert) {
    try {
      assertType$1(poolLimit, "poolLimit", ["number"]);
      assertType$1(array, "array", ["array"]);
      assertType$1(iteratorFn, "iteratorFn", ["function"]);
      assert$1(array.length, "Parameter `array` must have at least one item");
    } catch (error) {
      return Promise.reject(error);
    }
  }
  let i = 0;
  const ret = [];
  const executing = [];
  const enqueue = function() {
    if (i === array.length) {
      return Promise.resolve();
    }
    const item = array[i++];
    const p = Promise.resolve().then(() => iteratorFn(item, array));
    ret.push(p);
    const e = p.then(() => executing.splice(executing.indexOf(e), 1));
    executing.push(e);
    let r = Promise.resolve();
    if (executing.length >= poolLimit) {
      r = Promise.race(executing);
    }
    return r.then(() => enqueue());
  };
  return enqueue().then(() => Promise.all(ret));
}

var es6 = asyncPool;

let assert$2, assertType$2;
const shouldAssert$1 = process.env.NODE_ENV === "development";

if (shouldAssert$1) {
  ({ assert: assert$2, assertType: assertType$2 } = src);
}

async function asyncPool$1(poolLimit, array, iteratorFn) {
  if (shouldAssert$1) {
    assertType$2(poolLimit, "poolLimit", ["number"]);
    assertType$2(array, "array", ["array"]);
    assertType$2(iteratorFn, "iteratorFn", ["function"]);
    assert$2(array.length, "Parameter `array` must have at least one item");
  }
  const ret = [];
  const executing = [];
  for (const item of array) {
    const p = Promise.resolve().then(() => iteratorFn(item, array));
    ret.push(p);
    const e = p.then(() => executing.splice(executing.indexOf(e), 1));
    executing.push(e);
    if (executing.length >= poolLimit) {
      await Promise.race(executing);
    }
  }
  return Promise.all(ret);
}

var es7 = asyncPool$1;

var exports$1;


if (semver.satisfies(process.version, "<8")) {
  exports$1 = es6;
} else {
  exports$1 = es7;
}

var node = exports$1;
var default_1 = exports$1;
node.default = default_1;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$4.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty$4 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$4;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$2(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$2;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$9.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$2 = _getNative(_root, 'Promise');

var _Promise$1 = Promise$2;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise$1),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise$1 && getTag(_Promise$1.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$a.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$b.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$1;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (isObject_1(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty ? identity_1 : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = _createAssigner(function(object, source, srcIndex, customizer) {
  _baseMerge(object, source, srcIndex, customizer);
});

var mergeWith_1 = mergeWith;

var AbstractIndex = function () {
  _createClass(AbstractIndex, null, [{
    key: 'SERIALIZED_OBJECTS',

    /**
     * This allows you to hydrate a model with the related object that is serialized
     * into the API response. For instance, the key would be the name of property,
     * and the value would be the model that you want to hydrate.
     *
     * @return {object}
     */
    get: function get() {
      return {};
    }

    /** AbstractModel constructor. */

  }]);

  function AbstractIndex() {
    var _this = this;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AbstractIndex);

    if (this.constructor.name === 'AbstractModel') {
      throw new Error('An AbstractModel cannot be constructed directly.');
    }

    var tempData = isObject_1(data) ? cloneDeep_1(data) : {};

    if (_Object$keys(this.constructor.SERIALIZED_OBJECTS).length) {
      _Object$keys(this.constructor.SERIALIZED_OBJECTS).forEach(function (key) {
        if (!{}.hasOwnProperty.call(data, key)) {
          return;
        }

        if (!Array.isArray(tempData[key])) {
          tempData[key] = new _this.constructor.SERIALIZED_OBJECTS[key](tempData[key]);
          return;
        }

        if (!tempData[key].length) return;

        tempData[key].forEach(function (item, index) {
          tempData[key][index] = new _this.constructor.SERIALIZED_OBJECTS[key](item);
        });
      });
    }

    var mergedData = mergeWith_1(this.constructor.DEFAULTS, tempData, function (objValue, srcValue) {
      return isObject_1(objValue) && !isObject_1(srcValue) || Array.isArray(objValue) && !Array.isArray(srcValue) ? objValue : undefined;
    });

    _Object$assign(this, mergedData);
  }

  /** @return {Promise<any>} */


  _createClass(AbstractIndex, null, [{
    key: 'fetchAll',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _this2 = this;

        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var finalQuery, items, totalPages, queryParams, page, response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                finalQuery = _Object$assign({
                  per_page: 100
                }, query);
                items = void 0;
                _context.prev = 2;
                _context.next = 5;
                return this.search(finalQuery);

              case 5:
                items = _context.sent;
                totalPages = Math.ceil(items.total / finalQuery.per_page);

                if (!(totalPages > 1)) {
                  _context.next = 14;
                  break;
                }

                queryParams = [];


                for (page = 2; page <= totalPages; page += 1) {
                  queryParams.push(_Object$assign({ page: page }, finalQuery));
                }

                _context.next = 12;
                return node(6, queryParams, function (item) {
                  return _this2.search(item);
                });

              case 12:
                response = _context.sent;


                response.forEach(function (additionalItems) {
                  items = items.merge(additionalItems.all());
                });

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](2);
                throw new Error('Something went wrong.', _context.t0);

              case 19:
                return _context.abrupt('return', items);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 16]]);
      }));

      function fetchAll() {
        return _ref.apply(this, arguments);
      }

      return fetchAll;
    }()

    /** @return {Promise<any>} */

  }, {
    key: 'search',
    value: function search() {
      var _this3 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new _Promise(function (resolve, reject) {
        Client.get(_this3.BASE_URI(params), {
          params: params
        }).then(function (response) {
          var results = response.data.results;

          var items = collect(results.map(function (result) {
            return new _this3(cloneDeep_1(result));
          }));

          _Object$keys(response.data).forEach(function (key) {
            if (key === 'results') return;

            items[key] = response.data[key];
          });

          resolve(items);
        }).catch(function () {
          reject(new Error('Something went wrong.'));
        });
      });
    }
  }]);

  return AbstractIndex;
}();

var _validateCollection = function (it, TYPE) {
  if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

var dP$2 = _objectDp.f;









var fastKey = _meta.fastKey;

var SIZE = _descriptors ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

var _collectionStrong = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = _objectCreate(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });
    _redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = _validateCollection(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        _validateCollection(this, NAME);
        var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(_validateCollection(this, NAME), key);
      }
    });
    if (_descriptors) dP$2(C.prototype, 'size', {
      get: function () {
        return _validateCollection(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    _iterDefine(C, NAME, function (iterated, kind) {
      this._t = _validateCollection(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return _iterStep(1);
      }
      // return step by kind
      if (kind == 'keys') return _iterStep(0, entry.k);
      if (kind == 'values') return _iterStep(0, entry.v);
      return _iterStep(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    _setSpecies(NAME);
  }
};

var SPECIES$2 = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var dP$3 = _objectDp.f;
var each = _arrayMethods(0);


var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = _global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!_descriptors || typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    _redefineAll(C.prototype, methods);
    _meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      _anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) _forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) _hide(C.prototype, KEY, function (a, b) {
        _anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !_isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP$3(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  _setToStringTag(C, NAME);

  O[NAME] = C;
  _export(_export.G + _export.W + _export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

var MAP = 'Map';

// 23.1 Map Objects
var es6_map = _collection(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = _collectionStrong.getEntry(_validateCollection(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return _collectionStrong.def(_validateCollection(this, MAP), key === 0 ? 0 : key, value);
  }
}, _collectionStrong, true);

var _arrayFromIterable = function (iter, ITERATOR) {
  var result = [];
  _forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

// https://github.com/DavidBruant/Map-Set.prototype.toJSON


var _collectionToJson = function (NAME) {
  return function toJSON() {
    if (_classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return _arrayFromIterable(this);
  };
};

// https://github.com/DavidBruant/Map-Set.prototype.toJSON


_export(_export.P + _export.R, 'Map', { toJSON: _collectionToJson('Map') });

// https://tc39.github.io/proposal-setmap-offrom/


var _setCollectionOf = function (COLLECTION) {
  _export(_export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
_setCollectionOf('Map');

// https://tc39.github.io/proposal-setmap-offrom/





var _setCollectionFrom = function (COLLECTION) {
  _export(_export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    _aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) _aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = _ctx(mapFn, arguments[2], 2);
      _forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      _forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
_setCollectionFrom('Map');

var map = _core.Map;

var map$1 = createCommonjsModule(function (module) {
module.exports = { "default": map, __esModule: true };
});

var _Map$1 = unwrapExports(map$1);

var SET = 'Set';

// 23.2 Set Objects
var es6_set = _collection(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
  }
}, _collectionStrong);

// https://github.com/DavidBruant/Map-Set.prototype.toJSON


_export(_export.P + _export.R, 'Set', { toJSON: _collectionToJson('Set') });

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
_setCollectionOf('Set');

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
_setCollectionFrom('Set');

var set = _core.Set;

var set$1 = createCommonjsModule(function (module) {
module.exports = { "default": set, __esModule: true };
});

var _Set$1 = unwrapExports(set$1);

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2);
}

var isSymbol_1 = isSymbol$1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString$2;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty$c.call(object, key);
}

var _baseHas = baseHas;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && _hasPath(object, path, _baseHas);
}

var has_1 = has;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject_1(object)) {
    return object;
  }
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = _toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject_1(objValue)
          ? objValue
          : (_isIndex(path[index + 1]) ? [] : {});
      }
    }
    _assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet;

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set$2(object, path, value) {
  return object == null ? object : _baseSet(object, path, value);
}

var set_1 = set$2;

var defineProperty$5 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
});

var _defineProperty$1 = unwrapExports(defineProperty$5);

// 19.1.2.7 Object.getOwnPropertyNames(O)
_objectSap('getOwnPropertyNames', function () {
  return _objectGopnExt.f;
});

var $Object$2 = _core.Object;
var getOwnPropertyNames = function getOwnPropertyNames(it) {
  return $Object$2.getOwnPropertyNames(it);
};

var getOwnPropertyNames$1 = createCommonjsModule(function (module) {
module.exports = { "default": getOwnPropertyNames, __esModule: true };
});

var _Object$getOwnPropertyNames = unwrapExports(getOwnPropertyNames$1);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$3 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$3:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$2:
      return object.name == other.name && object.message == other.message;

    case regexpTag$3:
    case stringTag$3:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$5:
      var convert = _mapToArray;

    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$d.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    objectTag$4 = '[object Object]';

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$g.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$2 : _getTag(object),
      othTag = othIsArr ? arrayTag$2 : _getTag(other);

  objTag = objTag == argsTag$3 ? objectTag$4 : objTag;
  othTag = othTag == argsTag$3 ? objectTag$4 : othTag;

  var objIsObj = objTag == objectTag$4,
      othIsObj = othTag == objectTag$4,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$e.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$e.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return _baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

// 20.1.2.2 Number.isFinite(number)

var _isFinite = _global.isFinite;

_export(_export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

var _isFinite$1 = _core.Number.isFinite;

var _isFinite$2 = createCommonjsModule(function (module) {
module.exports = { "default": _isFinite$1, __esModule: true };
});

var _Number$isFinite = unwrapExports(_isFinite$2);

// 20.1.2.4 Number.isNaN(number)


_export(_export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

var isNan = _core.Number.isNaN;

var isNan$1 = createCommonjsModule(function (module) {
module.exports = { "default": isNan, __esModule: true };
});

var _Number$isNaN = unwrapExports(isNan$1);

/**
 * https://stackoverflow.com/a/9716488/657193
 *
 * @return {boolean}
 */
function isNumeric(n) {
  return !_Number$isNaN(parseFloat(n)) && _Number$isFinite(Number(n));
}

function isObject$1(item) {
  return item !== null && !Array.isArray(item) && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object';
}

function getCleanData(clean, key, defaultValue) {
  return isObject$1(clean) && clean[key] !== undefined ? clean[key] : defaultValue;
}

function getChangedData(clean, dirty) {
  var jsonValueKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var changedData = cloneDeep_1(dirty);
  var keys = _Object$keys(changedData);

  keys.forEach(function (key) {
    if (jsonValueKeys.includes(key)) {
      if (isEqual_1(changedData[key], clean[key])) {
        delete changedData[key];
      }

      return;
    }

    if (isObject$1(changedData[key])) {
      var cleanData = getCleanData(clean, key, {});

      changedData[key] = getChangedData(cleanData, changedData[key]);

      if (_Object$keys(changedData[key]).length === 0) {
        delete changedData[key];
      }
      return;
    }

    if (Array.isArray(changedData[key])) {
      var isArrayOfRecords = changedData[key].length > 0 && isObject$1(changedData[key][0]) || isObject$1(clean) && clean[key] !== undefined && clean[key].length > 0 && isObject$1(clean[key][0]);

      if (!isArrayOfRecords) {
        var _cleanData = getCleanData(clean, key, []);

        if (isEqual_1([].concat(_toConsumableArray(_cleanData)), [].concat(_toConsumableArray(changedData[key])))) {
          delete changedData[key];
        }
      } else {
        var indexesToRemove = [];

        indexesToRemove = [];

        changedData[key].forEach(function (record, index) {
          if (!isNumeric(record.id)) {
            return;
          }

          if (!has_1(clean, key)) {
            return;
          }

          var cleanRecord = clean[key]
          // eslint-disable-next-line no-shadow
          .find(function (cleanRecord) {
            return cleanRecord.id === record.id;
          });

          if (_Object$keys(getChangedData(cleanRecord, record)).length === 0) {
            indexesToRemove.unshift(index);
          } else {
            changedData[key][index] = getChangedData(cleanRecord, record);
          }
        });

        indexesToRemove.forEach(function (index) {
          return changedData[key].splice(index, 1);
        });

        if (changedData[key].length === 0) {
          delete changedData[key];
        }
      }
      return;
    }

    if (key === 'id' && isNumeric(dirty[key])) {
      return;
    }

    if (isObject$1(clean) && clean[key] === changedData[key]) {
      delete changedData[key];
    }
  });

  var remainingKeys = _Object$keys(changedData);

  if (remainingKeys.length === 1 && remainingKeys[0] === 'id') {
    delete changedData.id;
  }

  return changedData;
}

// @TODO: Add better rejections (currently they're very generic).

/* eslint-disable class-methods-use-this */
/* eslint prefer-promise-reject-errors: 0 */
/* eslint new-cap: ["error", { "properties": false }] */

var QueryBuilder = function () {

  /** constructor */


  /** @type {object} */
  function QueryBuilder(record) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, QueryBuilder);

    this.params = {};
    this.record = null;
    this._uriParams = new _Map$1();

    this.record = record;

    if (params) {
      this.params = params;
    }
  }

  /** @return {Promise<any>} */


  /** @type {Map} */

  /** @type {object} */


  _createClass(QueryBuilder, [{
    key: 'destroy',
    value: function destroy() {
      var _this = this;

      if (!this.record.exists()) {
        throw new Error('The record must exist in order to destroy it.');
      }

      if (!this.getSetting('DESTROYABLE')) {
        throw new Error('This record cannot be destroyed.');
      }

      var uri = this.getBaseUri();

      if (this.getSetting('PRIMARY_KEY') !== null) {
        uri = uri + '/' + this.record[this.getSetting('PRIMARY_KEY')];
      }

      return new _Promise(function (resolve, reject) {
        _this.getSetting('CLIENT').delete(uri).then(function () {
          resolve({});
        }).catch(function () {
          reject({
            error: 'Something went wrong.'
          });
        });
      });
    }

    /**
     * @return {Promise<any>}
     */

  }, {
    key: 'findById',
    value: function findById(id) {
      var _this2 = this;

      return new _Promise(function (resolve, reject) {
        _this2.getSetting('CLIENT').get(_this2.getBaseUri() + '/' + id, {
          params: _this2.params
        }).then(function (response) {
          var item = new _this2.record(cloneDeep_1(response.data));
          _this2._maybeApplyUriParamsToItem(item);

          resolve(item);
        }).catch(function () {
          reject({
            error: 'Something went wrong.'
          });
        });
      });
    }

    /** @return {Promise<any>} */

  }, {
    key: 'get',
    value: function get() {
      var _this3 = this;

      return new _Promise(function (resolve, reject) {
        _this3.getSetting('CLIENT').get(_this3.getBaseUri(), {
          params: _this3.params
        }).then(function (response) {
          var results = response.data.results;

          var items = collect(results.map(function (result) {
            var item = new _this3.record(cloneDeep_1(result));
            _this3._maybeApplyUriParamsToItem(item);

            return item;
          }));

          _Object$keys(response.data).forEach(function (key) {
            if (key === 'results') return;

            items[key] = response.data[key];
          });

          resolve(items);
        }).catch(function () {
          reject({
            error: 'Something went wrong.'
          });
        });
      });
    }

    /** @return {string} */

  }, {
    key: 'getBaseUri',
    value: function getBaseUri() {
      var _this4 = this;

      var baseUri = this.getSetting('BASE_URI');

      var rawMatches = baseUri.match(/:([a-zA-Z_]+)\/?/g);

      if (rawMatches) {
        rawMatches.forEach(function (rawMatch) {
          var key = rawMatch.replace(/\/|:/g, '');
          var param = rawMatch.replace('/', '');

          var instance = typeof _this4.record !== 'function' ? _this4.record : _this4;

          if (instance.hasUriParam(key)) {
            baseUri = baseUri.replace(param, instance.getUriParam(key));
          } else if (_this4.params[key]) {
            baseUri = baseUri.replace(param, _this4.params[key]);
          } else if (_Object$keys(_this4.getSetting('DEFAULTS')).includes(key) && _this4.record[key]) {
            baseUri = baseUri.replace(param, _this4.record[key]);
          }
        });
      }

      return baseUri;
    }

    /** @return {object} */

  }, {
    key: 'getChangedData',
    value: function getChangedData$$1() {
      return getChangedData(this.record.getClean(), this.getPreparedBodyData(), this.record.constructor.JSON_VALUE_PATHS);
    }

    /**
     * Get the prepared body data to be sent to the API.
     *
     * @return {object}
     */

  }, {
    key: 'getPreparedBodyData',
    value: function getPreparedBodyData() {
      var _this5 = this;

      var data = {};
      var recordKeys = _Object$keys(this.record).filter(function (key) {
        return !key.startsWith('_');
      });

      _Object$getOwnPropertyNames(this.record).filter(function (key) {
        return recordKeys.includes(key) && (_this5.record[key] !== null || _this5.record.isFieldNullable(key));
      }).forEach(function (key) {
        data[key] = cloneDeep_1(_this5.record[key]);
      });

      _Object$keys(this.record.getRemovedNestedItems()).forEach(function (itemPath) {
        _this5.record.getRemovedNestedItems()[itemPath].forEach(function (ids) {
          _this5._maybeAppendDestroyItemToBody(data, itemPath, ids);
        });
      });

      return data;
    }

    /** @return {mixed} */

  }, {
    key: 'getSetting',
    value: function getSetting(key) {
      return typeof this.record === 'function' ? this.record[key] : this.record.constructor[key];
    }

    /** @return {boolean} */

  }, {
    key: 'isDirty',
    value: function isDirty() {
      return this.record.exists() ? _Object$keys(this.getChangedData()).length > 0 : true;
    }

    /** @return {Promise<any>} */

  }, {
    key: 'save',
    value: function save() {
      var _this6 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var payload = void 0;

      if (data !== null) {
        payload = data;
      } else {
        payload = this.record.exists() ? this.getChangedData() : this.getPreparedBodyData();
      }

      if (!this.isDirty()) {
        return new _Promise(function (resolve) {
          return resolve(_this6.record);
        });
      }

      var method = this.record.exists() ? 'PATCH' : 'POST';

      var url = this.record.exists() && this.record.constructor.PRIMARY_KEY ? this.getBaseUri() + '/' + this.record[this.record.constructor.PRIMARY_KEY] : this.getBaseUri();

      return new _Promise(function (resolve, reject) {
        var requestConfig = { data: payload, params: _this6.params };

        if (_this6.record.constructor.WITH_CREDENTIALS) {
          requestConfig.withCredentials = true;
        }

        _this6.getSetting('CLIENT').request(method, url, requestConfig).then(function (response) {
          _this6.record.resetRemovedNestedItems();
          var responseData = cloneDeep_1(response.data);

          _this6.record.transformData(responseData);

          _Object$assign(_this6.record, responseData);
          _this6.record.updateClean();
          resolve(_this6.record);
        }).catch(function (error) {
          try {
            reject(error.response.data.errors);
          } catch (e) {
            reject([]);
          }
        });
      });
    }

    /** @return {boolean} */

  }, {
    key: 'hasUriParam',
    value: function hasUriParam(key) {
      return this._uriParams.has(key);
    }

    /** @return {any} */

  }, {
    key: 'getUriParam',
    value: function getUriParam(key) {
      return this._uriParams.get(key);
    }

    /** @return {Map} */

  }, {
    key: 'getUriParams',
    value: function getUriParams() {
      return this._uriParams;
    }

    /** @return {this} */

  }, {
    key: 'setUriParam',
    value: function setUriParam(key, value) {
      this._uriParams.set(key, value);

      return this;
    }

    /** @return {void} */

  }, {
    key: '_maybeApplyUriParamsToItem',
    value: function _maybeApplyUriParamsToItem(item) {
      var uriParams = this.getUriParams();

      if (uriParams.size === 0) {
        return;
      }

      uriParams.forEach(function (value, key) {
        return item.setUriParam(key, value);
      });
    }

    /** @return {void} */

  }, {
    key: '_maybeAppendDestroyItemToBody',
    value: function _maybeAppendDestroyItemToBody(body, itemPath, ids) {
      var primaryKey = this.record.getNestedItemPrimaryKey(itemPath);

      var currentItemPath = itemPath;
      var i = 0;

      while (currentItemPath.includes('[?]')) {
        var path = currentItemPath.match(/^(.*?)\[\?]/)[1];
        var items = get_1(body, path);

        if (!Array.isArray(items)) return;

        if (i >= ids.length - 1) {
          items.push(_defineProperty$1({
            _destroy: 1
          }, primaryKey, ids[ids.length - 1]));

          return;
        }

        var itemIndex = void 0;
        var n = void 0;

        for (n = 0; n < items.length; n += 1) {
          if (items[n][primaryKey] === ids[i]) {
            itemIndex = n;
            break;
          }
        }

        if (!itemIndex && itemIndex !== 0) return;

        currentItemPath = currentItemPath.replace('[?]', '[' + itemIndex + ']');

        i += 1;
      }
    }
  }]);

  return QueryBuilder;
}();

var AbstractModel = function () {
  _createClass(AbstractModel, null, [{
    key: 'CLIENT',

    /** @type {function} */
    get: function get() {
      return Client;
    }

    /** @type {string} */

  }, {
    key: 'DEFAULT_FETCH_ALL_SORT_BY',
    get: function get() {
      return 'name';
    }

    /** @type {string} */

  }, {
    key: 'DEFAULT_FETCH_ALL_SORT_ORDER',
    get: function get() {
      return 'asc';
    }

    /** @type {boolean} */

  }, {
    key: 'DESTROYABLE',
    get: function get() {
      return true;
    }

    /** @type {boolean} */

  }, {
    key: 'HAS_SCROLL_SUPPORT',
    get: function get() {
      return false;
    }

    /** @type {array} */

  }, {
    key: 'JSON_VALUE_PATHS',
    get: function get() {
      return [];
    }

    /** @type {number} */

  }, {
    key: 'PER_PAGE_MAX',
    get: function get() {
      return 100;
    }

    /**
     * This allows you to mirror the payload that the API expects by converting a serialized
     * collection of items down to an array of id's.
     *
     * @type {object}
     */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {};
    }

    /** @type {string|null} */

  }, {
    key: 'PRIMARY_KEY',
    get: function get() {
      return 'id';
    }

    /**
     * This can be overridden to represent a list of nested attributes that
     * have a primary field, including the singular and plural version of it.
     *
     * @type {object}
     */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {};
    }

    /**
     * The API will sometimes return a serialized object (e.g. user), instead of the id
     * (e.g. user_id). This becomes problematic because now the response is different from
     * what the API expects in the request.
     *
     * @type {object}
     */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {};
    }

    /**
     * This allows you to hydrate a model with the related object that is serialized
     * into the API response. For instance, the key would be the name of property,
     * and the value would be the model that you want to hydrate.
     *
     * @type {object}
     */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {};
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {};
    }

    /** @type {boolean} */

  }, {
    key: 'WITH_CREDENTIALS',
    get: function get() {
      return false;
    }

    /** @type {null|object} */


    /** @type {Set} */


    /**
     * Keep track of attributes that have been removed, so that they can be destroyed
     * on the next save.
     *
     * @type {object}
     */


    /** @type {Map} */

  }]);

  /** AbstractModel constructor. */
  function AbstractModel() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AbstractModel);

    this._clean = null;
    this._nullableFields = new _Set$1();
    this._removedNestedItems = {};
    this._uriParams = new _Map$1();

    if (this.constructor.name === 'AbstractModel') {
      throw new Error('An AbstractModel cannot be constructed directly.');
    }

    var localData = isObject_1(data) ? cloneDeep_1(data) : {};

    this.transformData(localData);

    var mergedData = mergeWith_1(this.constructor.DEFAULTS, localData, function (objValue, srcValue) {
      return isObject_1(objValue) && !isObject_1(srcValue) || Array.isArray(objValue) && !Array.isArray(srcValue) ? objValue : undefined;
    });

    _Object$assign(this, mergedData);

    this.updateClean();
  }

  /**
   * This allows you to explicitly whitelist a field to be set as null. This is
   * currently required, as any value set to null will be filtered out on save,
   * as there is no way to determine if that was the true intention, as it could
   * be a default, instead something on the actual record.
   *
   * @return {this}
   */


  _createClass(AbstractModel, [{
    key: 'addNullableField',
    value: function addNullableField(fieldName) {
      this._nullableFields.add(fieldName);

      return this;
    }

    /** @return {Promise<any>} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.query().destroy();
    }

    /** @return void */

  }, {
    key: 'destroyNestedItemById',
    value: function destroyNestedItemById(itemPath, ids) {
      if (!Array.isArray(this._removedNestedItems[itemPath])) {
        this._removedNestedItems[itemPath] = [];
      }

      this._removedNestedItems[itemPath].push(ids);
    }

    /** @return {boolean} */

  }, {
    key: 'exists',
    value: function exists() {
      if (!this.constructor.PRIMARY_KEY) {
        return true;
      }

      return !!this[this.constructor.PRIMARY_KEY];
    }

    /** @return {Promise<any>} */

  }, {
    key: 'getMeta',


    /** @return {object|undefined} */
    value: function getMeta(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      return this.meta.find(function (item) {
        return item.key === key;
      }) || defaultValue;
    }

    /** @return {string} */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'getNestedItemPrimaryKey',
    value: function getNestedItemPrimaryKey() {
      return 'id';
    }

    /** @return {object|undefined} */

  }, {
    key: 'getPrimary',
    value: function getPrimary(attribute) {
      var map = this.constructor.PRIMARY_MAP;

      if (!_Object$keys(map).length || !_Object$keys(map).includes(attribute)) {
        return undefined;
      }

      var primary = this[map[attribute]].find(function (item) {
        return !!item.primary;
      });

      return typeof primary !== 'undefined' ? primary : undefined;
    }

    /** @return {object} */

  }, {
    key: 'getRemovedNestedItems',
    value: function getRemovedNestedItems() {
      return this._removedNestedItems;
    }

    /** @return {boolean} */

  }, {
    key: 'hasMeta',
    value: function hasMeta(key) {
      return !!this.getMeta(key);
    }

    /** @return {boolean} */

  }, {
    key: 'hasPrimary',
    value: function hasPrimary(attribute) {
      return !!this.getPrimary(attribute);
    }

    /** @return {boolean} */

  }, {
    key: 'isFieldNullable',
    value: function isFieldNullable(fieldName) {
      return this._nullableFields.has(fieldName);
    }

    /** @return {QueryBuilder} */

  }, {
    key: 'query',


    /** @return {QueryBuilder} */
    value: function query() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new QueryBuilder(this, params);
    }

    /** @return {this} */

  }, {
    key: 'removeMeta',
    value: function removeMeta(key) {
      var index = this.meta.findIndex(function (item) {
        return item.key === key;
      });

      if (index === -1) {
        return this;
      }

      this.removeNestedItem('meta[' + index + ']');

      return this;
    }

    /**
     * Remove a nested item from this record (based on its index). This is
     * required because of the way you must remove these items via the API.
     *
     * Example Usage:
     * - removeNestedItem('pets[?].photos[?]', [0, 1])
     * - removeNestedItem('pets[0].photos[1]')
     *
     * @return {void}
     */

  }, {
    key: 'removeNestedItem',
    value: function removeNestedItem(nestedItemPath, indexes) {
      var nestedItemPathWithIndexes = nestedItemPath;

      if (Array.isArray(indexes) && indexes.length) {
        indexes.forEach(function (index) {
          nestedItemPathWithIndexes = nestedItemPathWithIndexes.replace('?', index);
        });
      }

      var item = get_1(this, nestedItemPathWithIndexes);
      var primaryKey = this.getNestedItemPrimaryKey(nestedItemPath);
      var indexList = nestedItemPathWithIndexes.match(/\[\d+]/g).map(function (match) {
        return Number(match.replace('[', '').replace(']', ''));
      });

      var nestedCollectionPath = nestedItemPathWithIndexes.replace(/(\[\d+])$/, '');

      if (item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item[primaryKey]) {
        var nestedCollectionPathWithIds = nestedCollectionPath.replace(/(\[\d+])/g, '[?]');

        var i = 0;

        while (nestedCollectionPathWithIds.includes('[?]')) {
          var path = nestedCollectionPathWithIds.match(/^(.*?)\[\?]/)[1];
          nestedCollectionPathWithIds = nestedCollectionPathWithIds.replace('[?]', '[' + get_1(this, path)[indexList[i]][primaryKey] + ']');

          i += 1;
        }

        var nestedItemPathWithIds = nestedCollectionPathWithIds + '[' + get_1(this, nestedItemPathWithIndexes)[primaryKey] + ']';
        var idList = nestedItemPathWithIds.match(/\[\d+]/g).map(function (match) {
          return Number(match.replace('[', '').replace(']', ''));
        });

        this.destroyNestedItemById(nestedItemPathWithIds.replace(/(\[\d+])/g, '[?]'), idList);
      }

      get_1(this, nestedCollectionPath).splice(indexList[indexList.length - 1], 1);
    }

    /** @return {this} */

  }, {
    key: 'removeNullableField',
    value: function removeNullableField(fieldName) {
      this._nullableFields.delete(fieldName);

      return this;
    }

    /** @return {object} */

  }, {
    key: 'resetRemovedNestedItems',
    value: function resetRemovedNestedItems() {
      this._removedNestedItems = {};
    }

    /** @return {Promise<any>} */

  }, {
    key: 'save',
    value: function save() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return this.query().save(data);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'setMeta',


    /** @return {this} */
    value: function setMeta(key, value) {
      if (this.hasMeta(key)) {
        var item = this.getMeta(key);
        item.value = value;
      } else {
        this.meta.push({
          key: key,
          value: value
        });
      }

      return this;
    }

    /** @return {void} */

  }, {
    key: 'transformData',
    value: function transformData(data) {
      var _this = this;

      if (_Object$keys(this.constructor.SERIALIZED_OBJECTS).length) {
        var container = Container.getInstance();

        _Object$keys(this.constructor.SERIALIZED_OBJECTS).forEach(function (key) {
          if (!has_1(data, key)) {
            return;
          }

          var value = get_1(data, key);

          if (!Array.isArray(value)) {
            set_1(data, key, container.resolve(_this.constructor.SERIALIZED_OBJECTS[key], [value]));
            return;
          }

          if (!value.length) return;

          value.forEach(function (item, index) {
            value[index] = container.resolve(_this.constructor.SERIALIZED_OBJECTS[key], [item]);
          });
        });
      }

      if (_Object$keys(this.constructor.SERIALIZE_IDS).length > 0) {
        _Object$keys(this.constructor.SERIALIZE_IDS).forEach(function (objectPath) {
          var idKey = _this.constructor.SERIALIZE_IDS[objectPath];

          if ({}.hasOwnProperty.call(data, idKey)) {
            return;
          }

          var object = get_1(data, objectPath);

          // eslint-disable-next-line no-param-reassign
          data[idKey] = isObject_1(object) && {}.hasOwnProperty.call(object, 'id') ? object.id : null;
        });
      }

      _Object$keys(this.constructor.PLUCK_IDS).forEach(function (key) {
        var value = get_1(data, key);

        if (!Array.isArray(value)) {
          return;
        }

        set_1(data, _this.constructor.PLUCK_IDS[key], collect(value).pluck('id').all());
      });

      _Object$keys(data).forEach(function (key) {
        if (!key.startsWith('_')) {
          return;
        }

        // eslint-disable-next-line no-param-reassign
        delete data[key];
      });
    }

    /** @return {boolean} */

  }, {
    key: 'hasUriParam',
    value: function hasUriParam(key) {
      return this._uriParams.has(key);
    }

    /** @return {object} */

  }, {
    key: 'getClean',
    value: function getClean() {
      return this._clean;
    }

    /** @return {any} */

  }, {
    key: 'getUriParam',
    value: function getUriParam(key) {
      return this._uriParams.get(key);
    }

    /** @return {Map} */

  }, {
    key: 'getUriParams',
    value: function getUriParams() {
      return this._uriParams;
    }

    /** @return {this} */

  }, {
    key: 'setUriParam',
    value: function setUriParam(key, value) {
      this._uriParams.set(key, value);

      return this;
    }

    /** @return {this} */

  }, {
    key: 'updateClean',
    value: function updateClean() {
      this._clean = this.query().getPreparedBodyData();

      return this;
    }
  }], [{
    key: 'fetchAll',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _this2 = this;

        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var finalQueryParams, items, query, scrollId, totalPages, queryParamSet, page, response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                finalQueryParams = _Object$assign({
                  per_page: this.PER_PAGE_MAX,
                  sort_by: this.DEFAULT_FETCH_ALL_SORT_BY,
                  sort_order: this.DEFAULT_FETCH_ALL_SORT_ORDER
                }, params);


                if (this.HAS_SCROLL_SUPPORT) {
                  finalQueryParams.scroll = 1;
                }

                items = void 0;
                _context.prev = 3;
                query = this.query(finalQueryParams);


                if (options.uriParams) {
                  _Object$keys(options.uriParams).forEach(function (key) {
                    query.setUriParam(key, options.uriParams[key]);
                  });
                }

                _context.next = 8;
                return query.get();

              case 8:
                items = _context.sent;
                scrollId = this.HAS_SCROLL_SUPPORT ? items.meta.scroll_id : null;
                totalPages = Math.ceil(items.total / finalQueryParams.per_page);

                if (!(totalPages > 1)) {
                  _context.next = 18;
                  break;
                }

                queryParamSet = [];


                for (page = 2; page <= totalPages; page += 1) {
                  if (scrollId) {
                    queryParamSet.push({ scroll_id: scrollId });
                  } else {
                    queryParamSet.push(_Object$assign({}, finalQueryParams, { page: page }));
                  }
                }

                _context.next = 16;
                return node(scrollId ? 1 : 6, queryParamSet, function (queryParams) {
                  var pageQuery = _this2.query(queryParams);

                  if (options.uriParams) {
                    _Object$keys(options.uriParams).forEach(function (key) {
                      pageQuery.setUriParam(key, options.uriParams[key]);
                    });
                  }

                  return pageQuery.get();
                });

              case 16:
                response = _context.sent;


                response.forEach(function (additionalItems) {
                  items = items.merge(additionalItems.all());
                });

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](3);
                throw new Error('Something went wrong.', _context.t0);

              case 23:
                return _context.abrupt('return', items);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 20]]);
      }));

      function fetchAll() {
        return _ref.apply(this, arguments);
      }

      return fetchAll;
    }()

    /** @return {Promise<any>} */

  }, {
    key: 'findById',
    value: function findById(id) {
      return this.query().findById(id);
    }
  }, {
    key: 'query',
    value: function query() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new QueryBuilder(this, params);
    }
  }, {
    key: 'search',
    value: function search() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.query(params).get();
    }
  }]);

  return AbstractModel;
}();

var ContactActivityIndex = function (_AbstractIndex) {
  _inherits(ContactActivityIndex, _AbstractIndex);

  function ContactActivityIndex() {
    _classCallCheck(this, ContactActivityIndex);

    return _possibleConstructorReturn(this, (ContactActivityIndex.__proto__ || _Object$getPrototypeOf(ContactActivityIndex)).apply(this, arguments));
  }

  _createClass(ContactActivityIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return 'contacts/' + params.contact_id + '/activities';
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        created_after: {
          type: Date
        },
        created_before: {
          type: Date
        },
        type: {
          type: String
        }
      };
    }
  }]);

  return ContactActivityIndex;
}(AbstractIndex);

var ContactCustomActivity = function (_AbstractModel) {
  _inherits(ContactCustomActivity, _AbstractModel);

  function ContactCustomActivity() {
    _classCallCheck(this, ContactCustomActivity);

    return _possibleConstructorReturn(this, (ContactCustomActivity.__proto__ || _Object$getPrototypeOf(ContactCustomActivity)).apply(this, arguments));
  }

  _createClass(ContactCustomActivity, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/custom_activities';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        contact_id: null,
        description: null,
        title: null,
        type: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return ContactCustomActivity;
}(AbstractModel);

var ContactEmailIndex = function (_AbstractIndex) {
  _inherits(ContactEmailIndex, _AbstractIndex);

  function ContactEmailIndex() {
    _classCallCheck(this, ContactEmailIndex);

    return _possibleConstructorReturn(this, (ContactEmailIndex.__proto__ || _Object$getPrototypeOf(ContactEmailIndex)).apply(this, arguments));
  }

  _createClass(ContactEmailIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return 'contacts/' + params.contact_id + '/emails';
    }
  }]);

  return ContactEmailIndex;
}(AbstractIndex);

var MlsOffice = function (_AbstractModel) {
  _inherits(MlsOffice, _AbstractModel);

  function MlsOffice() {
    _classCallCheck(this, MlsOffice);

    return _possibleConstructorReturn(this, (MlsOffice.__proto__ || _Object$getPrototypeOf(MlsOffice)).apply(this, arguments));
  }

  _createClass(MlsOffice, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/mls_offices';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        franchise_affiliation: null,
        idx_office_participation_y_n: null,
        main_office_key: null,
        media: [],
        office_address1: null,
        office_address2: null,
        office_aor: null,
        office_aor_key: null,
        office_aor_mls_id: null,
        office_association_comments: null,
        office_branch_type: null,
        office_city: null,
        office_corporate_license: null,
        office_county_or_parish: null,
        office_email: null,
        office_fax: null,
        office_manager_key: null,
        office_manager_mls_id: null,
        office_name: null,
        office_national_association_id: null,
        office_phone: null,
        office_phone_ext: null,
        office_postal_code: null,
        office_postal_code_plus4: null,
        office_state_or_province: null,
        office_status: null,
        office_type: null,
        original_system_id: null,
        originating_system_name: null,
        originating_system_office_key: null,
        social_media: [],
        source_system_id: null,
        source_system_name: null,
        source_system_office_key: null,
        syndicate_agent_options: null,
        syndicate_to: null
      };
    }
  }]);

  return MlsOffice;
}(AbstractModel);

var Region = function (_AbstractModel) {
  _inherits(Region, _AbstractModel);

  function Region() {
    _classCallCheck(this, Region);

    return _possibleConstructorReturn(this, (Region.__proto__ || _Object$getPrototypeOf(Region)).apply(this, arguments));
  }

  _createClass(Region, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/regions';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return Region;
}(AbstractModel);

var Office = function (_AbstractModel) {
  _inherits(Office, _AbstractModel);

  function Office() {
    _classCallCheck(this, Office);

    return _possibleConstructorReturn(this, (Office.__proto__ || _Object$getPrototypeOf(Office)).apply(this, arguments));
  }

  _createClass(Office, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/offices';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        addresses: [],
        biography: null,
        created_at: null,
        custom_identifiers: [],
        email: null,
        id: null,
        latitude: null,
        license_number: null,
        longitude: null,
        manager_user_ids: [],
        mls_ids: [],
        name: null,
        office: Container.getInstance().resolve(MlsOffice),
        phone_numbers: [],
        photos: [],
        region: Container.getInstance().resolve(Region),
        region_id: null,
        updated_at: null,
        urls: []
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        address: 'addresses',
        phone_number: 'phone_numbers',
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        region: 'region_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        office: MlsOffice,
        region: Region
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        city: {
          type: String
        },
        email: {
          type: String
        },
        name: {
          type: String
        },
        office_key: {
          type: String
        },
        phone_number: {
          type: String
        },
        region_id: {
          commaSeparatedSupport: true,
          model: Region,
          type: Number
        },
        zip: {
          type: String
        }
      };
    }
  }]);

  return Office;
}(AbstractModel);

var AbstractPolicy = function () {
  function AbstractPolicy(user) {
    var record = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var related = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, AbstractPolicy);

    this.record = record;
    this.user = user;
    this.related = related;
  }

  /** @return {boolean} */


  _createClass(AbstractPolicy, [{
    key: '_isAssignedToUser',
    value: function _isAssignedToUser(model, userIdPath) {
      if (!(this.record instanceof model)) {
        return true;
      }

      var recordUserId = get_1(this.record, userIdPath);

      return this.user.id === recordUserId;
    }
  }]);

  return AbstractPolicy;
}();

var EmailFooter = function (_AbstractModel) {
  _inherits(EmailFooter, _AbstractModel);

  function EmailFooter() {
    _classCallCheck(this, EmailFooter);

    return _possibleConstructorReturn(this, (EmailFooter.__proto__ || _Object$getPrototypeOf(EmailFooter)).apply(this, arguments));
  }

  _createClass(EmailFooter, null, [{
    key: 'BASE_URI',

    /** @var {string} */
    get: function get() {
      return '/emails/footers';
    }

    /** @return {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null,
        body: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return EmailFooter;
}(AbstractModel);

var EmailHeader = function (_AbstractModel) {
  _inherits(EmailHeader, _AbstractModel);

  function EmailHeader() {
    _classCallCheck(this, EmailHeader);

    return _possibleConstructorReturn(this, (EmailHeader.__proto__ || _Object$getPrototypeOf(EmailHeader)).apply(this, arguments));
  }

  _createClass(EmailHeader, null, [{
    key: 'BASE_URI',

    /** @var {string} */
    get: function get() {
      return '/emails/headers';
    }

    /** @return {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null,
        body: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return EmailHeader;
}(AbstractModel);

/** @return {boolean} */
function isEmptyString(value) {
  if (value === null || value === undefined) {
    return true;
  }

  if (isNumeric(value)) {
    return false;
  }

  if (typeof value !== 'string') {
    return true;
  }

  return value.trim() === '';
}

var PropertyMarketingHistory = function (_AbstractModel) {
  _inherits(PropertyMarketingHistory, _AbstractModel);

  function PropertyMarketingHistory() {
    _classCallCheck(this, PropertyMarketingHistory);

    return _possibleConstructorReturn(this, (PropertyMarketingHistory.__proto__ || _Object$getPrototypeOf(PropertyMarketingHistory)).apply(this, arguments));
  }

  _createClass(PropertyMarketingHistory, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/properties/:property_id/marketing_histories';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        category: null,
        cost: null,
        logo_url: null,
        name: null,
        preview_url: null,
        property_id: null,
        stats: null,
        user_id: null
      };
    }
  }]);

  return PropertyMarketingHistory;
}(AbstractModel);

var PropertyNote = function (_AbstractModel) {
  _inherits(PropertyNote, _AbstractModel);

  function PropertyNote() {
    _classCallCheck(this, PropertyNote);

    return _possibleConstructorReturn(this, (PropertyNote.__proto__ || _Object$getPrototypeOf(PropertyNote)).apply(this, arguments));
  }

  _createClass(PropertyNote, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/properties/:property_id/notes';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        property_id: null,
        contact: Container.getInstance().resolve(Contact),
        contact_id: null,
        user: Container.getInstance().resolve(User),
        user_id: null,
        body: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        contact: 'contact_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        contact: Contact,
        user: User
      };
    }
  }]);

  return PropertyNote;
}(AbstractModel);

var PropertySuggestionIndex = function (_AbstractIndex) {
  _inherits(PropertySuggestionIndex, _AbstractIndex);

  function PropertySuggestionIndex() {
    _classCallCheck(this, PropertySuggestionIndex);

    return _possibleConstructorReturn(this, (PropertySuggestionIndex.__proto__ || _Object$getPrototypeOf(PropertySuggestionIndex)).apply(this, arguments));
  }

  _createClass(PropertySuggestionIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      return 'properties/suggestions';
    }
  }]);

  return PropertySuggestionIndex;
}(AbstractIndex);

var PropertyTransaction = function (_AbstractModel) {
  _inherits(PropertyTransaction, _AbstractModel);

  function PropertyTransaction() {
    _classCallCheck(this, PropertyTransaction);

    return _possibleConstructorReturn(this, (PropertyTransaction.__proto__ || _Object$getPrototypeOf(PropertyTransaction)).apply(this, arguments));
  }

  _createClass(PropertyTransaction, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/properties/:property_id/transactions';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        contact: Container.getInstance().resolve(Contact),
        contact_id: null,
        created_at: null,
        id: null,
        property_id: null,
        type: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        contact: 'contact_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        contact: Contact
      };
    }
  }]);

  return PropertyTransaction;
}(AbstractModel);

var Property = function (_AbstractModel) {
  _inherits(Property, _AbstractModel);

  function Property() {
    _classCallCheck(this, Property);

    return _possibleConstructorReturn(this, (Property.__proto__ || _Object$getPrototypeOf(Property)).apply(this, arguments));
  }

  _createClass(Property, [{
    key: 'getAddress',


    /** @return {string} */
    value: function getAddress() {
      var _this2 = this;

      var items = ['street_number', 'street_dir_prefix', 'street_name', 'street_suffix', 'street_dir_suffix', 'unit_number'];

      var address = '';

      items.forEach(function (key) {
        if (!_this2.location.address || !_this2.location.address[key]) {
          return;
        }

        var appendedValue = _this2.location.address[key];

        appendedValue = key === 'unit_number' ? ', #' + appendedValue : ' ' + appendedValue;

        address = ('' + address + appendedValue).trim();
      });

      return address;
    }

    /** @return {string} */

  }, {
    key: 'getAddressSecondary',
    value: function getAddressSecondary() {
      var _this3 = this;

      var items = ['city', 'state_or_province', 'postal_code'];

      var address = '';

      items.forEach(function (key) {
        if (!_this3.location.address || !_this3.location.address[key]) {
          return;
        }

        var appendedValue = _this3.location.address[key];

        appendedValue = key === 'city' ? appendedValue + ',' : ' ' + appendedValue;

        address = ('' + address + appendedValue).trim();
      });

      return address;
    }

    /** @return {boolean} */

  }, {
    key: 'hasModifiedVersion',
    value: function hasModifiedVersion() {
      return !isEmptyString(this.user_property_id);
    }

    /** @return {boolean} */

  }, {
    key: 'isFromRets',
    value: function isFromRets() {
      return this.source === 'RETS' && isEmptyString(this.property_id);
    }

    /** @return {boolean} */

  }, {
    key: 'isFromUser',
    value: function isFromUser() {
      return !isEmptyString(this.user_id);
    }

    /** @return {boolean} */

  }, {
    key: 'isModifiedVersion',
    value: function isModifiedVersion() {
      return !isEmptyString(this.property_id);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'marketingHistories',
    value: function marketingHistories() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return PropertyMarketingHistory.query(_Object$assign({ property_id: this.id }, args)).get();
    }

    /** @return {Promise<any>} */

  }, {
    key: 'notes',
    value: function notes() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return PropertyNote.query(_Object$assign({ property_id: this.id }, args)).get();
    }

    /** @return {Promise<any>} */

  }, {
    key: 'transactions',
    value: function transactions() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return PropertyTransaction.query(_Object$assign({ property_id: this.id }, args)).get();
    }
  }], [{
    key: 'suggestions',


    /** @return {function} */
    value: function suggestions() {
      return PropertySuggestionIndex;
    }
  }, {
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/properties';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        board: {},
        board_id: null,
        custom_fields: {},
        dash_deactivated_at: null,
        dash_guid: null,
        hide_photos: false,
        property_type: null,
        property_sub_type: null,
        property_universal_id: null,
        source: null,
        private: false,
        property_id: null,
        user_id: null,
        user_property_id: null,
        location: {
          address: {},
          area: {},
          gis: {},
          school: {}
        },
        business: {},
        characteristics: {},
        equipment: {},
        farming: {},
        financial: {},
        hoa: {},
        listing: {
          agent_office: {
            buyer_agent: {},
            buyer_office: {},
            co_buyer_agent: {},
            co_buyer_agent2: {},
            co_buyer_agent3: {},
            co_buyer_agent4: {},
            co_buyer_agent5: {},
            co_buyer_office: {},
            co_list_agent: {},
            co_list_agent2: {},
            co_list_agent3: {},
            co_list_agent4: {},
            co_list_agent5: {},
            co_list_office: {},
            co_relocation_agent: {},
            co_relocation_agent2: {},
            co_relocation_agent3: {},
            co_relocation_agent4: {},
            co_relocation_agent5: {},
            co_showing_agent: {},
            co_showing_agent2: {},
            co_showing_agent3: {},
            co_showing_agent4: {},
            co_showing_agent5: {},
            list_agent: {},
            list_office: {},
            relocation_agent: {},
            showing_agent: {},
            team: {}
          },
          closing: {},
          compensation: {},
          contract: {},
          dates: {},
          marketing: {},
          media: {},
          price: {},
          remarks: {},
          showing: {}
        },
        media: [],
        occupant_owner: {},
        open_houses: [],
        structure: {
          performance: {
            green_marketing: {}
          }
        },
        tax: {},
        user_properties: [],
        utility: {},
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        accessibility_features: {
          type: String
        },
        agent_user_id: {
          model: User,
          type: Number
        },
        architectural_style: {
          commaSeparatedSupport: true,
          type: String
        },
        association_y_n: {
          type: Boolean
        },
        attached_garage_y_n: {
          type: Boolean
        },
        board_id: {
          type: String
        },
        building_features: {
          commaSeparatedSupport: true,
          type: String
        },
        building_name: {
          type: String
        },
        buyer_agent_mls_id: {
          type: String
        },
        city: {
          commaSeparatedSupport: true,
          type: String
        },
        close_date_after: {
          type: Date
        },
        close_date_before: {
          type: Date
        },
        close_date_since: {
          type: Number
        },
        combo_search: {
          type: String
        },
        country: {
          type: String
        },
        county_or_parish: {
          commaSeparatedSupport: true,
          type: String
        },
        created_after: {
          type: Date
        },
        created_before: {
          type: Date
        },
        created_since: {
          type: Number
        },
        direction_faces: {
          commaSeparatedSupport: true,
          type: String
        },
        elementary_school: {
          type: String
        },
        foreclosure_y_n: {
          type: Boolean
        },
        furnished_y_n: {
          type: Boolean
        },
        geo_polygon: {
          type: String
        },
        high_school: {
          type: String
        },
        internet_entire_listing_display_y_n: {
          type: Boolean
        },
        list_agent_mls_id: {
          type: String
        },
        listing_agent_user_id: {
          model: User,
          type: Number
        },
        list_office_mls_id: {
          type: String
        },
        list_price_changed_after: {
          type: Date
        },
        list_price_changed_before: {
          type: Date
        },
        list_price_changed_since: {
          type: Number
        },
        list_price_change_created_after: {
          type: Date
        },
        list_price_change_created_before: {
          type: Date
        },
        list_price_change_created_since: {
          type: Number
        },
        listing_id: {
          commaSeparatedSupport: true,
          type: String
        },
        listing_type: {
          commaSeparatedSupport: true,
          type: String
        },
        max_association_fee: {
          type: Number
        },
        max_bathrooms_full: {
          type: Number
        },
        max_bathrooms_total_integer: {
          type: Number
        },
        max_bedrooms_total: {
          type: Number
        },
        max_close_price: {
          type: Number
        },
        max_close_price_per_living_area: {
          type: Number
        },
        max_garage_spaces: {
          type: Number
        },
        max_list_price: {
          type: Number
        },
        max_list_price_per_living_area: {
          type: Number
        },
        max_living_area: {
          type: Number
        },
        max_lot_size_acres: {
          type: Number
        },
        max_lot_size_square_feet: {
          type: Number
        },
        max_number_of_units_total: {
          type: Number
        },
        max_photos_count: {
          type: Number
        },
        max_stories: {
          type: Number
        },
        max_stories_total: {
          type: Number
        },
        max_year_built: {
          type: Number
        },
        middle_or_junior_school: {
          type: String
        },
        min_association_fee: {
          type: Number
        },
        min_bathrooms_full: {
          type: Number
        },
        min_bathrooms_total_integer: {
          type: Number
        },
        min_bedrooms_total: {
          type: Number
        },
        min_close_price: {
          type: Number
        },
        min_close_price_per_living_area: {
          type: Number
        },
        min_garage_spaces: {
          type: Number
        },
        min_list_price: {
          type: Number
        },
        min_list_price_per_living_area: {
          type: Number
        },
        min_living_area: {
          type: Number
        },
        min_lot_size_acres: {
          type: Number
        },
        min_lot_size_square_feet: {
          type: Number
        },
        min_number_of_units_total: {
          type: Number
        },
        min_photos_count: {
          type: Number
        },
        min_stories: {
          type: Number
        },
        min_stories_total: {
          type: Number
        },
        min_year_built: {
          type: Number
        },
        mls_area_major: {
          commaSeparatedSupport: true,
          type: String
        },
        mls_area_minor: {
          commaSeparatedSupport: true,
          type: String
        },
        mls_status: {
          commaSeparatedSupport: true,
          type: String
        },
        mls_status_changed_after: {
          type: Date
        },
        mls_status_changed_before: {
          type: Date
        },
        mls_status_changed_since: {
          type: Number
        },
        mls_status_change_created_after: {
          type: Date
        },
        mls_status_change_created_before: {
          type: Date
        },
        mls_status_change_created_since: {
          type: Number
        },
        new_construction_y_n: {
          type: Boolean
        },
        on_market_date_after: {
          type: Date
        },
        on_market_date_before: {
          type: Date
        },
        on_market_date_since: {
          type: Number
        },
        open_house_end_time_after: {
          type: Date
        },
        open_house_end_time_before: {
          type: Date
        },
        open_house_end_time_within: {
          type: Number
        },
        open_house_method: {
          commaSeparatedSupport: true,
          type: String
        },
        open_house_type: {
          commaSeparatedSupport: true,
          type: String
        },
        parcel_number: {
          type: String
        },
        pool_private_y_n: {
          type: Boolean
        },
        postal_code: {
          commaSeparatedSupport: true,
          type: String
        },
        price_reduced_after: {
          type: Date
        },
        price_reduced_before: {
          type: Date
        },
        price_reduced_since: {
          type: Number
        },
        price_reduction_created_after: {
          type: Date
        },
        price_reduction_created_before: {
          type: Date
        },
        price_reduction_created_since: {
          type: Number
        },
        primary_on_main_y_n: {
          type: Boolean
        },
        property_sub_type: {
          commaSeparatedSupport: true,
          type: String
        },
        property_type: {
          commaSeparatedSupport: true,
          type: String
        },
        public_remarks: {
          type: String
        },
        publication_remarks_approved_y_n: {
          type: Boolean
        },
        school: {
          type: String
        },
        school_district: {
          type: String
        },
        senior_community_y_n: {
          type: Boolean
        },
        short_sale_y_n: {
          type: Boolean
        },
        single_property_website_y_n: {
          type: Boolean
        },
        source: {
          commaSeparatedSupport: true,
          type: String
        },
        state_or_province: {
          type: String
        },
        street_address: {
          type: String
        },
        subdivision_name: {
          commaSeparatedSupport: true,
          type: String
        },
        syndicate_y_n: {
          type: Boolean
        },
        updated_after: {
          type: Date
        },
        updated_before: {
          type: Date
        },
        updated_since: {
          type: Number
        },
        view: {
          commaSeparatedSupport: true,
          type: String
        },
        view_y_n: {
          type: Boolean
        },
        virtual_tour_y_n: {
          type: Boolean
        },
        visibility: {
          commaSeparatedSupport: true,
          type: String
        },
        waterfront_y_n: {
          type: Boolean
        },
        zoning_description: {
          type: String
        }
      };
    }
  }]);

  return Property;
}(AbstractModel);

var Blast = function (_AbstractModel) {
  _inherits(Blast, _AbstractModel);

  function Blast() {
    _classCallCheck(this, Blast);

    return _possibleConstructorReturn(this, (Blast.__proto__ || _Object$getPrototypeOf(Blast)).apply(this, arguments));
  }

  _createClass(Blast, [{
    key: 'stats',


    /** @return {object} */
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Client.get(this.constructor.BASE_URI + '/' + this.id + '/emails');

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stats() {
        return _ref.apply(this, arguments);
      }

      return stats;
    }()

    /** @return {Promise<any>} */

  }, {
    key: 'subscribe',
    value: function subscribe(contactIds) {
      return Client.post(this.constructor.BASE_URI + '/' + this.id + '/subscribe', {
        data: {
          contact_ids: contactIds
        }
      });
    }

    /** @return {Promise<any>} */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe(contactIds) {
      return Client.post(this.constructor.BASE_URI + '/' + this.id + '/unsubscribe', {
        data: {
          contact_ids: contactIds
        }
      });
    }
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/blasts';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        autosubscribe_rule: {
          enabled: null,
          query_string: null
        },
        body: null,
        body_source: null,
        created_at: null,
        email_footer: Container.getInstance().resolve(EmailFooter),
        email_footer_id: null,
        email_header: Container.getInstance().resolve(EmailHeader),
        email_header_id: null,
        format: null,
        id: null,
        meta: [],
        name: null,
        photos: [],
        properties: [],
        property_ids: [],
        send_at: null,
        sent_at: null,
        sender_email: null,
        sender_name: null,
        subject: null,
        subscribers_total: null,
        template: null,
        updated_at: null,
        user: {},
        user_id: null
      };
    }

    /** @var {object} */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {
        properties: 'property_ids'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        email_footer: 'email_footer_id',
        email_header: 'email_header_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        email_footer: EmailFooter,
        email_header: EmailHeader,
        properties: Property,
        user: User
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        created_after: {
          type: Date
        },
        created_before: {
          type: Date
        },
        created_since: {
          type: Number
        },
        has_sent: {
          type: Boolean
        },
        name: {
          type: String
        },
        property_id: {
          commaSeparatedSupport: true,
          model: Property,
          type: Number
        },
        send_after: {
          type: Date
        },
        send_before: {
          type: Date
        },
        send_within: {
          type: Number
        },
        sent_after: {
          type: Date
        },
        sent_before: {
          type: Date
        },
        sent_since: {
          type: Number
        },
        user_id: {
          commaSeparatedSupport: true,
          model: User,
          type: Number
        }
      };
    }
  }]);

  return Blast;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var BlastPolicy = function (_AbstractPolicy) {
  _inherits(BlastPolicy, _AbstractPolicy);

  function BlastPolicy() {
    _classCallCheck(this, BlastPolicy);

    return _possibleConstructorReturn(this, (BlastPolicy.__proto__ || _Object$getPrototypeOf(BlastPolicy)).apply(this, arguments));
  }

  _createClass(BlastPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || !this.record || !this.record.user_id || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      if (this._hasSent()) {
        return false;
      }

      return ['admin', 'super'].includes(this.user.role) || !this.record || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return this._hasSent() ? false : ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'subscribe',
    value: function subscribe() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: '_hasSent',
    value: function _hasSent() {
      if (!(this.record instanceof Blast)) {
        return false;
      }

      return this.record.sent_at !== null;
    }
  }]);

  return BlastPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var BlastTemplatePolicy = function (_AbstractPolicy) {
  _inherits(BlastTemplatePolicy, _AbstractPolicy);

  function BlastTemplatePolicy() {
    _classCallCheck(this, BlastTemplatePolicy);

    return _possibleConstructorReturn(this, (BlastTemplatePolicy.__proto__ || _Object$getPrototypeOf(BlastTemplatePolicy)).apply(this, arguments));
  }

  _createClass(BlastTemplatePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || !this.record || !this.record.user_id || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return ['admin', 'super'].includes(this.user.role) || !this.record || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return BlastTemplatePolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index"] }] */

var ChannelPolicy = function (_AbstractPolicy) {
  _inherits(ChannelPolicy, _AbstractPolicy);

  function ChannelPolicy() {
    _classCallCheck(this, ChannelPolicy);

    return _possibleConstructorReturn(this, (ChannelPolicy.__proto__ || _Object$getPrototypeOf(ChannelPolicy)).apply(this, arguments));
  }

  _createClass(ChannelPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ChannelPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index"] }] */

var ChannelCommentPolicy = function (_AbstractPolicy) {
  _inherits(ChannelCommentPolicy, _AbstractPolicy);

  function ChannelCommentPolicy() {
    _classCallCheck(this, ChannelCommentPolicy);

    return _possibleConstructorReturn(this, (ChannelCommentPolicy.__proto__ || _Object$getPrototypeOf(ChannelCommentPolicy)).apply(this, arguments));
  }

  _createClass(ChannelCommentPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.related.channel ? ['super'].includes(this.user.role) || !this.related.channel.mandatory_subscription : true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.record ? ['admin', 'super'].includes(this.user.role) || this.record.user.id === this.user.id : true;
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return ChannelCommentPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var ContactCustomActivityPolicy = function (_AbstractPolicy) {
  _inherits(ContactCustomActivityPolicy, _AbstractPolicy);

  function ContactCustomActivityPolicy() {
    _classCallCheck(this, ContactCustomActivityPolicy);

    return _possibleConstructorReturn(this, (ContactCustomActivityPolicy.__proto__ || _Object$getPrototypeOf(ContactCustomActivityPolicy)).apply(this, arguments));
  }

  _createClass(ContactCustomActivityPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return ['admin', 'super'].includes(this.user.role) || this.user.id === this.record.user_id;
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return ContactCustomActivityPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index", "create"] }] */

var ContactPolicy = function (_AbstractPolicy) {
  _inherits(ContactPolicy, _AbstractPolicy);

  function ContactPolicy() {
    _classCallCheck(this, ContactPolicy);

    return _possibleConstructorReturn(this, (ContactPolicy.__proto__ || _Object$getPrototypeOf(ContactPolicy)).apply(this, arguments));
  }

  _createClass(ContactPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(Contact, 'user_id') || this._isAssignedToTeamMemberWithReadAccess();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(Contact, 'user_id') || this._isAssignedToTeamMemberWithEditAccess();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      var isRoleApproved = ['admin', 'super'].includes(this.user.role);

      if (!(this.record instanceof Contact)) {
        return isRoleApproved;
      }

      return (isRoleApproved || this._isAssignedToTeamMemberWithEditAccess()) && !this.record.belongsToContactGroup();
    }

    /** @return {boolean} */

  }, {
    key: '_isAssignedToTeamMemberWithEditAccess',
    value: function _isAssignedToTeamMemberWithEditAccess() {
      var _this2 = this;

      if (!(this.record instanceof Contact) || !this.record.user_id) {
        return false;
      }

      var matches = this.user.teams.filter(function (team) {
        return team.leader_user_ids.includes(_this2.user.id) && (team.user_ids.includes(_this2.record.user_id) || team.leader_user_ids.includes(_this2.record.user_id));
      });

      return matches.length > 0;
    }

    /** @return {boolean} */

  }, {
    key: '_isAssignedToTeamMemberWithReadAccess',
    value: function _isAssignedToTeamMemberWithReadAccess() {
      var _this3 = this;

      if (!(this.record instanceof Contact) || !this.record.user_id) {
        return false;
      }

      var matches = this.user.teams.filter(function (team) {
        return team.contact_access === 'contact_access' && (team.user_ids.includes(_this3.record.user_id) || team.leader_user_ids.includes(_this3.record.user_id));
      });

      return matches.length > 0;
    }
  }]);

  return ContactPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show", "create"]}] */

var ContactGroupPolicy = function (_AbstractPolicy) {
  _inherits(ContactGroupPolicy, _AbstractPolicy);

  function ContactGroupPolicy() {
    _classCallCheck(this, ContactGroupPolicy);

    return _possibleConstructorReturn(this, (ContactGroupPolicy.__proto__ || _Object$getPrototypeOf(ContactGroupPolicy)).apply(this, arguments));
  }

  _createClass(ContactGroupPolicy, [{
    key: 'show',

    /** @return {boolean} */
    value: function show() {
      if (!(this.record instanceof ContactGroup)) {
        return true;
      }

      return new ContactPolicy(this.user, this.related.contact).show();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      if (!(this.record instanceof ContactGroup)) {
        return true;
      }

      return new ContactPolicy(this.user, this.related.contact).update();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return ['admin', 'super'].includes(this.user.role);
    }
  }]);

  return ContactGroupPolicy;
}(AbstractPolicy);

var ContactListingReport = function (_AbstractModel) {
  _inherits(ContactListingReport, _AbstractModel);

  function ContactListingReport() {
    _classCallCheck(this, ContactListingReport);

    return _possibleConstructorReturn(this, (ContactListingReport.__proto__ || _Object$getPrototypeOf(ContactListingReport)).apply(this, arguments));
  }

  _createClass(ContactListingReport, [{
    key: 'email',


    /** @return {Promise<object>} */
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(message) {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Client.post(this.query().getBaseUri() + '/' + this.id + '/email', {
                  data: {
                    user_message: message
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function email(_x) {
        return _ref.apply(this, arguments);
      }

      return email;
    }()
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/listing_reports';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        created_at: null,
        id: null,
        property: Container.getInstance().resolve(Property),
        property_id: null,
        send_email: true,
        updated_at: null,
        user: Container.getInstance().resolve(User),
        user_id: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        property: 'property_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        property: Property,
        user: User
      };
    }
  }]);

  return ContactListingReport;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index", "show"] }] */

var ContactListingReportPolicy = function (_AbstractPolicy) {
  _inherits(ContactListingReportPolicy, _AbstractPolicy);

  function ContactListingReportPolicy() {
    _classCallCheck(this, ContactListingReportPolicy);

    return _possibleConstructorReturn(this, (ContactListingReportPolicy.__proto__ || _Object$getPrototypeOf(ContactListingReportPolicy)).apply(this, arguments));
  }

  _createClass(ContactListingReportPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(ContactListingReport, 'user.id');
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ContactListingReportPolicy;
}(AbstractPolicy);

var ContactMarketUpdatePolicy = function (_AbstractPolicy) {
  _inherits(ContactMarketUpdatePolicy, _AbstractPolicy);

  function ContactMarketUpdatePolicy() {
    _classCallCheck(this, ContactMarketUpdatePolicy);

    return _possibleConstructorReturn(this, (ContactMarketUpdatePolicy.__proto__ || _Object$getPrototypeOf(ContactMarketUpdatePolicy)).apply(this, arguments));
  }

  _createClass(ContactMarketUpdatePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return this.user.hasPermissionTo('show', this.related.contact || 'contact');
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ContactMarketUpdatePolicy;
}(AbstractPolicy);

var ContactMessage = function (_AbstractModel) {
  _inherits(ContactMessage, _AbstractModel);

  function ContactMessage() {
    _classCallCheck(this, ContactMessage);

    return _possibleConstructorReturn(this, (ContactMessage.__proto__ || _Object$getPrototypeOf(ContactMessage)).apply(this, arguments));
  }

  _createClass(ContactMessage, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/messages';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        body: null,
        contact: new Contact(),
        contact_id: null,
        created_at: null,
        id: null,
        subject: null,
        updated_at: null,
        user: new User(),
        user_id: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        contact: 'contact_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        contact: Contact,
        user: User
      };
    }
  }]);

  return ContactMessage;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index", "update"] }] */

var ContactMessagePolicy = function (_AbstractPolicy) {
  _inherits(ContactMessagePolicy, _AbstractPolicy);

  function ContactMessagePolicy() {
    _classCallCheck(this, ContactMessagePolicy);

    return _possibleConstructorReturn(this, (ContactMessagePolicy.__proto__ || _Object$getPrototypeOf(ContactMessagePolicy)).apply(this, arguments));
  }

  _createClass(ContactMessagePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(ContactMessage, 'user.id');
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      if (['admin', 'super'].includes(this.user.role)) {
        return true;
      }

      return this.related.contact ? this.related.contact.user_id === this.user.id : true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return ContactMessagePolicy;
}(AbstractPolicy);

var ContactNote = function (_AbstractModel) {
  _inherits(ContactNote, _AbstractModel);

  function ContactNote() {
    _classCallCheck(this, ContactNote);

    return _possibleConstructorReturn(this, (ContactNote.__proto__ || _Object$getPrototypeOf(ContactNote)).apply(this, arguments));
  }

  _createClass(ContactNote, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/notes';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        contact_id: null,
        user: Container.getInstance().resolve(User),
        user_id: null,
        body: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        user: User
      };
    }
  }]);

  return ContactNote;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show", "create"]}] */

var ContactNotePolicy = function (_AbstractPolicy) {
  _inherits(ContactNotePolicy, _AbstractPolicy);

  function ContactNotePolicy() {
    _classCallCheck(this, ContactNotePolicy);

    return _possibleConstructorReturn(this, (ContactNotePolicy.__proto__ || _Object$getPrototypeOf(ContactNotePolicy)).apply(this, arguments));
  }

  _createClass(ContactNotePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(ContactNote, 'user_id');
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return ContactNotePolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index", "show"] }] */

var ContactPropertyTransactionPolicy = function (_AbstractPolicy) {
  _inherits(ContactPropertyTransactionPolicy, _AbstractPolicy);

  function ContactPropertyTransactionPolicy() {
    _classCallCheck(this, ContactPropertyTransactionPolicy);

    return _possibleConstructorReturn(this, (ContactPropertyTransactionPolicy.__proto__ || _Object$getPrototypeOf(ContactPropertyTransactionPolicy)).apply(this, arguments));
  }

  _createClass(ContactPropertyTransactionPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.show();
    }
  }]);

  return ContactPropertyTransactionPolicy;
}(AbstractPolicy);

var ContactSavedSearchPolicy = function (_AbstractPolicy) {
  _inherits(ContactSavedSearchPolicy, _AbstractPolicy);

  function ContactSavedSearchPolicy() {
    _classCallCheck(this, ContactSavedSearchPolicy);

    return _possibleConstructorReturn(this, (ContactSavedSearchPolicy.__proto__ || _Object$getPrototypeOf(ContactSavedSearchPolicy)).apply(this, arguments));
  }

  _createClass(ContactSavedSearchPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return this.user.hasPermissionTo('show', this.related.contact || 'contact');
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ContactSavedSearchPolicy;
}(AbstractPolicy);

var ContentCategory = function (_AbstractModel) {
  _inherits(ContentCategory, _AbstractModel);

  function ContentCategory() {
    _classCallCheck(this, ContentCategory);

    return _possibleConstructorReturn(this, (ContentCategory.__proto__ || _Object$getPrototypeOf(ContentCategory)).apply(this, arguments));
  }

  _createClass(ContentCategory, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contents/categories';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        created_at: null,
        id: null,
        name: null,
        updated_at: null
      };
    }
  }]);

  return ContentCategory;
}(AbstractModel);

var Content = function (_AbstractModel) {
  _inherits(Content, _AbstractModel);

  function Content() {
    _classCallCheck(this, Content);

    return _possibleConstructorReturn(this, (Content.__proto__ || _Object$getPrototypeOf(Content)).apply(this, arguments));
  }

  _createClass(Content, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contents';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        body: null,
        category: new ContentCategory(),
        category_id: null,
        created_at: null,
        id: null,
        name: null,
        roles: [],
        subject: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        category: 'category_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        category: ContentCategory
      };
    }
  }]);

  return Content;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index"] }] */

var ContentPolicy = function (_AbstractPolicy) {
  _inherits(ContentPolicy, _AbstractPolicy);

  function ContentPolicy() {
    _classCallCheck(this, ContentPolicy);

    return _possibleConstructorReturn(this, (ContentPolicy.__proto__ || _Object$getPrototypeOf(ContentPolicy)).apply(this, arguments));
  }

  _createClass(ContentPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this.record instanceof Content && this.record.roles.includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ContentPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index"] }] */

var ContentCategoryPolicy = function (_AbstractPolicy) {
  _inherits(ContentCategoryPolicy, _AbstractPolicy);

  function ContentCategoryPolicy() {
    _classCallCheck(this, ContentCategoryPolicy);

    return _possibleConstructorReturn(this, (ContentCategoryPolicy.__proto__ || _Object$getPrototypeOf(ContentCategoryPolicy)).apply(this, arguments));
  }

  _createClass(ContentCategoryPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ContentCategoryPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var DripCampaignPolicy = function (_AbstractPolicy) {
  _inherits(DripCampaignPolicy, _AbstractPolicy);

  function DripCampaignPolicy() {
    _classCallCheck(this, DripCampaignPolicy);

    return _possibleConstructorReturn(this, (DripCampaignPolicy.__proto__ || _Object$getPrototypeOf(DripCampaignPolicy)).apply(this, arguments));
  }

  _createClass(DripCampaignPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || !this.record || !this.record.user_id || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return ['admin', 'super'].includes(this.user.role) || !this.record || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'subscribe',
    value: function subscribe() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      return this.update();
    }
  }]);

  return DripCampaignPolicy;
}(AbstractPolicy);

var DripCampaignDrip = function (_AbstractModel) {
  _inherits(DripCampaignDrip, _AbstractModel);

  function DripCampaignDrip() {
    _classCallCheck(this, DripCampaignDrip);

    return _possibleConstructorReturn(this, (DripCampaignDrip.__proto__ || _Object$getPrototypeOf(DripCampaignDrip)).apply(this, arguments));
  }

  _createClass(DripCampaignDrip, [{
    key: 'stats',


    /** @return {object} */
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Client.get('/drip_campaigns/' + this.drip_campaign_id + '/drips/' + this.id + '/emails');

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stats() {
        return _ref.apply(this, arguments);
      }

      return stats;
    }()
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/drip_campaigns/:drip_campaign_id/drips';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        drip_campaign_id: null,
        subject: null,
        body: null,
        body_source: null,
        email_footer: Container.getInstance().resolve(EmailFooter),
        email_footer_id: null,
        email_header: Container.getInstance().resolve(EmailHeader),
        email_header_id: null,
        format: null,
        send_after: null,
        template: null,
        drips_total: null,
        subscribers_total: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        email_footer: 'email_footer_id',
        email_header: 'email_header_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        email_footer: EmailFooter,
        email_header: EmailHeader
      };
    }
  }]);

  return DripCampaignDrip;
}(AbstractModel);

var DripCampaignDripPolicy = function (_AbstractPolicy) {
  _inherits(DripCampaignDripPolicy, _AbstractPolicy);

  function DripCampaignDripPolicy() {
    _classCallCheck(this, DripCampaignDripPolicy);

    return _possibleConstructorReturn(this, (DripCampaignDripPolicy.__proto__ || _Object$getPrototypeOf(DripCampaignDripPolicy)).apply(this, arguments));
  }

  _createClass(DripCampaignDripPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      if (this._inGeneral()) {
        return true;
      }

      if (this.related.dripCampaign) {
        return !this.related.dripCampaign.user_id || this.user.id === this.related.dripCampaign.user.id;
      }

      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      if (this._inGeneral()) {
        return true;
      }

      if (this.related.dripCampaign) {
        return this.user.id === this.related.dripCampaign.user.id;
      }

      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: '_hasRoles',
    value: function _hasRoles() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: '_inGeneral',
    value: function _inGeneral() {
      if (!(this.record instanceof DripCampaignDrip) && !this.related.dripCampaign) {
        return true;
      }

      return this._hasRoles();
    }
  }]);

  return DripCampaignDripPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var DripCampaignTemplatePolicy = function (_AbstractPolicy) {
  _inherits(DripCampaignTemplatePolicy, _AbstractPolicy);

  function DripCampaignTemplatePolicy() {
    _classCallCheck(this, DripCampaignTemplatePolicy);

    return _possibleConstructorReturn(this, (DripCampaignTemplatePolicy.__proto__ || _Object$getPrototypeOf(DripCampaignTemplatePolicy)).apply(this, arguments));
  }

  _createClass(DripCampaignTemplatePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || !this.record || !this.record.user_id || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return ['admin', 'super'].includes(this.user.role) || !this.record || this.user.id === this.record.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return DripCampaignTemplatePolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var EmailFooterPolicy = function (_AbstractPolicy) {
  _inherits(EmailFooterPolicy, _AbstractPolicy);

  function EmailFooterPolicy() {
    _classCallCheck(this, EmailFooterPolicy);

    return _possibleConstructorReturn(this, (EmailFooterPolicy.__proto__ || _Object$getPrototypeOf(EmailFooterPolicy)).apply(this, arguments));
  }

  _createClass(EmailFooterPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.show();
    }
  }]);

  return EmailFooterPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var EmailHeaderPolicy = function (_AbstractPolicy) {
  _inherits(EmailHeaderPolicy, _AbstractPolicy);

  function EmailHeaderPolicy() {
    _classCallCheck(this, EmailHeaderPolicy);

    return _possibleConstructorReturn(this, (EmailHeaderPolicy.__proto__ || _Object$getPrototypeOf(EmailHeaderPolicy)).apply(this, arguments));
  }

  _createClass(EmailHeaderPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.show();
    }
  }]);

  return EmailHeaderPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var FieldOptionPolicy = function (_AbstractPolicy) {
  _inherits(FieldOptionPolicy, _AbstractPolicy);

  function FieldOptionPolicy() {
    _classCallCheck(this, FieldOptionPolicy);

    return _possibleConstructorReturn(this, (FieldOptionPolicy.__proto__ || _Object$getPrototypeOf(FieldOptionPolicy)).apply(this, arguments));
  }

  _createClass(FieldOptionPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return FieldOptionPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var MlsOfficePolicy = function (_AbstractPolicy) {
  _inherits(MlsOfficePolicy, _AbstractPolicy);

  function MlsOfficePolicy() {
    _classCallCheck(this, MlsOfficePolicy);

    return _possibleConstructorReturn(this, (MlsOfficePolicy.__proto__ || _Object$getPrototypeOf(MlsOfficePolicy)).apply(this, arguments));
  }

  _createClass(MlsOfficePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return MlsOfficePolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var PropertyMarketingHistoryPolicy = function (_AbstractPolicy) {
  _inherits(PropertyMarketingHistoryPolicy, _AbstractPolicy);

  function PropertyMarketingHistoryPolicy() {
    _classCallCheck(this, PropertyMarketingHistoryPolicy);

    return _possibleConstructorReturn(this, (PropertyMarketingHistoryPolicy.__proto__ || _Object$getPrototypeOf(PropertyMarketingHistoryPolicy)).apply(this, arguments));
  }

  _createClass(PropertyMarketingHistoryPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role) || this._belongsToUser();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: '_belongsToUser',
    value: function _belongsToUser() {
      if (!(this.record instanceof PropertyMarketingHistory)) {
        return true;
      }

      return this.user.id === this.record.user_id;
    }
  }]);

  return PropertyMarketingHistoryPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var OfficePolicy = function (_AbstractPolicy) {
  _inherits(OfficePolicy, _AbstractPolicy);

  function OfficePolicy() {
    _classCallCheck(this, OfficePolicy);

    return _possibleConstructorReturn(this, (OfficePolicy.__proto__ || _Object$getPrototypeOf(OfficePolicy)).apply(this, arguments));
  }

  _createClass(OfficePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return OfficePolicy;
}(AbstractPolicy);

var ProductCategory = function (_AbstractModel) {
  _inherits(ProductCategory, _AbstractModel);

  function ProductCategory() {
    _classCallCheck(this, ProductCategory);

    return _possibleConstructorReturn(this, (ProductCategory.__proto__ || _Object$getPrototypeOf(ProductCategory)).apply(this, arguments));
  }

  _createClass(ProductCategory, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/products/categories';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        created_at: null,
        id: null,
        name: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        name: {
          type: String
        }
      };
    }
  }]);

  return ProductCategory;
}(AbstractModel);

var Product = function (_AbstractModel) {
  _inherits(Product, _AbstractModel);

  function Product() {
    _classCallCheck(this, Product);

    return _possibleConstructorReturn(this, (Product.__proto__ || _Object$getPrototypeOf(Product)).apply(this, arguments));
  }

  _createClass(Product, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/products';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        active: null,
        approval_required: false,
        category: Container.getInstance().resolve(ProductCategory),
        category_id: null,
        created_at: null,
        custom_fields: [],
        description: null,
        emails: [],
        fulfill_by: null,
        id: null,
        meta: [],
        name: null,
        photos: [],
        price: null,
        price_value: null,
        updated_at: null,
        url: null,
        user: Container.getInstance().resolve(User),
        user_id: null
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        category: 'category_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        category: ProductCategory,
        user: User
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        active: {
          type: Boolean
        },
        approval_required: {
          type: Boolean
        },
        category_id: {
          commaSeparatedSupport: true,
          model: ProductCategory,
          type: Number
        },
        name: {
          type: String
        },
        max_price: {
          type: Number
        },
        min_price: {
          type: Number
        },
        user_id: {
          model: User,
          type: Number
        }
      };
    }
  }]);

  return Product;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var ProductPolicy = function (_AbstractPolicy) {
  _inherits(ProductPolicy, _AbstractPolicy);

  function ProductPolicy() {
    _classCallCheck(this, ProductPolicy);

    return _possibleConstructorReturn(this, (ProductPolicy.__proto__ || _Object$getPrototypeOf(ProductPolicy)).apply(this, arguments));
  }

  _createClass(ProductPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      if (!(this.record instanceof Product)) {
        return true;
      }

      return this._isRoleApproved() || this.record.active === true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this._isRoleApproved();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'queryForInactive',
    value: function queryForInactive() {
      return this._isRoleApproved();
    }

    /** @return {boolean} */

  }, {
    key: '_isRoleApproved',
    value: function _isRoleApproved() {
      return ['admin', 'super'].includes(this.user.role);
    }
  }]);

  return ProductPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var ProductCategoryPolicy = function (_AbstractPolicy) {
  _inherits(ProductCategoryPolicy, _AbstractPolicy);

  function ProductCategoryPolicy() {
    _classCallCheck(this, ProductCategoryPolicy);

    return _possibleConstructorReturn(this, (ProductCategoryPolicy.__proto__ || _Object$getPrototypeOf(ProductCategoryPolicy)).apply(this, arguments));
  }

  _createClass(ProductCategoryPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ProductCategoryPolicy;
}(AbstractPolicy);

var ProductRequestStatus = function (_AbstractModel) {
  _inherits(ProductRequestStatus, _AbstractModel);

  function ProductRequestStatus() {
    _classCallCheck(this, ProductRequestStatus);

    return _possibleConstructorReturn(this, (ProductRequestStatus.__proto__ || _Object$getPrototypeOf(ProductRequestStatus)).apply(this, arguments));
  }

  _createClass(ProductRequestStatus, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/products/requests/statuses';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        created_at: null,
        name: null,
        order: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        name: {
          type: String
        }
      };
    }
  }]);

  return ProductRequestStatus;
}(AbstractModel);

var ProductRequest = function (_AbstractModel) {
  _inherits(ProductRequest, _AbstractModel);

  function ProductRequest() {
    _classCallCheck(this, ProductRequest);

    return _possibleConstructorReturn(this, (ProductRequest.__proto__ || _Object$getPrototypeOf(ProductRequest)).apply(this, arguments));
  }

  _createClass(ProductRequest, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/products/requests';
    }

    /** @type {string} */

  }, {
    key: 'DEFAULT_FETCH_ALL_SORT_BY',
    get: function get() {
      return 'created_at';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        created_at: null,
        custom_fields: {},
        id: null,
        photos: [],
        product: Container.getInstance().resolve(Product),
        product_id: null,
        property: Container.getInstance().resolve(Property),
        property_id: null,
        status: Container.getInstance().resolve(ProductRequestStatus),
        status_id: null,
        updated_at: null,
        user: Container.getInstance().resolve(User),
        user_id: null
      };
    }

    /** @type {boolean} */

  }, {
    key: 'HAS_SCROLL_SUPPORT',
    get: function get() {
      return true;
    }

    /** @type {number} */

  }, {
    key: 'PER_PAGE_MAX',
    get: function get() {
      return 100;
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        product: 'product_id',
        property: 'property_id',
        status: 'status_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        product: Product,
        property: Property,
        status: ProductRequestStatus,
        user: User
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        category_id: {
          commaSeparatedSupport: true,
          model: ProductCategory,
          type: Number
        },
        created_after: {
          type: Date
        },
        created_before: {
          type: Date
        },
        created_since: {
          type: Number
        },
        max_price: {
          type: Number
        },
        min_price: {
          type: Number
        },
        product_id: {
          commaSeparatedSupport: true,
          model: Product,
          type: Number
        },
        product_user_id: {
          commaSeparatedSupport: true,
          model: User,
          type: Number
        },
        property_id: {
          commaSeparatedSupport: true,
          model: Property,
          type: Number
        },
        status_id: {
          commaSeparatedSupport: true,
          model: ProductRequestStatus,
          type: Number
        },
        user_id: {
          commaSeparatedSupport: true,
          model: User,
          type: Number
        }
      };
    }
  }]);

  return ProductRequest;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "create"]}] */

var ProductRequestPolicy = function (_AbstractPolicy) {
  _inherits(ProductRequestPolicy, _AbstractPolicy);

  function ProductRequestPolicy() {
    _classCallCheck(this, ProductRequestPolicy);

    return _possibleConstructorReturn(this, (ProductRequestPolicy.__proto__ || _Object$getPrototypeOf(ProductRequestPolicy)).apply(this, arguments));
  }

  _createClass(ProductRequestPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      if (!(this.record instanceof Product)) {
        return true;
      }

      return this._isRoleApproved() || this._isAssignedToUser(ProductRequest, 'user_id') || this._isProductAssignedToUser();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this._isRoleApproved() || this._isAssignedToUser(ProductRequest, 'user_id');
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return this._isRoleApproved();
    }

    /** @return {boolean} */

  }, {
    key: '_isProductAssignedToUser',
    value: function _isProductAssignedToUser() {
      if (!(this.record.product instanceof Product)) {
        return true;
      }

      return this.user.id === this.record.product.user_id;
    }

    /** @return {boolean} */

  }, {
    key: '_isRoleApproved',
    value: function _isRoleApproved() {
      return ['admin', 'super'].includes(this.user.role);
    }
  }]);

  return ProductRequestPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var ProductRequestStatusPolicy = function (_AbstractPolicy) {
  _inherits(ProductRequestStatusPolicy, _AbstractPolicy);

  function ProductRequestStatusPolicy() {
    _classCallCheck(this, ProductRequestStatusPolicy);

    return _possibleConstructorReturn(this, (ProductRequestStatusPolicy.__proto__ || _Object$getPrototypeOf(ProductRequestStatusPolicy)).apply(this, arguments));
  }

  _createClass(ProductRequestStatusPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return ProductRequestStatusPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var PropertyCustomFieldPolicy = function (_AbstractPolicy) {
  _inherits(PropertyCustomFieldPolicy, _AbstractPolicy);

  function PropertyCustomFieldPolicy() {
    _classCallCheck(this, PropertyCustomFieldPolicy);

    return _possibleConstructorReturn(this, (PropertyCustomFieldPolicy.__proto__ || _Object$getPrototypeOf(PropertyCustomFieldPolicy)).apply(this, arguments));
  }

  _createClass(PropertyCustomFieldPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return PropertyCustomFieldPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "create"]}] */

var PropertyNotePolicy = function (_AbstractPolicy) {
  _inherits(PropertyNotePolicy, _AbstractPolicy);

  function PropertyNotePolicy() {
    _classCallCheck(this, PropertyNotePolicy);

    return _possibleConstructorReturn(this, (PropertyNotePolicy.__proto__ || _Object$getPrototypeOf(PropertyNotePolicy)).apply(this, arguments));
  }

  _createClass(PropertyNotePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(PropertyNote, 'user_id');
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return PropertyNotePolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var PropertyPolicy = function (_AbstractPolicy) {
  _inherits(PropertyPolicy, _AbstractPolicy);

  function PropertyPolicy() {
    _classCallCheck(this, PropertyPolicy);

    return _possibleConstructorReturn(this, (PropertyPolicy.__proto__ || _Object$getPrototypeOf(PropertyPolicy)).apply(this, arguments));
  }

  _createClass(PropertyPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      if (!(this.user instanceof User) || !(this.record instanceof Property) && this.user.role !== 'lender') {
        return true;
      }

      if (this.record instanceof Property && !this.record.isFromUser() || this.user.role === 'lender') {
        return false;
      }

      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      if (!(this.user instanceof User) || this.record instanceof Property && !this.record.isFromUser()) {
        return false;
      }

      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: '_isAssignedToUser',
    value: function _isAssignedToUser() {
      return this.record.isFromUser() && this.record.user_id === this.user.id;
    }
  }]);

  return PropertyPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index"] }] */

var PropertyTransactionPolicy = function (_AbstractPolicy) {
  _inherits(PropertyTransactionPolicy, _AbstractPolicy);

  function PropertyTransactionPolicy() {
    _classCallCheck(this, PropertyTransactionPolicy);

    return _possibleConstructorReturn(this, (PropertyTransactionPolicy.__proto__ || _Object$getPrototypeOf(PropertyTransactionPolicy)).apply(this, arguments));
  }

  _createClass(PropertyTransactionPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      var contact = this.record && this.record.contact ? this.record.contact : null;

      return new ContactPolicy(this.user, contact).show();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.show();
    }
  }]);

  return PropertyTransactionPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var RegionPolicy = function (_AbstractPolicy) {
  _inherits(RegionPolicy, _AbstractPolicy);

  function RegionPolicy() {
    _classCallCheck(this, RegionPolicy);

    return _possibleConstructorReturn(this, (RegionPolicy.__proto__ || _Object$getPrototypeOf(RegionPolicy)).apply(this, arguments));
  }

  _createClass(RegionPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return RegionPolicy;
}(AbstractPolicy);

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $getOwnPropertyDescriptor$1 = _objectGopd.f;

_objectSap('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor$1(_toIobject(it), key);
  };
});

var $Object$3 = _core.Object;
var getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  return $Object$3.getOwnPropertyDescriptor(it, key);
};

var getOwnPropertyDescriptor$1 = createCommonjsModule(function (module) {
module.exports = { "default": getOwnPropertyDescriptor, __esModule: true };
});

unwrapExports(getOwnPropertyDescriptor$1);

var get$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _getPrototypeOf2 = _interopRequireDefault(getPrototypeOf$1);



var _getOwnPropertyDescriptor2 = _interopRequireDefault(getOwnPropertyDescriptor$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};
});

var _get = unwrapExports(get$1);

// @TODO: Could be considered something other than a model, but requires similar functionality.

var RouteSettings = function (_AbstractModel) {
  _inherits(RouteSettings, _AbstractModel);

  function RouteSettings() {
    _classCallCheck(this, RouteSettings);

    return _possibleConstructorReturn(this, (RouteSettings.__proto__ || _Object$getPrototypeOf(RouteSettings)).apply(this, arguments));
  }

  _createClass(RouteSettings, [{
    key: 'exists',


    /** @return {boolean} */
    // eslint-disable-next-line class-methods-use-this
    value: function exists() {
      return true;
    }

    /** @return {Promise<any>} */

  }], [{
    key: 'fetch',
    value: function fetch() {
      var _this2 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new _Promise(function (resolve, reject) {
        Client.get(_this2.BASE_URI, { params: params }).then(function (response) {
          resolve(new _this2(cloneDeep_1(response.data)));
        }).catch(function () {
          reject(new Error('Something unexpected happened.'));
        });
      });
    }
  }, {
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/routes/settings';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        assign_to_listing_agent: false,
        enabled: true,
        listing_agent_acceptance_limit: null,
        routes_order: null,
        updated_at: null,
        default_user: null,
        default_user_id: null
      };
    }

    /** @type {boolean} */

  }, {
    key: 'DESTROYABLE',
    get: function get() {
      return false;
    }

    /** @type {string|null} */

  }, {
    key: 'PRIMARY_KEY',
    get: function get() {
      return null;
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        default_user: 'default_user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_OBJECTS',
    get: function get() {
      return {
        default_user: User
      };
    }
  }]);

  return RouteSettings;
}(AbstractModel);

var Route = function (_AbstractModel) {
  _inherits(Route, _AbstractModel);

  function Route() {
    _classCallCheck(this, Route);

    return _possibleConstructorReturn(this, (Route.__proto__ || _Object$getPrototypeOf(Route)).apply(this, arguments));
  }

  _createClass(Route, [{
    key: 'getSettingsQueryParams',


    /** @return {object} */
    value: function getSettingsQueryParams() {
      var _this2 = this;

      var resourceName = this.constructor.RESOURCE_NAMES.find(function (item) {
        return _this2[item + '_id'] !== null;
      });

      if (resourceName === undefined) {
        return {};
      }

      return _defineProperty$1({}, resourceName + '_id', this[resourceName + '_id']);
    }

    /** @return {Promise<any>} */

  }, {
    key: 'destroy',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var _this3 = this;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _get(Route.prototype.__proto__ || _Object$getPrototypeOf(Route.prototype), 'destroy', this).call(this).then(function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(item) {
                    var settingsQueryParams, settings, itemIndex;
                    return regenerator.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            settingsQueryParams = _this3.getSettingsQueryParams();
                            _context.next = 4;
                            return _this3.constructor.SETTINGS_MODEL.fetch(settingsQueryParams);

                          case 4:
                            settings = _context.sent;
                            itemIndex = settings.routes_order.indexOf(_this3.id.toString());

                            if (!(itemIndex >= 0)) {
                              _context.next = 10;
                              break;
                            }

                            settings.routes_order.splice(itemIndex, 1);
                            _context.next = 10;
                            return settings.query(settingsQueryParams).save();

                          case 10:
                            _context.next = 14;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                          case 14:
                            return _context.abrupt('return', item);

                          case 15:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this3, [[0, 12]]);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function destroy() {
        return _ref2.apply(this, arguments);
      }

      return destroy;
    }()

    /** @return {Promise<any>} */

  }, {
    key: 'save',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        var _this4 = this;

        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.exists()) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return', _get(Route.prototype.__proto__ || _Object$getPrototypeOf(Route.prototype), 'save', this).call(this));

              case 2:
                return _context4.abrupt('return', _get(Route.prototype.__proto__ || _Object$getPrototypeOf(Route.prototype), 'save', this).call(this).then(function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(item) {
                    var settingsQueryParams, settings;
                    return regenerator.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            settingsQueryParams = _this4.getSettingsQueryParams();
                            _context3.next = 4;
                            return _this4.constructor.SETTINGS_MODEL.fetch(settingsQueryParams);

                          case 4:
                            settings = _context3.sent;


                            settings.routes_order.push(item.id);
                            _context3.next = 8;
                            return settings.query(settingsQueryParams).save();

                          case 8:
                            _context3.next = 12;
                            break;

                          case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](0);

                          case 12:
                            return _context3.abrupt('return', item);

                          case 13:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4, [[0, 10]]);
                  }));

                  return function (_x2) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function save() {
        return _ref4.apply(this, arguments);
      }

      return save;
    }()
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/routes';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null,
        acceptance_limit: null,
        round_robin: null,
        list_price_min: null,
        list_price_max: null,
        counties: [],
        cities: [],
        mls_areas_major: [],
        office_id: null,
        property_types: [],
        school_districts: [],
        subdivision_names: [],
        users: [],
        user_ids: [],
        user_query: null,
        website_id: null,
        zips: []
      };
    }

    /** @type {object} */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {
        users: 'user_ids'
      };
    }

    /** @type {array} */

  }, {
    key: 'RESOURCE_NAMES',
    get: function get() {
      return ['office', 'website'];
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        users: User
      };
    }

    /** @return {function} */

  }, {
    key: 'SETTINGS_MODEL',
    get: function get() {
      return RouteSettings;
    }
  }]);

  return Route;
}(AbstractModel);

var RoutePolicy = function (_AbstractPolicy) {
  _inherits(RoutePolicy, _AbstractPolicy);

  function RoutePolicy() {
    _classCallCheck(this, RoutePolicy);

    return _possibleConstructorReturn(this, (RoutePolicy.__proto__ || _Object$getPrototypeOf(RoutePolicy)).apply(this, arguments));
  }

  _createClass(RoutePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      var _this2 = this;

      if (['admin', 'super'].includes(this.user.role)) {
        return true;
      }

      return this.user.offices.some(function (office) {
        return office.manager_user_ids.includes(_this2.user.id);
      });
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      var _this3 = this;

      if (['admin', 'super'].includes(this.user.role)) {
        return true;
      }

      if (this.related.office !== undefined) {
        return this.related.office.manager_user_ids.includes(this.user.id);
      }

      if (this.record instanceof Route && this.record.office_id !== null) {
        var office = this.user.offices.find(function (item) {
          return item.id === _this3.record.office_id;
        });

        return office !== undefined ? office.manager_user_ids.includes(this.user.id) : false;
      }

      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return RoutePolicy;
}(AbstractPolicy);

var RouteSettingsPolicy = function (_AbstractPolicy) {
  _inherits(RouteSettingsPolicy, _AbstractPolicy);

  function RouteSettingsPolicy() {
    _classCallCheck(this, RouteSettingsPolicy);

    return _possibleConstructorReturn(this, (RouteSettingsPolicy.__proto__ || _Object$getPrototypeOf(RouteSettingsPolicy)).apply(this, arguments));
  }

  _createClass(RouteSettingsPolicy, [{
    key: 'show',

    /** @return {boolean} */
    value: function show() {
      if (['admin', 'super'].includes(this.user.role)) {
        return true;
      }

      return this.related.office !== undefined && this.related.office.manager_user_ids.includes(this.user.id);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }
  }]);

  return RouteSettingsPolicy;
}(AbstractPolicy);

var Tag = function (_AbstractModel) {
  _inherits(Tag, _AbstractModel);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || _Object$getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/tags';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        contact_frequency: null,
        hex: null,
        id: null,
        name: null,
        user: Container.getInstance().resolve(User),
        user_id: null
      };
    }

    /** @return {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        name: {
          type: String
        },
        user_assigned: {
          type: Boolean
        },
        user_id: {
          model: User,
          type: Number
        }
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        user: User
      };
    }
  }]);

  return Tag;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var TagPolicy = function (_AbstractPolicy) {
  _inherits(TagPolicy, _AbstractPolicy);

  function TagPolicy() {
    _classCallCheck(this, TagPolicy);

    return _possibleConstructorReturn(this, (TagPolicy.__proto__ || _Object$getPrototypeOf(TagPolicy)).apply(this, arguments));
  }

  _createClass(TagPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(Tag, 'user.id');
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.show();
    }
  }]);

  return TagPolicy;
}(AbstractPolicy);

var Task = function (_AbstractModel) {
  _inherits(Task, _AbstractModel);

  function Task() {
    _classCallCheck(this, Task);

    return _possibleConstructorReturn(this, (Task.__proto__ || _Object$getPrototypeOf(Task)).apply(this, arguments));
  }

  _createClass(Task, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/tasks';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        assigned_user: Container.getInstance().resolve(User),
        assigned_user_id: null,
        completed: false,
        description: null,
        due_date: null,
        subject_contact: Container.getInstance().resolve(Contact),
        subject_contact_id: null,
        subject_property: Container.getInstance().resolve(Property),
        subject_property_id: null,
        subject_user: Container.getInstance().resolve(User),
        subject_user_id: null,
        title: null,
        user_id: null,
        completed_at: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        assigned_user: 'assigned_user_id',
        subject_contact: 'subject_contact_id',
        subject_property: 'subject_property_id',
        subject_user: 'subject_user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        assigned_user: User,
        subject_contact: Contact,
        subject_property: Property,
        subject_user: User
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        assigned_user_id: {
          model: User,
          type: Number
        },
        completed: {
          type: Boolean
        },
        subject_contact_id: {
          model: Contact,
          type: Number
        },
        subject_property_id: {
          model: Property,
          type: Number
        },
        subject_user_id: {
          model: User,
          type: Number
        },
        user_id: {
          model: User,
          type: Number
        }
      };
    }
  }]);

  return Task;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "create"]}] */

var TaskPolicy = function (_AbstractPolicy) {
  _inherits(TaskPolicy, _AbstractPolicy);

  function TaskPolicy() {
    _classCallCheck(this, TaskPolicy);

    return _possibleConstructorReturn(this, (TaskPolicy.__proto__ || _Object$getPrototypeOf(TaskPolicy)).apply(this, arguments));
  }

  _createClass(TaskPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(Task, 'assigned_user_id') || this._isOwner();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'updateAssignedUserId',
    value: function updateAssignedUserId() {
      return ['admin', 'super'].includes(this.user.role) || this._isOwner();
    }

    /** @return {boolean} */

  }, {
    key: 'updateDescription',
    value: function updateDescription() {
      return this.updateAssignedUserId();
    }

    /** @return {boolean} */

  }, {
    key: 'updateDueDate',
    value: function updateDueDate() {
      return this.updateAssignedUserId();
    }

    /** @return {boolean} */

  }, {
    key: 'updateSubjectContactId',
    value: function updateSubjectContactId() {
      return this.updateAssignedUserId();
    }

    /** @return {boolean} */

  }, {
    key: 'updateSubjectPropertyId',
    value: function updateSubjectPropertyId() {
      return this.updateAssignedUserId();
    }

    /** @return {boolean} */

  }, {
    key: 'updateSubjectUserId',
    value: function updateSubjectUserId() {
      return this.updateAssignedUserId();
    }

    /** @return {boolean} */

  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      return this.updateAssignedUserId();
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return this.updateAssignedUserId();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return ['admin', 'super'].includes(this.user.role) || this._isOwner();
    }
  }, {
    key: '_isOwner',
    value: function _isOwner() {
      if (!(this.record instanceof Task)) {
        return true;
      }

      return this.user.id === this.record.user_id;
    }
  }]);

  return TaskPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var TeamPolicy = function (_AbstractPolicy) {
  _inherits(TeamPolicy, _AbstractPolicy);

  function TeamPolicy() {
    _classCallCheck(this, TeamPolicy);

    return _possibleConstructorReturn(this, (TeamPolicy.__proto__ || _Object$getPrototypeOf(TeamPolicy)).apply(this, arguments));
  }

  _createClass(TeamPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return TeamPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var BaseIndexPolicy = function (_AbstractPolicy) {
  _inherits(BaseIndexPolicy, _AbstractPolicy);

  function BaseIndexPolicy() {
    _classCallCheck(this, BaseIndexPolicy);

    return _possibleConstructorReturn(this, (BaseIndexPolicy.__proto__ || _Object$getPrototypeOf(BaseIndexPolicy)).apply(this, arguments));
  }

  _createClass(BaseIndexPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.show();
    }
  }]);

  return BaseIndexPolicy;
}(AbstractPolicy);

var UserActivityPolicy = function (_BaseIndexPolicy) {
  _inherits(UserActivityPolicy, _BaseIndexPolicy);

  function UserActivityPolicy() {
    _classCallCheck(this, UserActivityPolicy);

    return _possibleConstructorReturn(this, (UserActivityPolicy.__proto__ || _Object$getPrototypeOf(UserActivityPolicy)).apply(this, arguments));
  }

  _createClass(UserActivityPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return ['admin', 'super'].includes(this.user.role);
    }
  }]);

  return UserActivityPolicy;
}(BaseIndexPolicy);

var UserContactSync = function (_AbstractModel) {
  _inherits(UserContactSync, _AbstractModel);

  function UserContactSync() {
    _classCallCheck(this, UserContactSync);

    return _possibleConstructorReturn(this, (UserContactSync.__proto__ || _Object$getPrototypeOf(UserContactSync)).apply(this, arguments));
  }

  _createClass(UserContactSync, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/:user_id/contact_syncs';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        data: null,
        group_ids: [],
        id: null,
        oauth_identity_id: null,
        provider_name: null,
        user_id: null
      };
    }
  }]);

  return UserContactSync;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show", "create"]}] */

var UserContactSyncPolicy = function (_AbstractPolicy) {
  _inherits(UserContactSyncPolicy, _AbstractPolicy);

  function UserContactSyncPolicy() {
    _classCallCheck(this, UserContactSyncPolicy);

    return _possibleConstructorReturn(this, (UserContactSyncPolicy.__proto__ || _Object$getPrototypeOf(UserContactSyncPolicy)).apply(this, arguments));
  }

  _createClass(UserContactSyncPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(UserContactSync, 'user_id');
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return UserContactSyncPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var UserCustomActivityPolicy = function (_AbstractPolicy) {
  _inherits(UserCustomActivityPolicy, _AbstractPolicy);

  function UserCustomActivityPolicy() {
    _classCallCheck(this, UserCustomActivityPolicy);

    return _possibleConstructorReturn(this, (UserCustomActivityPolicy.__proto__ || _Object$getPrototypeOf(UserCustomActivityPolicy)).apply(this, arguments));
  }

  _createClass(UserCustomActivityPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.index();
    }
  }]);

  return UserCustomActivityPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var UserCustomFieldPolicy = function (_AbstractPolicy) {
  _inherits(UserCustomFieldPolicy, _AbstractPolicy);

  function UserCustomFieldPolicy() {
    _classCallCheck(this, UserCustomFieldPolicy);

    return _possibleConstructorReturn(this, (UserCustomFieldPolicy.__proto__ || _Object$getPrototypeOf(UserCustomFieldPolicy)).apply(this, arguments));
  }

  _createClass(UserCustomFieldPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return UserCustomFieldPolicy;
}(AbstractPolicy);

var UserHotsheetPolicy = function (_AbstractPolicy) {
  _inherits(UserHotsheetPolicy, _AbstractPolicy);

  function UserHotsheetPolicy() {
    _classCallCheck(this, UserHotsheetPolicy);

    return _possibleConstructorReturn(this, (UserHotsheetPolicy.__proto__ || _Object$getPrototypeOf(UserHotsheetPolicy)).apply(this, arguments));
  }

  _createClass(UserHotsheetPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return ['admin', 'super'].includes(this.user.role) || this.related.user.id === this.user.id;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.index();
    }
  }]);

  return UserHotsheetPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var UserMlsMemberPolicy = function (_AbstractPolicy) {
  _inherits(UserMlsMemberPolicy, _AbstractPolicy);

  function UserMlsMemberPolicy() {
    _classCallCheck(this, UserMlsMemberPolicy);

    return _possibleConstructorReturn(this, (UserMlsMemberPolicy.__proto__ || _Object$getPrototypeOf(UserMlsMemberPolicy)).apply(this, arguments));
  }

  _createClass(UserMlsMemberPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return UserMlsMemberPolicy;
}(AbstractPolicy);

var UserNote = function (_AbstractModel) {
  _inherits(UserNote, _AbstractModel);

  function UserNote() {
    _classCallCheck(this, UserNote);

    return _possibleConstructorReturn(this, (UserNote.__proto__ || _Object$getPrototypeOf(UserNote)).apply(this, arguments));
  }

  _createClass(UserNote, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/:user_id/notes';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        user_id: null,
        owner_user: Container.getInstance().resolve(User),
        owner_user_id: null,
        body: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        owner_user: 'owner_user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        owner_user: User
      };
    }
  }]);

  return UserNote;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "create"]}] */

var UserNotePolicy = function (_AbstractPolicy) {
  _inherits(UserNotePolicy, _AbstractPolicy);

  function UserNotePolicy() {
    _classCallCheck(this, UserNotePolicy);

    return _possibleConstructorReturn(this, (UserNotePolicy.__proto__ || _Object$getPrototypeOf(UserNotePolicy)).apply(this, arguments));
  }

  _createClass(UserNotePolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(UserNote, 'owner_user.id');
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.show();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.update();
    }
  }]);

  return UserNotePolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var UserPolicy = function (_AbstractPolicy) {
  _inherits(UserPolicy, _AbstractPolicy);

  function UserPolicy() {
    _classCallCheck(this, UserPolicy);

    return _possibleConstructorReturn(this, (UserPolicy.__proto__ || _Object$getPrototypeOf(UserPolicy)).apply(this, arguments));
  }

  _createClass(UserPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role) && this._isRoleApproved();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return (['admin', 'super'].includes(this.user.role) || this._isSelf()) && this._isRoleApproved();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      if (!['super', 'admin'].includes(this.user.role)) {
        return false;
      }

      if (!(this.record instanceof User)) {
        return true;
      }

      if (this.user.role === 'admin') {
        return ['agent', 'lender', 'staff'].includes(this.record.role);
      }

      return !this._isSelf();
    }

    /** @return {boolean} */

  }, {
    key: 'updateRole',
    value: function updateRole() {
      if (!(this.record instanceof User)) {
        return ['admin', 'super'].includes(this.user.role);
      }

      return this.user.role === 'super' || this.user.role === 'admin' && this.record.role !== 'super';
    }

    /**
     * Prevent someone who isn't a super user from changing someone's role to super.
     *
     * @return {boolean}
     */

  }, {
    key: '_isRoleApproved',
    value: function _isRoleApproved() {
      if (!(this.record instanceof User)) {
        return true;
      }

      return this.user.role === 'super' || this.record.role !== 'super';
    }

    /** @return {boolean} */

  }, {
    key: '_isSelf',
    value: function _isSelf() {
      if (!(this.record instanceof User)) {
        return true;
      }

      return this.user.id === this.record.id;
    }
  }]);

  return UserPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "update"]}] */

var UserPasskeyPolicy = function (_AbstractPolicy) {
  _inherits(UserPasskeyPolicy, _AbstractPolicy);

  function UserPasskeyPolicy() {
    _classCallCheck(this, UserPasskeyPolicy);

    return _possibleConstructorReturn(this, (UserPasskeyPolicy.__proto__ || _Object$getPrototypeOf(UserPasskeyPolicy)).apply(this, arguments));
  }

  _createClass(UserPasskeyPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.index();
    }
  }]);

  return UserPasskeyPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["index"] }] */

var UserRegistrationEmailPolicy = function (_AbstractPolicy) {
  _inherits(UserRegistrationEmailPolicy, _AbstractPolicy);

  function UserRegistrationEmailPolicy() {
    _classCallCheck(this, UserRegistrationEmailPolicy);

    return _possibleConstructorReturn(this, (UserRegistrationEmailPolicy.__proto__ || _Object$getPrototypeOf(UserRegistrationEmailPolicy)).apply(this, arguments));
  }

  _createClass(UserRegistrationEmailPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return false;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.index();
    }
  }]);

  return UserRegistrationEmailPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index"]}] */

var UserTestimonialPolicy = function (_AbstractPolicy) {
  _inherits(UserTestimonialPolicy, _AbstractPolicy);

  function UserTestimonialPolicy() {
    _classCallCheck(this, UserTestimonialPolicy);

    return _possibleConstructorReturn(this, (UserTestimonialPolicy.__proto__ || _Object$getPrototypeOf(UserTestimonialPolicy)).apply(this, arguments));
  }

  _createClass(UserTestimonialPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return this.index();
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return UserTestimonialPolicy;
}(AbstractPolicy);

var WebsiteRoutePolicy = function (_RoutePolicy) {
  _inherits(WebsiteRoutePolicy, _RoutePolicy);

  function WebsiteRoutePolicy() {
    _classCallCheck(this, WebsiteRoutePolicy);

    return _possibleConstructorReturn(this, (WebsiteRoutePolicy.__proto__ || _Object$getPrototypeOf(WebsiteRoutePolicy)).apply(this, arguments));
  }

  _createClass(WebsiteRoutePolicy, [{
    key: 'index',
    value: function index() {
      return ['admin', 'super'].includes(this.user.role);
    }
  }]);

  return WebsiteRoutePolicy;
}(RoutePolicy);

var WebsiteRouteSettingsPolicy = function (_RouteSettingsPolicy) {
  _inherits(WebsiteRouteSettingsPolicy, _RouteSettingsPolicy);

  function WebsiteRouteSettingsPolicy() {
    _classCallCheck(this, WebsiteRouteSettingsPolicy);

    return _possibleConstructorReturn(this, (WebsiteRouteSettingsPolicy.__proto__ || _Object$getPrototypeOf(WebsiteRouteSettingsPolicy)).apply(this, arguments));
  }

  return WebsiteRouteSettingsPolicy;
}(RouteSettingsPolicy);

var VendorArea = function (_AbstractModel) {
  _inherits(VendorArea, _AbstractModel);

  function VendorArea() {
    _classCallCheck(this, VendorArea);

    return _possibleConstructorReturn(this, (VendorArea.__proto__ || _Object$getPrototypeOf(VendorArea)).apply(this, arguments));
  }

  _createClass(VendorArea, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/vendors/areas';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null
      };
    }
  }]);

  return VendorArea;
}(AbstractModel);

var VendorCategory = function (_AbstractModel) {
  _inherits(VendorCategory, _AbstractModel);

  function VendorCategory() {
    _classCallCheck(this, VendorCategory);

    return _possibleConstructorReturn(this, (VendorCategory.__proto__ || _Object$getPrototypeOf(VendorCategory)).apply(this, arguments));
  }

  _createClass(VendorCategory, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/vendors/categories';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null
      };
    }
  }]);

  return VendorCategory;
}(AbstractModel);

var VendorReview = function (_AbstractModel) {
  _inherits(VendorReview, _AbstractModel);

  function VendorReview() {
    _classCallCheck(this, VendorReview);

    return _possibleConstructorReturn(this, (VendorReview.__proto__ || _Object$getPrototypeOf(VendorReview)).apply(this, arguments));
  }

  _createClass(VendorReview, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/vendors/:vendor_id/reviews';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        comment: null,
        id: null,
        rating: null,
        photos: [],
        vendor_id: null,
        user: Container.getInstance().resolve(User),
        user_id: null
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        user: 'user_id'
      };
    }

    /** @var {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        user: User
      };
    }
  }]);

  return VendorReview;
}(AbstractModel);

var Vendor = function (_AbstractModel) {
  _inherits(Vendor, _AbstractModel);

  function Vendor() {
    _classCallCheck(this, Vendor);

    return _possibleConstructorReturn(this, (Vendor.__proto__ || _Object$getPrototypeOf(Vendor)).apply(this, arguments));
  }

  _createClass(Vendor, [{
    key: 'getContactFullName',


    /** @return {string} */
    value: function getContactFullName() {
      return ((this.contact_first_name ? String(this.contact_first_name).trim() : '') + ' ' + (this.contact_last_name ? String(this.contact_last_name).trim() : '')).trim();
    }

    /** @return {string} */

  }, {
    key: 'getContactName',
    value: function getContactName() {
      return typeof this.contact_display_name === 'string' && this.contact_display_name.trim().length ? String(this.contact_display_name).trim() : this.getContactFullName();
    }

    /** @return {Promise<any>} */

  }, {
    key: 'reviews',
    value: function reviews() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return VendorReview.search(_Object$assign({ vendor_id: this.id }, args));
    }
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/vendors';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        additional_email_addresses: [],
        addresses: [],
        area_ids: [],
        areas: [],
        category_ids: [],
        categories: [],
        contact_display_name: null,
        contact_first_name: null,
        contact_last_name: null,
        description: null,
        email: null,
        id: null,
        name: null,
        phone_numbers: [],
        photos: [],
        rating: null,
        urls: [],
        user: Container.getInstance().resolve(User),
        user_id: null
      };
    }

    /** @type {object} */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {
        areas: 'area_ids',
        categories: 'category_ids'
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        address: 'addresses',
        phone_number: 'phone_numbers',
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        user: User
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        area_id: {
          commaSeparatedSupport: true,
          model: VendorArea,
          type: Number
        },
        category_id: {
          commaSeparatedSupport: true,
          model: VendorCategory,
          type: Number
        },
        name: {
          type: String
        }
      };
    }
  }]);

  return Vendor;
}(AbstractModel);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show", "create"]}] */

var VendorPolicy = function (_AbstractPolicy) {
  _inherits(VendorPolicy, _AbstractPolicy);

  function VendorPolicy() {
    _classCallCheck(this, VendorPolicy);

    return _possibleConstructorReturn(this, (VendorPolicy.__proto__ || _Object$getPrototypeOf(VendorPolicy)).apply(this, arguments));
  }

  _createClass(VendorPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(Vendor, 'user.id');
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return ['admin', 'super'].includes(this.user.role);
    }
  }]);

  return VendorPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var VendorAreaPolicy = function (_AbstractPolicy) {
  _inherits(VendorAreaPolicy, _AbstractPolicy);

  function VendorAreaPolicy() {
    _classCallCheck(this, VendorAreaPolicy);

    return _possibleConstructorReturn(this, (VendorAreaPolicy.__proto__ || _Object$getPrototypeOf(VendorAreaPolicy)).apply(this, arguments));
  }

  _createClass(VendorAreaPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return VendorAreaPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show"]}] */

var VendorCategoryPolicy = function (_AbstractPolicy) {
  _inherits(VendorCategoryPolicy, _AbstractPolicy);

  function VendorCategoryPolicy() {
    _classCallCheck(this, VendorCategoryPolicy);

    return _possibleConstructorReturn(this, (VendorCategoryPolicy.__proto__ || _Object$getPrototypeOf(VendorCategoryPolicy)).apply(this, arguments));
  }

  _createClass(VendorCategoryPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return this.create();
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.create();
    }
  }]);

  return VendorCategoryPolicy;
}(AbstractPolicy);

/* eslint class-methods-use-this: ["error", {"exceptMethods": ["index", "show", "create"]}] */

var VendorReviewPolicy = function (_AbstractPolicy) {
  _inherits(VendorReviewPolicy, _AbstractPolicy);

  function VendorReviewPolicy() {
    _classCallCheck(this, VendorReviewPolicy);

    return _possibleConstructorReturn(this, (VendorReviewPolicy.__proto__ || _Object$getPrototypeOf(VendorReviewPolicy)).apply(this, arguments));
  }

  _createClass(VendorReviewPolicy, [{
    key: 'index',

    /** @return {boolean} */
    value: function index() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'show',
    value: function show() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'create',
    value: function create() {
      return true;
    }

    /** @return {boolean} */

  }, {
    key: 'update',
    value: function update() {
      return ['admin', 'super'].includes(this.user.role) || this._isAssignedToUser(VendorReview, 'user.id');
    }

    /** @return {boolean} */

  }, {
    key: 'destroy',
    value: function destroy() {
      return ['admin', 'super'].includes(this.user.role);
    }

    /** @return {boolean} */

  }, {
    key: 'updateUserId',
    value: function updateUserId() {
      return ['admin', 'super'].includes(this.user.role);
    }
  }]);

  return VendorReviewPolicy;
}(AbstractPolicy);

var PolicyFactory = function () {
  function PolicyFactory() {
    _classCallCheck(this, PolicyFactory);
  }

  _createClass(PolicyFactory, null, [{
    key: 'create',

    /** @return {object} */
    value: function create(user, record, related) {
      var map = {
        blast: BlastPolicy,
        blasttemplate: BlastTemplatePolicy,
        channel: ChannelPolicy,
        channelcomment: ChannelCommentPolicy,
        contact: ContactPolicy,
        contactcustomactivity: ContactCustomActivityPolicy,
        contactgroup: ContactGroupPolicy,
        contactlistingreport: ContactListingReportPolicy,
        contactmarketupdate: ContactMarketUpdatePolicy,
        contactmessage: ContactMessagePolicy,
        contactnote: ContactNotePolicy,
        contactpropertytransaction: ContactPropertyTransactionPolicy,
        contactsavedsearch: ContactSavedSearchPolicy,
        content: ContentPolicy,
        contentcategory: ContentCategoryPolicy,
        dripcampaign: DripCampaignPolicy,
        dripcampaigndrip: DripCampaignDripPolicy,
        dripcampaigntemplate: DripCampaignTemplatePolicy,
        emailfooter: EmailFooterPolicy,
        emailheader: EmailHeaderPolicy,
        fieldoption: FieldOptionPolicy,
        mlsoffice: MlsOfficePolicy,
        propertymarketinghistory: PropertyMarketingHistoryPolicy,
        office: OfficePolicy,
        product: ProductPolicy,
        productcategory: ProductCategoryPolicy,
        productrequest: ProductRequestPolicy,
        productrequeststatus: ProductRequestStatusPolicy,
        property: PropertyPolicy,
        propertycustomfield: PropertyCustomFieldPolicy,
        propertynote: PropertyNotePolicy,
        propertytransaction: PropertyTransactionPolicy,
        region: RegionPolicy,
        route: RoutePolicy,
        routesettings: RouteSettingsPolicy,
        tag: TagPolicy,
        task: TaskPolicy,
        team: TeamPolicy,
        user: UserPolicy,
        useractivity: UserActivityPolicy,
        usercontactsync: UserContactSyncPolicy,
        usercustomactivity: UserCustomActivityPolicy,
        usercustomfield: UserCustomFieldPolicy,
        userhotsheet: UserHotsheetPolicy,
        usermlsmember: UserMlsMemberPolicy,
        usernote: UserNotePolicy,
        userpasskey: UserPasskeyPolicy,
        userregistrationemail: UserRegistrationEmailPolicy,
        usertestimonial: UserTestimonialPolicy,
        websiteroute: WebsiteRoutePolicy,
        websiteroutesettings: WebsiteRouteSettingsPolicy,
        vendor: VendorPolicy,
        vendorarea: VendorAreaPolicy,
        vendorcategory: VendorCategoryPolicy,
        vendorreview: VendorReviewPolicy
      };

      var key = typeof record === 'string' ? record : record.constructor.name.toLowerCase();

      if (!_Object$keys(map).includes(key)) {
        throw new Error('Related policy ("' + key + '") could not be found.');
      }

      var args = [user];

      args.push((typeof record === 'undefined' ? 'undefined' : _typeof(record)) === 'object' && record.exists() ? record : null);
      args.push(related);

      return new (Function.prototype.bind.apply(map[key], [null].concat(args)))();
    }
  }]);

  return PolicyFactory;
}();

var UserActivityIndex = function (_AbstractIndex) {
  _inherits(UserActivityIndex, _AbstractIndex);

  function UserActivityIndex() {
    _classCallCheck(this, UserActivityIndex);

    return _possibleConstructorReturn(this, (UserActivityIndex.__proto__ || _Object$getPrototypeOf(UserActivityIndex)).apply(this, arguments));
  }

  _createClass(UserActivityIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return 'users/' + params.user_id + '/activities';
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        created_after: {
          type: Date
        },
        created_before: {
          type: Date
        },
        type: {
          type: String
        }
      };
    }
  }]);

  return UserActivityIndex;
}(AbstractIndex);

var UserCustomActivity = function (_AbstractModel) {
  _inherits(UserCustomActivity, _AbstractModel);

  function UserCustomActivity() {
    _classCallCheck(this, UserCustomActivity);

    return _possibleConstructorReturn(this, (UserCustomActivity.__proto__ || _Object$getPrototypeOf(UserCustomActivity)).apply(this, arguments));
  }

  _createClass(UserCustomActivity, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/:user_id/custom_activities';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        description: null,
        title: null,
        type: null,
        user_id: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return UserCustomActivity;
}(AbstractModel);

var UserHotsheet = function (_AbstractModel) {
  _inherits(UserHotsheet, _AbstractModel);

  function UserHotsheet() {
    _classCallCheck(this, UserHotsheet);

    return _possibleConstructorReturn(this, (UserHotsheet.__proto__ || _Object$getPrototypeOf(UserHotsheet)).apply(this, arguments));
  }

  _createClass(UserHotsheet, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/:user_id/hotsheets';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null,
        query_string: null,
        send_email: true,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return UserHotsheet;
}(AbstractModel);

var UserMlsMember = function (_AbstractModel) {
  _inherits(UserMlsMember, _AbstractModel);

  function UserMlsMember() {
    _classCallCheck(this, UserMlsMember);

    return _possibleConstructorReturn(this, (UserMlsMember.__proto__ || _Object$getPrototypeOf(UserMlsMember)).apply(this, arguments));
  }

  _createClass(UserMlsMember, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return 'users/:user_id/mls_members';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        job_title: null,
        media: [],
        member_mls_access_y_n: null,
        member_address1: null,
        member_address2: null,
        member_aor: null,
        member_aor_key: null,
        member_aor_mls_id: null,
        member_association_comments: null,
        member_carrier_route: null,
        member_city: null,
        member_country: null,
        member_county_or_parish: null,
        member_designation: null,
        member_direct_phone: null,
        member_email: null,
        member_fax: null,
        member_first_name: null,
        member_full_name: null,
        member_home_phone: null,
        member_is_assistant_to: null,
        member_languages: null,
        member_last_name: null,
        member_login_id: null,
        member_middle_name: null,
        member_mls_id: null,
        member_mls_security_class: null,
        member_mobile_phone: null,
        member_name_prefix: null,
        member_name_suffix: null,
        member_national_association_id: null,
        member_nickname: null,
        member_office_phone: null,
        member_office_phone_ext: null,
        member_pager: null,
        member_phone_ttytdd: null,
        member_postal_code: null,
        member_postal_code_plus4: null,
        member_preferred_phone: null,
        member_preferred_phone_ext: null,
        member_state_license: null,
        member_state_license_state: null,
        member_state_or_province: null,
        member_status: null,
        member_toll_free_phone: null,
        member_type: null,
        member_voice_mail: null,
        member_voic_email_ext: null,
        office_key: null,
        originating_system_id: null,
        originating_system_member_key: null,
        originating_system_name: null,
        social_media: [],
        source_system_id: null,
        source_system_member_key: null,
        source_system_name: null,
        syndicate_to: null,
        user_id: null
      };
    }
  }]);

  return UserMlsMember;
}(AbstractModel);

var UserSuggestionIndex = function (_AbstractIndex) {
  _inherits(UserSuggestionIndex, _AbstractIndex);

  function UserSuggestionIndex() {
    _classCallCheck(this, UserSuggestionIndex);

    return _possibleConstructorReturn(this, (UserSuggestionIndex.__proto__ || _Object$getPrototypeOf(UserSuggestionIndex)).apply(this, arguments));
  }

  _createClass(UserSuggestionIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      return 'users/suggestions';
    }
  }]);

  return UserSuggestionIndex;
}(AbstractIndex);

var UserTestimonial = function (_AbstractModel) {
  _inherits(UserTestimonial, _AbstractModel);

  function UserTestimonial() {
    _classCallCheck(this, UserTestimonial);

    return _possibleConstructorReturn(this, (UserTestimonial.__proto__ || _Object$getPrototypeOf(UserTestimonial)).apply(this, arguments));
  }

  _createClass(UserTestimonial, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/:user_id/testimonials';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        user_id: null,
        client: null,
        body: null,
        source: null,
        transaction_date: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return UserTestimonial;
}(AbstractModel);

var User = function (_AbstractModel) {
  _inherits(User, _AbstractModel);

  function User() {
    _classCallCheck(this, User);

    return _possibleConstructorReturn(this, (User.__proto__ || _Object$getPrototypeOf(User)).apply(this, arguments));
  }

  _createClass(User, [{
    key: 'activitiesIndex',


    /** @return {Promise<any>} */
    value: function activitiesIndex() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return UserActivityIndex.search(_Object$assign({ user_id: this.id }, args));
    }

    /** @return {Promise<any>} */

  }, {
    key: 'contactSyncs',
    value: function contactSyncs() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return UserContactSync.search(_Object$assign({ user_id: this.id }, args));
    }

    /** @return {Promise<any>} */

  }, {
    key: 'customActivities',
    value: function customActivities() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return UserCustomActivity.search(_Object$assign({ user_id: this.id }, args));
    }

    /** @return {string} */

  }, {
    key: 'getFullName',
    value: function getFullName() {
      return ((this.first_name ? String(this.first_name).trim() : '') + ' ' + (this.last_name ? String(this.last_name).trim() : '')).trim();
    }

    /** @return {string} */

  }, {
    key: 'getName',
    value: function getName() {
      return typeof this.display_name === 'string' && this.display_name.trim().length ? String(this.display_name).trim() : this.getFullName();
    }

    /** @return {boolean} */

  }, {
    key: 'hasPermissionTo',
    value: function hasPermissionTo(action, record) {
      var related = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return PolicyFactory.create(this, record, related)[action]();
    }

    /** @return {Promise<any>} */

  }, {
    key: 'hotsheets',
    value: function hotsheets() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return UserHotsheet.search(_Object$assign({ user_id: this.id }, args));
    }

    /** @return {Promise<any>} */

  }, {
    key: 'mlsMembers',
    value: function mlsMembers() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return UserMlsMember.search(_Object$assign({ user_id: this.id }, args));
    }

    /** @return {Promise<any>} */

  }, {
    key: 'notes',
    value: function notes() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return UserNote.search(_Object$assign({ user_id: this.id }, args));
    }

    /** @return {Promise<any>} */

  }, {
    key: 'testimonials',
    value: function testimonials() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return UserTestimonial.search(_Object$assign({ user_id: this.id }, args));
    }
  }], [{
    key: 'suggestions',


    /** @return {UserSuggestionIndex} */
    value: function suggestions() {
      return UserSuggestionIndex;
    }
  }, {
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        additional_email_addresses: [],
        addresses: [],
        agent_type: null,
        biography: null,
        board_data: {},
        commission_split: null,
        custom_identifiers: [],
        custom_fields: {},
        designations: [],
        display_name: null,
        display_on_web: true,
        email: null,
        email_signature: null,
        email_verified: false,
        emergency_contact: {},
        facts: [],
        first_name: null,
        gender: null,
        id: null,
        important_dates: [],
        job_title: null,
        languages: [],
        last_name: null,
        licenses: [],
        mls_ids: [],
        mls_member: null,
        oauth_identities: [],
        offices: [],
        office_ids: [],
        password: null,
        pets: [],
        phone_numbers: [],
        photos: [],
        realtor: null,
        relatives: [],
        resources: [],
        role: null,
        skip_email: null,
        sponsor_user_id: null,
        sponsorship: {
          sponsored_users_total: null,
          sponsor_user: null,
          sponsored_users: []
        },
        teams: [],
        title: null,
        urls: [],
        website: null,
        website_id: null
      };
    }

    /** @type {object} */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {
        offices: 'office_ids'
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        address: 'addresses',
        phone_number: 'phone_numbers',
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        'sponsorship.sponsor_user': 'sponsor_user_id',
        website: 'website_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        city: {
          type: String
        },
        designation: {
          commaSeparatedSupport: true,
          type: String
        },
        display_on_web: {
          type: Boolean
        },
        email: {
          type: String
        },
        has_biography: {
          type: Boolean
        },
        has_primary_photo: {
          type: Boolean
        },
        id: {
          commaSeparatedSupport: true,
          model: User,
          type: Number
        },
        is_deleted: {
          type: Boolean
        },
        language: {
          commaSeparatedSupport: true,
          type: String
        },
        max_ams_member_balance: {
          type: Number
        },
        max_sponsored_users_count: {
          type: Number
        },
        member_status: {
          commaSeparatedSupport: true,
          type: String
        },
        member_type: {
          commaSeparatedSupport: true,
          type: String
        },
        min_ams_member_balance: {
          type: Number
        },
        min_sponsored_users_count: {
          type: Number
        },
        mls_id: {
          commaSeparatedSupport: true,
          type: String
        },
        mls_member: {
          type: Boolean
        },
        name: {
          type: String
        },
        office_id: {
          commaSeparatedSupport: true,
          model: Office,
          type: Number
        },
        phone_number: {
          type: String
        },
        realtor: {
          type: Boolean
        },
        region_id: {
          commaSeparatedSupport: true,
          model: Region,
          type: Number
        },
        role: {
          commaSeparatedSupport: true,
          type: String
        },
        sponsor_user_id: {
          model: User,
          type: Number
        },
        state: {
          type: String
        },
        zip: {
          type: String
        }
      };
    }
  }]);

  return User;
}(AbstractModel);

var ContactGroup = function (_AbstractModel) {
  _inherits(ContactGroup, _AbstractModel);

  function ContactGroup() {
    _classCallCheck(this, ContactGroup);

    return _possibleConstructorReturn(this, (ContactGroup.__proto__ || _Object$getPrototypeOf(ContactGroup)).apply(this, arguments));
  }

  _createClass(ContactGroup, [{
    key: 'exists',


    /** @return {boolean} */
    value: function exists() {
      return !!this.created_at;
    }

    /** @return {string} */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'getNestedItemPrimaryKey',
    value: function getNestedItemPrimaryKey(nestedItemPath) {
      if (nestedItemPath.match(/^members\[(\d+|\?)\]$/)) {
        return 'contact_id';
      }

      return 'id';
    }
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/group';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        addresses: [],
        name: null,
        members: [],
        user: Container.getInstance().resolve(User),
        user_id: null
      };
    }

    /** @type {string} */

  }, {
    key: 'PRIMARY_KEY',
    get: function get() {
      return null;
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        address: 'addresses'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        user: User
      };
    }
  }]);

  return ContactGroup;
}(AbstractModel);

var ContactMarketUpdate = function (_AbstractModel) {
  _inherits(ContactMarketUpdate, _AbstractModel);

  function ContactMarketUpdate() {
    _classCallCheck(this, ContactMarketUpdate);

    return _possibleConstructorReturn(this, (ContactMarketUpdate.__proto__ || _Object$getPrototypeOf(ContactMarketUpdate)).apply(this, arguments));
  }

  _createClass(ContactMarketUpdate, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/market_updates';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        contact_id: null,
        name: null,
        list_unsubscribed: false,
        query_string: null,
        send_email: true
      };
    }
  }]);

  return ContactMarketUpdate;
}(AbstractModel);

var ContactSavedSearch = function (_AbstractModel) {
  _inherits(ContactSavedSearch, _AbstractModel);

  function ContactSavedSearch() {
    _classCallCheck(this, ContactSavedSearch);

    return _possibleConstructorReturn(this, (ContactSavedSearch.__proto__ || _Object$getPrototypeOf(ContactSavedSearch)).apply(this, arguments));
  }

  _createClass(ContactSavedSearch, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/saved_searches';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        cc_user: false,
        id: null,
        contact_id: null,
        list_unsubscribed: false,
        name: null,
        query_string: null,
        send_email: true,
        send_immediately: false
      };
    }
  }]);

  return ContactSavedSearch;
}(AbstractModel);

var ContactSuggestionIndex = function (_AbstractIndex) {
  _inherits(ContactSuggestionIndex, _AbstractIndex);

  function ContactSuggestionIndex() {
    _classCallCheck(this, ContactSuggestionIndex);

    return _possibleConstructorReturn(this, (ContactSuggestionIndex.__proto__ || _Object$getPrototypeOf(ContactSuggestionIndex)).apply(this, arguments));
  }

  _createClass(ContactSuggestionIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      return 'contacts/suggestions';
    }
  }]);

  return ContactSuggestionIndex;
}(AbstractIndex);

var Contact = function (_AbstractModel) {
  _inherits(Contact, _AbstractModel);

  function Contact() {
    _classCallCheck(this, Contact);

    return _possibleConstructorReturn(this, (Contact.__proto__ || _Object$getPrototypeOf(Contact)).apply(this, arguments));
  }

  _createClass(Contact, [{
    key: 'activitiesIndex',


    /** @return {Promise<any>} */
    value: function activitiesIndex() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return ContactActivityIndex.search(_Object$assign({ contact_id: this.id }, args));
    }

    /** @return {boolean} */

  }, {
    key: 'belongsToContactGroup',
    value: function belongsToContactGroup() {
      return this.contact_group.exists();
    }

    /** @return {Promise<any>} */

  }, {
    key: 'customActivities',
    value: function customActivities() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return ContactCustomActivity.search(_Object$assign({ contact_id: this.id }, args));
    }

    /** @return {Promise<any>} */

  }, {
    key: 'emailsIndex',
    value: function emailsIndex() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return ContactEmailIndex.search(_Object$assign({ contact_id: this.id }, args));
    }

    /** @return {string} */

  }, {
    key: 'getFullName',
    value: function getFullName() {
      return ((this.first_name ? String(this.first_name).trim() : '') + ' ' + (this.last_name ? String(this.last_name).trim() : '')).trim();
    }

    /** @return {string} */

  }, {
    key: 'getName',
    value: function getName() {
      return typeof this.display_name === 'string' && this.display_name.trim().length ? String(this.display_name).trim() : this.getFullName();
    }

    /** @return {Promise<any>} */

  }, {
    key: 'marketUpdates',
    value: function marketUpdates() {
      var _this2 = this;

      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return ContactMarketUpdate.search(_Object$assign({ contact_id: this.id }, args)).then(function (items) {
        var total = items.total;


        items.map(function (item) {
          // eslint-disable-next-line no-param-reassign
          item.contact_id = _this2.id;
          return item;
        });

        // eslint-disable-next-line no-param-reassign
        items.total = total;

        return items;
      });
    }

    /** @return {Promise<any>} */

  }, {
    key: 'notes',
    value: function notes() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return ContactNote.search(_Object$assign({ contact_id: this.id }, args));
    }

    /** @return {Promise<any>} */

  }, {
    key: 'savedSearches',
    value: function savedSearches() {
      var _this3 = this;

      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return ContactSavedSearch.search(_Object$assign({ contact_id: this.id }, args)).then(function (items) {
        var total = items.total;


        items.map(function (item) {
          // eslint-disable-next-line no-param-reassign
          item.contact_id = _this3.id;
          return item;
        });

        // eslint-disable-next-line no-param-reassign
        items.total = total;

        return items;
      });
    }
  }], [{
    key: 'suggestions',


    /** @return {ContactSuggestionIndex} */
    value: function suggestions() {
      return ContactSuggestionIndex;
    }
  }, {
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        additional_email_addresses: [],
        addresses: [],
        channel: null,
        company: null,
        company_generated: null,
        contact_group: Container.getInstance().resolve(ContactGroup),
        credit_range: null,
        deleted_at: null,
        display_name: null,
        email: null,
        first_name: null,
        id: null,
        important_dates: [],
        jwt: null,
        last_contacted_at: null,
        last_name: null,
        login: null,
        military: null,
        miscellany: null,
        password: null,
        phone_numbers: [],
        photos: [],
        rating: null,
        referred_by: null,
        referral_fee_applies: null,
        registration_property_id: null,
        relatives: [],
        relocation: null,
        source: null,
        skip_email: null,
        status: null,
        tags: [],
        tag_ids: [],
        title: null,
        urls: [],
        user: Container.getInstance().resolve(User),
        user_id: null,
        vow_approved: null
      };
    }

    /** @type {boolean} */

  }, {
    key: 'HAS_SCROLL_SUPPORT',
    get: function get() {
      return true;
    }

    /** @type {number} */

  }, {
    key: 'PER_PAGE_MAX',
    get: function get() {
      return 500;
    }

    /** @type {object} */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {
        tags: 'tag_ids'
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        address: 'addresses',
        phone_number: 'phone_numbers',
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        contact_group: ContactGroup,
        tags: Tag,
        user: User
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        all_tag_ids: {
          commaSeparatedSupport: true,
          model: Tag,
          type: Number
        },
        channel: {
          type: String
        },
        city: {
          type: String
        },
        company_generated: {
          type: Boolean
        },
        created_after: {
          type: Date
        },
        created_before: {
          type: Date
        },
        credit_range: {
          commaSeparatedSupport: true,
          type: String
        },
        email: {
          type: String
        },
        id: {
          commaSeparatedSupport: true,
          type: Number
        },
        is_deleted: {
          type: Boolean
        },
        has_email: {
          type: Boolean
        },
        has_group: {
          type: Boolean
        },
        has_phone_number: {
          type: Boolean
        },
        last_active_after: {
          type: Date
        },
        last_active_before: {
          type: Date
        },
        max_market_updates_count: {
          type: Number
        },
        max_saved_searches_count: {
          type: Number
        },
        military: {
          type: Boolean
        },
        min_market_updates_count: {
          type: Number
        },
        min_saved_searches_count: {
          type: Number
        },
        name: {
          type: String
        },
        next_contact_within: {
          type: Number
        },
        not_tag_ids: {
          commaSeparatedSupport: true,
          model: Tag,
          type: Number
        },
        phone_number: {
          type: String
        },
        referral_fee_applies: {
          type: Boolean
        },
        relocation: {
          type: Boolean
        },
        source: {
          type: String
        },
        state: {
          type: String
        },
        street_address: {
          type: String
        },
        tag_id: {
          commaSeparatedSupport: true,
          model: Tag,
          type: Number
        },
        updated_after: {
          type: Date
        },
        updated_before: {
          type: Date
        },
        user_assigned: {
          type: Boolean
        },
        user_id: {
          model: User,
          type: Number
        },
        zip: {
          type: String
        }
      };
    }
  }]);

  return Contact;
}(AbstractModel);

var BlastSubscriptionIndex = function (_AbstractIndex) {
  _inherits(BlastSubscriptionIndex, _AbstractIndex);

  function BlastSubscriptionIndex() {
    _classCallCheck(this, BlastSubscriptionIndex);

    return _possibleConstructorReturn(this, (BlastSubscriptionIndex.__proto__ || _Object$getPrototypeOf(BlastSubscriptionIndex)).apply(this, arguments));
  }

  _createClass(BlastSubscriptionIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return 'blasts/' + params.blast_id + '/subscriptions';
    }

    /** @var {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        contact: Contact
      };
    }
  }]);

  return BlastSubscriptionIndex;
}(AbstractIndex);

var DripCampaignSubscriptionIndex = function (_AbstractIndex) {
  _inherits(DripCampaignSubscriptionIndex, _AbstractIndex);

  function DripCampaignSubscriptionIndex() {
    _classCallCheck(this, DripCampaignSubscriptionIndex);

    return _possibleConstructorReturn(this, (DripCampaignSubscriptionIndex.__proto__ || _Object$getPrototypeOf(DripCampaignSubscriptionIndex)).apply(this, arguments));
  }

  _createClass(DripCampaignSubscriptionIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return 'drip_campaigns/' + params.drip_campaign_id + '/subscriptions';
    }

    /** @var {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        contact: Contact
      };
    }
  }]);

  return DripCampaignSubscriptionIndex;
}(AbstractIndex);

var OAuthAppIndex = function (_AbstractIndex) {
  _inherits(OAuthAppIndex, _AbstractIndex);

  function OAuthAppIndex() {
    _classCallCheck(this, OAuthAppIndex);

    return _possibleConstructorReturn(this, (OAuthAppIndex.__proto__ || _Object$getPrototypeOf(OAuthAppIndex)).apply(this, arguments));
  }

  _createClass(OAuthAppIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      return 'oauth_apps';
    }
  }]);

  return OAuthAppIndex;
}(AbstractIndex);

var SsoAppIndex = function (_AbstractIndex) {
  _inherits(SsoAppIndex, _AbstractIndex);

  function SsoAppIndex() {
    _classCallCheck(this, SsoAppIndex);

    return _possibleConstructorReturn(this, (SsoAppIndex.__proto__ || _Object$getPrototypeOf(SsoAppIndex)).apply(this, arguments));
  }

  _createClass(SsoAppIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      return 'sso_apps';
    }
  }]);

  return SsoAppIndex;
}(AbstractIndex);

var TagSuggestionIndex = function (_AbstractIndex) {
  _inherits(TagSuggestionIndex, _AbstractIndex);

  function TagSuggestionIndex() {
    _classCallCheck(this, TagSuggestionIndex);

    return _possibleConstructorReturn(this, (TagSuggestionIndex.__proto__ || _Object$getPrototypeOf(TagSuggestionIndex)).apply(this, arguments));
  }

  _createClass(TagSuggestionIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      return 'tags/suggestions';
    }
  }]);

  return TagSuggestionIndex;
}(AbstractIndex);

var UserContactSyncProviderGroupIndex = function (_AbstractIndex) {
  _inherits(UserContactSyncProviderGroupIndex, _AbstractIndex);

  function UserContactSyncProviderGroupIndex() {
    _classCallCheck(this, UserContactSyncProviderGroupIndex);

    return _possibleConstructorReturn(this, (UserContactSyncProviderGroupIndex.__proto__ || _Object$getPrototypeOf(UserContactSyncProviderGroupIndex)).apply(this, arguments));
  }

  _createClass(UserContactSyncProviderGroupIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return '/users/' + params.user_id + '/contact_syncs/provider_groups';
    }
  }]);

  return UserContactSyncProviderGroupIndex;
}(AbstractIndex);

var WebsiteSuggestionIndex = function (_AbstractIndex) {
  _inherits(WebsiteSuggestionIndex, _AbstractIndex);

  function WebsiteSuggestionIndex() {
    _classCallCheck(this, WebsiteSuggestionIndex);

    return _possibleConstructorReturn(this, (WebsiteSuggestionIndex.__proto__ || _Object$getPrototypeOf(WebsiteSuggestionIndex)).apply(this, arguments));
  }

  _createClass(WebsiteSuggestionIndex, null, [{
    key: 'BASE_URI',

    /** @return {string} */
    value: function BASE_URI() {
      return 'websites/suggestions';
    }
  }]);

  return WebsiteSuggestionIndex;
}(AbstractIndex);

var contacts = {
  total: 5,
  results: [{
    id: 1,
    user_id: null,
    email: 'test@example.com',
    title: 'Sr.',
    first_name: 'John',
    last_name: 'Doe',
    display_name: 'John Doe Sr.',
    company: 'Acme',
    relocation: null,
    military: null,
    source: null,
    channel: null,
    referred_by: null,
    credit_range: null,
    rating: null,
    status: null,
    miscellany: null,
    created_at: '2018-03-19T20:44:57.569Z',
    updated_at: '2018-03-19T20:44:57.569Z',
    additional_email_addresses: [],
    addresses: [],
    important_dates: [{
      date: '1970-05-11T00:00:00.000Z',
      id: 2,
      type: 'Birthday'
    }],
    phone_numbers: [],
    relatives: [],
    urls: []
  }, {
    id: 2,
    user_id: 1,
    email: 'angela.martin@gmail.com',
    title: 'Ms.',
    first_name: 'Angela',
    last_name: 'Martin',
    display_name: 'Ms. Angela Martin',
    company: 'Dunder Mifflin',
    relocation: null,
    military: null,
    source: null,
    channel: 'Zillow',
    referred_by: null,
    credit_range: null,
    rating: null,
    status: null,
    miscellany: null,
    created_at: '2018-03-27T15:13:58.885Z',
    updated_at: '2018-03-27T15:13:58.885Z',
    additional_email_addresses: [],
    addresses: [],
    important_dates: [],
    phone_numbers: [],
    relatives: [],
    urls: []
  }, {
    id: 3,
    user_id: 2,
    email: 'jim.halpert@live.com',
    title: 'Mr.',
    first_name: 'Jim',
    last_name: 'Halpert',
    display_name: 'Mr. Jim Halpert',
    company: 'Dunder Mifflin',
    relocation: null,
    military: null,
    source: null,
    channel: 'Sphere of Influence',
    referred_by: null,
    credit_range: null,
    rating: null,
    status: null,
    miscellany: null,
    created_at: '2018-03-27T15:15:16.506Z',
    updated_at: '2018-03-27T15:15:16.506Z',
    additional_email_addresses: [],
    addresses: [],
    important_dates: [],
    phone_numbers: [],
    relatives: [],
    urls: []
  }, {
    id: 4,
    user_id: 3,
    email: 'ann.perkins@gmail.com',
    title: 'Ms.',
    first_name: 'Ann',
    last_name: 'Perkins',
    display_name: 'Ms. Ann Perkins',
    company: 'Parks Department of Pawnee',
    relocation: null,
    military: null,
    source: null,
    channel: null,
    referred_by: null,
    credit_range: null,
    rating: null,
    status: null,
    miscellany: null,
    created_at: '2018-03-27T15:16:59.770Z',
    updated_at: '2018-03-27T15:16:59.770Z',
    additional_email_addresses: [],
    addresses: [],
    important_dates: [],
    phone_numbers: [],
    relatives: [],
    urls: []
  }, {
    id: 5,
    user_id: null,
    email: 'ron@pawneeindiana.com',
    title: 'Mr.',
    first_name: 'Ron',
    last_name: 'Swanson',
    display_name: 'Mr. Ron Swanson',
    company: 'Park District of Pawnee',
    relocation: null,
    military: null,
    source: null,
    channel: null,
    referred_by: null,
    credit_range: null,
    rating: null,
    status: null,
    miscellany: null,
    created_at: '2018-03-27T15:19:35.890Z',
    updated_at: '2018-03-27T15:19:35.890Z',
    additional_email_addresses: [],
    addresses: [],
    important_dates: [],
    phone_numbers: [],
    relatives: [],
    urls: []
  }]
};

function getContactsMock() {
  return cloneDeep_1(contacts);
}

function getContactMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(contacts.results[index]);
}

var contactActivities = {
  total: 7,
  results: [{
    type: 'property_search',
    created_at: '2018-10-15T17:47:00.495Z',
    resource: {
      query_string: 'source=User',
      created_at: '2018-10-15T17:47:00.495Z'
    }
  }, {
    type: 'property_favorite',
    created_at: '2018-10-15T17:39:21.899Z',
    resource: {
      id: 1,
      type: 'property_favorite',
      title: 'Property Favorite',
      description: '123 Fake St.',
      created_at: '2018-10-15T17:39:21.899Z',
      updated_at: '2018-10-15T17:39:21.899Z'
    }
  }, {
    type: 'property_rating',
    created_at: '2018-10-15T17:38:15.351Z',
    resource: {
      id: 1,
      rating: 5,
      created_at: '2018-10-15T17:38:15.351Z',
      updated_at: '2018-10-15T17:38:15.351Z',
      property: {
        id: 1,
        property_type: 'Commercial Lease',
        property_sub_type: 'Manufactured Home',
        property_universal_id: '418ca4be91f9035167f87a6141c54cf2',
        source: 'RETS',
        location: {
          address: {
            carrier_route: 'Vegetable Beer',
            city: 'Predovicfurt',
            country: 'United States',
            county_or_parish: 'Woodland Tower',
            postal_city: 'Wiegandtown',
            postal_code: '55216-6902',
            postal_code_plus_4: '1273',
            state_or_province: 'OH',
            street_additional_info: 'Sierra Nevada Bigfoot Barleywine Style Ale',
            street_dir_prefix: 'W',
            street_dir_suffix: 'SW',
            street_name: 'Kraig Green',
            street_number: '5',
            street_number_numeric: 5,
            street_suffix: 'Village',
            street_suffix_modifier: 'Olympic',
            township: '5526 - Brettanomyces lambicus',
            unit_number: '3576',
            unparsed_address: '2276 Dylan Locks'
          },
          area: {
            city_region: 'Triffid Nebula',
            continent_region: 'Omega Centauri',
            country_region: 'Sun',
            mls_area_major: 'Glapflap',
            mls_area_minor: 'Deimos',
            state_region: 'C',
            subdivision_name: 'Park Village'
          },
          gis: {
            cross_street: 'Chad Pike',
            directions: 'Come on baby, I\'m saying bing bang bloozy, you and me in the jacuzzi. Whassup?',
            elevation: 5,
            elevation_units: 'feet',
            latitude: '-23.432614625832443',
            longitude: '-61.758219258878',
            map_coordinate: '42 megaparsecs',
            map_coordinate_source: 'Hoba',
            map_url: 'http://schmeler.info/neal'
          },
          school: {
            elementary_school_district: 'New Directions Publishing',
            elementary_school: 'Jacob Have I Loved',
            high_school_district: 'Harvest House',
            high_school: 'Look to Windward',
            middle_or_junior_school_district: 'Adis International',
            middle_or_junior_school: 'The Proper Study'
          }
        },
        media: [{
          media_key: '1bec326e8df357e4999e08a8102fdb911',
          media_status: 'Active',
          modification_timestamp: '2018-09-13T04:36:18.000Z',
          media_type: 'rtf',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptates voluptatum eveniet corrupti cumque.',
          long_description: 'Cum eius eos quae. Pariatur molestiae saepe voluptates non illum. Sunt accusantium autem ut aut. Fugiat aut molestias unde quo asperiores. Cumque aut dolorem illum et nihil sit praesentium.\nIpsum non illum nemo sit atque unde. Voluptatem occaecati ullam voluptatem voluptatibus. Consectetur minus molestias voluptas autem distinctio. Rerum vel et. Commodi repellat ducimus at soluta ut qui quibusdam.\nUt aut numquam. Dicta rerum eum sit laborum hic deserunt. Quo esse soluta et tempore.'
        }, {
          media_key: '2e92894533e3e27c5dff30a9797a7d600',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-10T10:56:13.000Z',
          media_type: 'pdf',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Medium',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Omnis placeat voluptatem facere expedita at.',
          long_description: 'Consequatur est id. Iure dolorem amet fugit quibusdam adipisci numquam cupiditate. Sit optio nobis est.\nVitae harum autem quo placeat eius voluptatum quia. Ullam omnis voluptas. Officiis at ipsam sunt quod.\nAut animi et. Voluptatem sunt exercitationem. Fugiat in assumenda autem dignissimos beatae quam. Temporibus perferendis et asperiores.'
        }, {
          media_key: '3f006b1f87f04c24c52eb3ff2b41a8d58',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T02:14:43.000Z',
          media_type: 'jpeg',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'X-Large',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Soluta officia temporibus nulla id laudantium qui.',
          long_description: 'Dolor qui nihil eos. Et sit cupiditate. Repellat voluptas quisquam aspernatur ut quam quo ipsa. Eaque et delectus. Ut enim laborum.\nOptio consequatur praesentium non soluta. Laboriosam necessitatibus nihil harum aspernatur qui inventore rerum. Sint et quam repellendus iure veritatis aliquam.\nConsequuntur cumque doloremque aut. Esse voluptatem fugiat voluptas. Iure voluptas aut cum.'
        }, {
          media_key: '481a1a0512868cdbada7153ed8f87d491',
          media_status: 'Active',
          modification_timestamp: '2018-09-04T20:24:17.000Z',
          media_type: 'xls',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Totam qui aliquam aut fugiat aperiam.',
          long_description: 'Placeat est aperiam alias ut maxime amet. Nobis impedit est aut. Consequatur est aliquam quis quis dolorum.\nAccusantium vel aut dolor. Voluptas fugiat nihil minus. At quod velit excepturi doloribus fugit quia. Ex et magnam est placeat ut itaque qui. Officiis aperiam quasi aut facere.\nVoluptas rem voluptates commodi nihil repellat inventore. Pariatur molestiae impedit. Cumque est et itaque debitis et. Distinctio impedit natus placeat sit non. Accusamus illum eveniet provident qui quia.'
        }, {
          media_key: '556f44b9b2050f85b29eb0f56392b4f83',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-21T16:54:55.000Z',
          media_type: 'png',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores vitae quia quia totam rerum.',
          long_description: 'Minus consectetur sed. Voluptates itaque esse nemo labore officia eum est. Veniam pariatur recusandae rerum distinctio ipsum excepturi. Perferendis sunt nemo quo.\nRerum suscipit saepe et sit unde quam. Labore sunt voluptatibus dolores suscipit rerum id. Cupiditate quia sit id.\nCorporis laborum eos omnis. Qui soluta ipsum. Ipsam consequatur voluptas sit necessitatibus omnis ut.'
        }, {
          media_key: '6d89da516cdc4d67aafa255d504279643',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-12T20:28:49.000Z',
          media_type: 'txt',
          media_category: 'Office Photo',
          image_size_description: 'Thumbnail',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ipsam voluptatem omnis repudiandae molestiae quo dolor impedit.',
          long_description: 'Enim dolorem molestiae dignissimos ullam facilis amet expedita. Beatae ipsum quia rerum. Veniam voluptas velit dicta et.\nEum deserunt rerum dolorem dolores qui et. Adipisci distinctio numquam sint. Qui est et. Perspiciatis suscipit sunt omnis dicta facilis.\nLaborum rerum dolores. Suscipit est quis molestiae provident. Sed maiores laudantium molestiae. Nihil suscipit minima modi asperiores. Quos est laudantium earum aut.'
        }, {
          media_key: '74c0c056810d2fc16397812731922b7f9',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-20T05:56:50.000Z',
          media_type: 'rtf',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Consequatur praesentium dolore nulla ut.',
          long_description: 'Provident voluptate sit esse veritatis ipsa eum. Quae ullam quia. Et delectus illo officiis incidunt ut ut. Fugit ea laboriosam quidem voluptates.\nRepudiandae tenetur blanditiis ut esse. Qui aut ut repellat maxime harum perferendis. Consequatur rerum iusto sunt deleniti tempore. Vel consequatur expedita labore delectus.\nEt ducimus quod temporibus non repellat nisi aut. Necessitatibus omnis sequi. Quisquam recusandae velit quae.'
        }, {
          media_key: '82fe832d662eb7267e7b25748cb65d48e',
          media_status: 'Active',
          modification_timestamp: '2018-09-02T13:26:21.000Z',
          media_type: 'txt',
          media_category: 'Document',
          image_size_description: 'Thumbnail',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut iste voluptas suscipit quas reprehenderit sequi.',
          long_description: 'Modi non illo. Magni et facilis aliquid. Non sed soluta ea.\nQuasi nobis facere consectetur dolorem ipsam dolorum debitis. Sed accusamus aliquam ut eum. In autem ut magnam possimus aut nihil.\nAliquam qui qui autem nesciunt. Ut repellendus est. Et assumenda aliquid sequi.'
        }, {
          media_key: '94c9db4fc1291dc8bdf03e5517b009f70',
          media_status: 'Active',
          modification_timestamp: '2018-09-24T11:06:08.000Z',
          media_type: 'xls',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Optio sint eum nobis est.',
          long_description: 'Ea et pariatur placeat. Sint culpa sint. Modi illum veritatis atque ratione et.\nDolorem dicta numquam fugiat aut quidem et culpa. Vitae beatae temporibus corporis. Et harum veritatis laboriosam laborum. Cupiditate natus eum omnis aut. Molestias aut maxime aut aut.\nSunt magnam et aut rerum voluptatem. Repudiandae neque non aut sit eos eaque fuga. Omnis corporis esse incidunt. Iusto libero laboriosam aut.'
        }, {
          media_key: '105bf110d7008161c913db8bba00bef20c',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-06T11:51:00.000Z',
          media_type: 'txt',
          media_category: 'Floor Plan',
          image_size_description: 'Thumbnail',
          order: 15,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Velit modi aut fuga sapiente voluptas veritatis tempore.',
          long_description: 'Temporibus libero eum et quia recusandae. Consectetur distinctio qui illo. Vel dolorem sit.\nOdio quidem quia quam dolores voluptatibus possimus quo. Debitis sit libero dolores eligendi. Velit est asperiores aliquid fuga illum distinctio repudiandae. Animi cum ut impedit esse qui quia.\nOdit quae id. Reprehenderit fugiat distinctio labore dicta placeat. Quia et et. Ut soluta eos. Accusantium et odio.'
        }, {
          media_key: '110fc03d1a2534b1a73870ad3c9935311a',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T23:34:08.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Thumbnail',
          order: 20,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Animi non perspiciatis et rerum ducimus laboriosam fugiat magni.',
          long_description: 'Qui illum harum et. Cumque iusto numquam. Voluptatem commodi dolor tempore enim adipisci perspiciatis.\nFuga unde et. Alias aut excepturi voluptatibus voluptate et. Deleniti sit atque placeat dolore nam maxime molestias. Eligendi qui et vitae qui ad quis.\nQuo et architecto unde. Illo sed amet deleniti soluta tempore. Consequatur voluptatum repudiandae veniam. Molestiae qui voluptas et quae quis praesentium. Inventore odio odit molestiae aspernatur qui repellendus.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'X-Large',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '133f996d1bc5143bd6db770983ac43d557',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-22T17:49:22.000Z',
          media_type: 'mp4',
          media_category: 'Office Logo',
          image_size_description: 'Thumbnail',
          order: 13,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ducimus quidem quae ipsa enim officia quasi sed quis.',
          long_description: 'Eum explicabo nihil odio ipsa itaque at. Dolor neque perferendis aut corrupti. Corrupti commodi alias ad aliquid. Quas modi officia eaque aut quaerat nihil animi.\nNisi quia veritatis molestiae sequi. Quod quos molestiae quia. Vero distinctio ad beatae. Nihil est perferendis nemo distinctio.\nInventore modi et asperiores earum. Officiis et tempore officia. Et fugit qui. Praesentium et rerum alias quis tempore. Vitae aut praesentium maxime ex delectus.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '156433494c06c6e7346895024612480663',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-23T03:59:09.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Officiis perferendis voluptate modi corporis necessitatibus nostrum.',
          long_description: 'Voluptas reiciendis ut. Saepe est eos. Aut voluptatibus delectus numquam qui.\nIusto minima incidunt deserunt eos vel optio. Aliquam consequatur in magni. Quas at similique deleniti et officia quo. Natus nihil unde fugit. Sed sed aut ullam.\nVel voluptas nulla reiciendis deleniti. Quos enim est est omnis corrupti cupiditate reiciendis. Impedit quo soluta repudiandae. Sunt eos labore magnam qui sed quidem cum. Dolorum voluptatum facilis nobis beatae odit.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Large',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Small',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Large',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '19b9984cf2cf5f71e0dfc42b21dd04583d',
          media_status: 'Active',
          modification_timestamp: '2018-10-05T02:03:31.000Z',
          media_type: 'wmv',
          media_category: 'Agent Photo',
          image_size_description: 'Large',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Iste eaque velit et quibusdam et sit.',
          long_description: 'Quia dolor et corporis inventore. Voluptatem non quis consequatur architecto quia velit. Deserunt amet et dolores tempore sint voluptatibus. Alias deserunt dolore est labore. Nostrum pariatur beatae repellendus accusamus praesentium.\nDignissimos saepe et in qui. Quod sed voluptate. Velit tenetur aliquid adipisci. Quisquam quae quidem facere cumque nihil vitae explicabo.\nDicta ea est. Qui magni et rerum. Dolores qui qui delectus numquam ipsa id. Voluptates minus qui eveniet aut ducimus sit. Eum sint quisquam explicabo dolorum est nulla.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Large',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Large',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '3f006b1f87f04c24c52eb3ff2b41a8d58',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T02:14:43.000Z',
          media_type: 'jpeg',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Thumb',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Soluta officia temporibus nulla id laudantium qui.',
          long_description: 'Dolor qui nihil eos. Et sit cupiditate. Repellat voluptas quisquam aspernatur ut quam quo ipsa. Eaque et delectus. Ut enim laborum.\nOptio consequatur praesentium non soluta. Laboriosam necessitatibus nihil harum aspernatur qui inventore rerum. Sint et quam repellendus iure veritatis aliquam.\nConsequuntur cumque doloremque aut. Esse voluptatem fugiat voluptas. Iure voluptas aut cum.'
        }, {
          media_key: '74c0c056810d2fc16397812731922b7f9',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-20T05:56:50.000Z',
          media_type: 'rtf',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Consequatur praesentium dolore nulla ut.',
          long_description: 'Provident voluptate sit esse veritatis ipsa eum. Quae ullam quia. Et delectus illo officiis incidunt ut ut. Fugit ea laboriosam quidem voluptates.\nRepudiandae tenetur blanditiis ut esse. Qui aut ut repellat maxime harum perferendis. Consequatur rerum iusto sunt deleniti tempore. Vel consequatur expedita labore delectus.\nEt ducimus quod temporibus non repellat nisi aut. Necessitatibus omnis sequi. Quisquam recusandae velit quae.'
        }, {
          media_key: '2e92894533e3e27c5dff30a9797a7d600',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-10T10:56:13.000Z',
          media_type: 'pdf',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Largest',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Omnis placeat voluptatem facere expedita at.',
          long_description: 'Consequatur est id. Iure dolorem amet fugit quibusdam adipisci numquam cupiditate. Sit optio nobis est.\nVitae harum autem quo placeat eius voluptatum quia. Ullam omnis voluptas. Officiis at ipsam sunt quod.\nAut animi et. Voluptatem sunt exercitationem. Fugiat in assumenda autem dignissimos beatae quam. Temporibus perferendis et asperiores.'
        }, {
          media_key: '481a1a0512868cdbada7153ed8f87d491',
          media_status: 'Active',
          modification_timestamp: '2018-09-04T20:24:17.000Z',
          media_type: 'xls',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Totam qui aliquam aut fugiat aperiam.',
          long_description: 'Placeat est aperiam alias ut maxime amet. Nobis impedit est aut. Consequatur est aliquam quis quis dolorum.\nAccusantium vel aut dolor. Voluptas fugiat nihil minus. At quod velit excepturi doloribus fugit quia. Ex et magnam est placeat ut itaque qui. Officiis aperiam quasi aut facere.\nVoluptas rem voluptates commodi nihil repellat inventore. Pariatur molestiae impedit. Cumque est et itaque debitis et. Distinctio impedit natus placeat sit non. Accusamus illum eveniet provident qui quia.'
        }, {
          media_key: '556f44b9b2050f85b29eb0f56392b4f83',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-21T16:54:55.000Z',
          media_type: 'png',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores vitae quia quia totam rerum.',
          long_description: 'Minus consectetur sed. Voluptates itaque esse nemo labore officia eum est. Veniam pariatur recusandae rerum distinctio ipsum excepturi. Perferendis sunt nemo quo.\nRerum suscipit saepe et sit unde quam. Labore sunt voluptatibus dolores suscipit rerum id. Cupiditate quia sit id.\nCorporis laborum eos omnis. Qui soluta ipsum. Ipsam consequatur voluptas sit necessitatibus omnis ut.'
        }, {
          media_key: '156433494c06c6e7346895024612480663',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-23T03:59:09.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Officiis perferendis voluptate modi corporis necessitatibus nostrum.',
          long_description: 'Voluptas reiciendis ut. Saepe est eos. Aut voluptatibus delectus numquam qui.\nIusto minima incidunt deserunt eos vel optio. Aliquam consequatur in magni. Quas at similique deleniti et officia quo. Natus nihil unde fugit. Sed sed aut ullam.\nVel voluptas nulla reiciendis deleniti. Quos enim est est omnis corrupti cupiditate reiciendis. Impedit quo soluta repudiandae. Sunt eos labore magnam qui sed quidem cum. Dolorum voluptatum facilis nobis beatae odit.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Thumb',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Largest',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Thumb',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Largest',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Thumb',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Largest',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Thumb',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Largest',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Thumb',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Largest',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }]
      }
    }
  }, {
    type: 'saved_search',
    created_at: '2018-10-15T17:36:35.993Z',
    resource: {
      id: 1,
      name: 'MLS',
      query_string: 'source=RETS',
      created_at: '2018-10-15T17:36:35.993Z',
      updated_at: '2018-10-15T17:36:35.993Z'
    }
  }, {
    type: 'property_view',
    created_at: '2018-10-15T17:22:13.981Z',
    resource: {
      created_at: '2018-10-15T17:22:13.981Z',
      property: {
        id: 1,
        property_type: 'Commercial Lease',
        property_sub_type: 'Manufactured Home',
        property_universal_id: '418ca4be91f9035167f87a6141c54cf2',
        source: 'RETS',
        location: {
          address: {
            carrier_route: 'Vegetable Beer',
            city: 'Predovicfurt',
            country: 'United States',
            county_or_parish: 'Woodland Tower',
            postal_city: 'Wiegandtown',
            postal_code: '55216-6902',
            postal_code_plus_4: '1273',
            state_or_province: 'OH',
            street_additional_info: 'Sierra Nevada Bigfoot Barleywine Style Ale',
            street_dir_prefix: 'W',
            street_dir_suffix: 'SW',
            street_name: 'Kraig Green',
            street_number: '5',
            street_number_numeric: 5,
            street_suffix: 'Village',
            street_suffix_modifier: 'Olympic',
            township: '5526 - Brettanomyces lambicus',
            unit_number: '3576',
            unparsed_address: '2276 Dylan Locks'
          },
          area: {
            city_region: 'Triffid Nebula',
            continent_region: 'Omega Centauri',
            country_region: 'Sun',
            mls_area_major: 'Glapflap',
            mls_area_minor: 'Deimos',
            state_region: 'C',
            subdivision_name: 'Park Village'
          },
          gis: {
            cross_street: 'Chad Pike',
            directions: 'Come on baby, I\'m saying bing bang bloozy, you and me in the jacuzzi. Whassup?',
            elevation: 5,
            elevation_units: 'feet',
            latitude: '-23.432614625832443',
            longitude: '-61.758219258878',
            map_coordinate: '42 megaparsecs',
            map_coordinate_source: 'Hoba',
            map_url: 'http://schmeler.info/neal'
          },
          school: {
            elementary_school_district: 'New Directions Publishing',
            elementary_school: 'Jacob Have I Loved',
            high_school_district: 'Harvest House',
            high_school: 'Look to Windward',
            middle_or_junior_school_district: 'Adis International',
            middle_or_junior_school: 'The Proper Study'
          }
        },
        media: [{
          media_key: '1bec326e8df357e4999e08a8102fdb911',
          media_status: 'Active',
          modification_timestamp: '2018-09-13T04:36:18.000Z',
          media_type: 'rtf',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptates voluptatum eveniet corrupti cumque.',
          long_description: 'Cum eius eos quae. Pariatur molestiae saepe voluptates non illum. Sunt accusantium autem ut aut. Fugiat aut molestias unde quo asperiores. Cumque aut dolorem illum et nihil sit praesentium.\nIpsum non illum nemo sit atque unde. Voluptatem occaecati ullam voluptatem voluptatibus. Consectetur minus molestias voluptas autem distinctio. Rerum vel et. Commodi repellat ducimus at soluta ut qui quibusdam.\nUt aut numquam. Dicta rerum eum sit laborum hic deserunt. Quo esse soluta et tempore.'
        }, {
          media_key: '2e92894533e3e27c5dff30a9797a7d600',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-10T10:56:13.000Z',
          media_type: 'pdf',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Medium',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Omnis placeat voluptatem facere expedita at.',
          long_description: 'Consequatur est id. Iure dolorem amet fugit quibusdam adipisci numquam cupiditate. Sit optio nobis est.\nVitae harum autem quo placeat eius voluptatum quia. Ullam omnis voluptas. Officiis at ipsam sunt quod.\nAut animi et. Voluptatem sunt exercitationem. Fugiat in assumenda autem dignissimos beatae quam. Temporibus perferendis et asperiores.'
        }, {
          media_key: '3f006b1f87f04c24c52eb3ff2b41a8d58',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T02:14:43.000Z',
          media_type: 'jpeg',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'X-Large',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Soluta officia temporibus nulla id laudantium qui.',
          long_description: 'Dolor qui nihil eos. Et sit cupiditate. Repellat voluptas quisquam aspernatur ut quam quo ipsa. Eaque et delectus. Ut enim laborum.\nOptio consequatur praesentium non soluta. Laboriosam necessitatibus nihil harum aspernatur qui inventore rerum. Sint et quam repellendus iure veritatis aliquam.\nConsequuntur cumque doloremque aut. Esse voluptatem fugiat voluptas. Iure voluptas aut cum.'
        }, {
          media_key: '481a1a0512868cdbada7153ed8f87d491',
          media_status: 'Active',
          modification_timestamp: '2018-09-04T20:24:17.000Z',
          media_type: 'xls',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Totam qui aliquam aut fugiat aperiam.',
          long_description: 'Placeat est aperiam alias ut maxime amet. Nobis impedit est aut. Consequatur est aliquam quis quis dolorum.\nAccusantium vel aut dolor. Voluptas fugiat nihil minus. At quod velit excepturi doloribus fugit quia. Ex et magnam est placeat ut itaque qui. Officiis aperiam quasi aut facere.\nVoluptas rem voluptates commodi nihil repellat inventore. Pariatur molestiae impedit. Cumque est et itaque debitis et. Distinctio impedit natus placeat sit non. Accusamus illum eveniet provident qui quia.'
        }, {
          media_key: '556f44b9b2050f85b29eb0f56392b4f83',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-21T16:54:55.000Z',
          media_type: 'png',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores vitae quia quia totam rerum.',
          long_description: 'Minus consectetur sed. Voluptates itaque esse nemo labore officia eum est. Veniam pariatur recusandae rerum distinctio ipsum excepturi. Perferendis sunt nemo quo.\nRerum suscipit saepe et sit unde quam. Labore sunt voluptatibus dolores suscipit rerum id. Cupiditate quia sit id.\nCorporis laborum eos omnis. Qui soluta ipsum. Ipsam consequatur voluptas sit necessitatibus omnis ut.'
        }, {
          media_key: '6d89da516cdc4d67aafa255d504279643',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-12T20:28:49.000Z',
          media_type: 'txt',
          media_category: 'Office Photo',
          image_size_description: 'Thumbnail',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ipsam voluptatem omnis repudiandae molestiae quo dolor impedit.',
          long_description: 'Enim dolorem molestiae dignissimos ullam facilis amet expedita. Beatae ipsum quia rerum. Veniam voluptas velit dicta et.\nEum deserunt rerum dolorem dolores qui et. Adipisci distinctio numquam sint. Qui est et. Perspiciatis suscipit sunt omnis dicta facilis.\nLaborum rerum dolores. Suscipit est quis molestiae provident. Sed maiores laudantium molestiae. Nihil suscipit minima modi asperiores. Quos est laudantium earum aut.'
        }, {
          media_key: '74c0c056810d2fc16397812731922b7f9',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-20T05:56:50.000Z',
          media_type: 'rtf',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Consequatur praesentium dolore nulla ut.',
          long_description: 'Provident voluptate sit esse veritatis ipsa eum. Quae ullam quia. Et delectus illo officiis incidunt ut ut. Fugit ea laboriosam quidem voluptates.\nRepudiandae tenetur blanditiis ut esse. Qui aut ut repellat maxime harum perferendis. Consequatur rerum iusto sunt deleniti tempore. Vel consequatur expedita labore delectus.\nEt ducimus quod temporibus non repellat nisi aut. Necessitatibus omnis sequi. Quisquam recusandae velit quae.'
        }, {
          media_key: '82fe832d662eb7267e7b25748cb65d48e',
          media_status: 'Active',
          modification_timestamp: '2018-09-02T13:26:21.000Z',
          media_type: 'txt',
          media_category: 'Document',
          image_size_description: 'Thumbnail',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut iste voluptas suscipit quas reprehenderit sequi.',
          long_description: 'Modi non illo. Magni et facilis aliquid. Non sed soluta ea.\nQuasi nobis facere consectetur dolorem ipsam dolorum debitis. Sed accusamus aliquam ut eum. In autem ut magnam possimus aut nihil.\nAliquam qui qui autem nesciunt. Ut repellendus est. Et assumenda aliquid sequi.'
        }, {
          media_key: '94c9db4fc1291dc8bdf03e5517b009f70',
          media_status: 'Active',
          modification_timestamp: '2018-09-24T11:06:08.000Z',
          media_type: 'xls',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Optio sint eum nobis est.',
          long_description: 'Ea et pariatur placeat. Sint culpa sint. Modi illum veritatis atque ratione et.\nDolorem dicta numquam fugiat aut quidem et culpa. Vitae beatae temporibus corporis. Et harum veritatis laboriosam laborum. Cupiditate natus eum omnis aut. Molestias aut maxime aut aut.\nSunt magnam et aut rerum voluptatem. Repudiandae neque non aut sit eos eaque fuga. Omnis corporis esse incidunt. Iusto libero laboriosam aut.'
        }, {
          media_key: '105bf110d7008161c913db8bba00bef20c',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-06T11:51:00.000Z',
          media_type: 'txt',
          media_category: 'Floor Plan',
          image_size_description: 'Thumbnail',
          order: 15,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Velit modi aut fuga sapiente voluptas veritatis tempore.',
          long_description: 'Temporibus libero eum et quia recusandae. Consectetur distinctio qui illo. Vel dolorem sit.\nOdio quidem quia quam dolores voluptatibus possimus quo. Debitis sit libero dolores eligendi. Velit est asperiores aliquid fuga illum distinctio repudiandae. Animi cum ut impedit esse qui quia.\nOdit quae id. Reprehenderit fugiat distinctio labore dicta placeat. Quia et et. Ut soluta eos. Accusantium et odio.'
        }, {
          media_key: '110fc03d1a2534b1a73870ad3c9935311a',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T23:34:08.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Thumbnail',
          order: 20,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Animi non perspiciatis et rerum ducimus laboriosam fugiat magni.',
          long_description: 'Qui illum harum et. Cumque iusto numquam. Voluptatem commodi dolor tempore enim adipisci perspiciatis.\nFuga unde et. Alias aut excepturi voluptatibus voluptate et. Deleniti sit atque placeat dolore nam maxime molestias. Eligendi qui et vitae qui ad quis.\nQuo et architecto unde. Illo sed amet deleniti soluta tempore. Consequatur voluptatum repudiandae veniam. Molestiae qui voluptas et quae quis praesentium. Inventore odio odit molestiae aspernatur qui repellendus.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'X-Large',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '133f996d1bc5143bd6db770983ac43d557',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-22T17:49:22.000Z',
          media_type: 'mp4',
          media_category: 'Office Logo',
          image_size_description: 'Thumbnail',
          order: 13,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ducimus quidem quae ipsa enim officia quasi sed quis.',
          long_description: 'Eum explicabo nihil odio ipsa itaque at. Dolor neque perferendis aut corrupti. Corrupti commodi alias ad aliquid. Quas modi officia eaque aut quaerat nihil animi.\nNisi quia veritatis molestiae sequi. Quod quos molestiae quia. Vero distinctio ad beatae. Nihil est perferendis nemo distinctio.\nInventore modi et asperiores earum. Officiis et tempore officia. Et fugit qui. Praesentium et rerum alias quis tempore. Vitae aut praesentium maxime ex delectus.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '156433494c06c6e7346895024612480663',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-23T03:59:09.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Officiis perferendis voluptate modi corporis necessitatibus nostrum.',
          long_description: 'Voluptas reiciendis ut. Saepe est eos. Aut voluptatibus delectus numquam qui.\nIusto minima incidunt deserunt eos vel optio. Aliquam consequatur in magni. Quas at similique deleniti et officia quo. Natus nihil unde fugit. Sed sed aut ullam.\nVel voluptas nulla reiciendis deleniti. Quos enim est est omnis corrupti cupiditate reiciendis. Impedit quo soluta repudiandae. Sunt eos labore magnam qui sed quidem cum. Dolorum voluptatum facilis nobis beatae odit.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Large',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Small',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Large',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '19b9984cf2cf5f71e0dfc42b21dd04583d',
          media_status: 'Active',
          modification_timestamp: '2018-10-05T02:03:31.000Z',
          media_type: 'wmv',
          media_category: 'Agent Photo',
          image_size_description: 'Large',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Iste eaque velit et quibusdam et sit.',
          long_description: 'Quia dolor et corporis inventore. Voluptatem non quis consequatur architecto quia velit. Deserunt amet et dolores tempore sint voluptatibus. Alias deserunt dolore est labore. Nostrum pariatur beatae repellendus accusamus praesentium.\nDignissimos saepe et in qui. Quod sed voluptate. Velit tenetur aliquid adipisci. Quisquam quae quidem facere cumque nihil vitae explicabo.\nDicta ea est. Qui magni et rerum. Dolores qui qui delectus numquam ipsa id. Voluptates minus qui eveniet aut ducimus sit. Eum sint quisquam explicabo dolorum est nulla.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Large',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Large',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '3f006b1f87f04c24c52eb3ff2b41a8d58',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T02:14:43.000Z',
          media_type: 'jpeg',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Thumb',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Soluta officia temporibus nulla id laudantium qui.',
          long_description: 'Dolor qui nihil eos. Et sit cupiditate. Repellat voluptas quisquam aspernatur ut quam quo ipsa. Eaque et delectus. Ut enim laborum.\nOptio consequatur praesentium non soluta. Laboriosam necessitatibus nihil harum aspernatur qui inventore rerum. Sint et quam repellendus iure veritatis aliquam.\nConsequuntur cumque doloremque aut. Esse voluptatem fugiat voluptas. Iure voluptas aut cum.'
        }, {
          media_key: '74c0c056810d2fc16397812731922b7f9',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-20T05:56:50.000Z',
          media_type: 'rtf',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Consequatur praesentium dolore nulla ut.',
          long_description: 'Provident voluptate sit esse veritatis ipsa eum. Quae ullam quia. Et delectus illo officiis incidunt ut ut. Fugit ea laboriosam quidem voluptates.\nRepudiandae tenetur blanditiis ut esse. Qui aut ut repellat maxime harum perferendis. Consequatur rerum iusto sunt deleniti tempore. Vel consequatur expedita labore delectus.\nEt ducimus quod temporibus non repellat nisi aut. Necessitatibus omnis sequi. Quisquam recusandae velit quae.'
        }, {
          media_key: '2e92894533e3e27c5dff30a9797a7d600',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-10T10:56:13.000Z',
          media_type: 'pdf',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Largest',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Omnis placeat voluptatem facere expedita at.',
          long_description: 'Consequatur est id. Iure dolorem amet fugit quibusdam adipisci numquam cupiditate. Sit optio nobis est.\nVitae harum autem quo placeat eius voluptatum quia. Ullam omnis voluptas. Officiis at ipsam sunt quod.\nAut animi et. Voluptatem sunt exercitationem. Fugiat in assumenda autem dignissimos beatae quam. Temporibus perferendis et asperiores.'
        }, {
          media_key: '481a1a0512868cdbada7153ed8f87d491',
          media_status: 'Active',
          modification_timestamp: '2018-09-04T20:24:17.000Z',
          media_type: 'xls',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Totam qui aliquam aut fugiat aperiam.',
          long_description: 'Placeat est aperiam alias ut maxime amet. Nobis impedit est aut. Consequatur est aliquam quis quis dolorum.\nAccusantium vel aut dolor. Voluptas fugiat nihil minus. At quod velit excepturi doloribus fugit quia. Ex et magnam est placeat ut itaque qui. Officiis aperiam quasi aut facere.\nVoluptas rem voluptates commodi nihil repellat inventore. Pariatur molestiae impedit. Cumque est et itaque debitis et. Distinctio impedit natus placeat sit non. Accusamus illum eveniet provident qui quia.'
        }, {
          media_key: '556f44b9b2050f85b29eb0f56392b4f83',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-21T16:54:55.000Z',
          media_type: 'png',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores vitae quia quia totam rerum.',
          long_description: 'Minus consectetur sed. Voluptates itaque esse nemo labore officia eum est. Veniam pariatur recusandae rerum distinctio ipsum excepturi. Perferendis sunt nemo quo.\nRerum suscipit saepe et sit unde quam. Labore sunt voluptatibus dolores suscipit rerum id. Cupiditate quia sit id.\nCorporis laborum eos omnis. Qui soluta ipsum. Ipsam consequatur voluptas sit necessitatibus omnis ut.'
        }, {
          media_key: '156433494c06c6e7346895024612480663',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-23T03:59:09.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Officiis perferendis voluptate modi corporis necessitatibus nostrum.',
          long_description: 'Voluptas reiciendis ut. Saepe est eos. Aut voluptatibus delectus numquam qui.\nIusto minima incidunt deserunt eos vel optio. Aliquam consequatur in magni. Quas at similique deleniti et officia quo. Natus nihil unde fugit. Sed sed aut ullam.\nVel voluptas nulla reiciendis deleniti. Quos enim est est omnis corrupti cupiditate reiciendis. Impedit quo soluta repudiandae. Sunt eos labore magnam qui sed quidem cum. Dolorum voluptatum facilis nobis beatae odit.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Thumb',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Largest',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Thumb',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Largest',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Thumb',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Largest',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Thumb',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Largest',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Thumb',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Largest',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }]
      }
    }
  }, {
    type: 'property_note',
    created_at: '2018-10-15T17:21:55.135Z',
    resource: {
      id: 2,
      body: 'Lorem ipsum..',
      created_at: '2018-10-15T17:21:55.135Z',
      updated_at: '2018-10-15T17:21:55.135Z',
      contact: {
        id: 1,
        user_id: null,
        email: 'john.doe@foo.bar',
        title: 'Mrs.',
        first_name: 'Hilma',
        last_name: 'Becker',
        display_name: 'Preston Goyette',
        company: 'Daniel-Zieme',
        relocation: true,
        military: true,
        source: 'Company Site',
        channel: 'Referral',
        referred_by: 'http://hamill.co/haven',
        status: 'Current Client',
        created_at: '2018-10-15T16:50:45.534Z',
        updated_at: '2018-10-15T17:15:15.349Z'
      },
      property: {
        id: 1,
        property_type: 'Commercial Lease',
        property_sub_type: 'Manufactured Home',
        property_universal_id: '418ca4be91f9035167f87a6141c54cf2',
        source: 'RETS',
        location: {
          address: {
            carrier_route: 'Vegetable Beer',
            city: 'Predovicfurt',
            country: 'United States',
            county_or_parish: 'Woodland Tower',
            postal_city: 'Wiegandtown',
            postal_code: '55216-6902',
            postal_code_plus_4: '1273',
            state_or_province: 'OH',
            street_additional_info: 'Sierra Nevada Bigfoot Barleywine Style Ale',
            street_dir_prefix: 'W',
            street_dir_suffix: 'SW',
            street_name: 'Kraig Green',
            street_number: '5',
            street_number_numeric: 5,
            street_suffix: 'Village',
            street_suffix_modifier: 'Olympic',
            township: '5526 - Brettanomyces lambicus',
            unit_number: '3576',
            unparsed_address: '2276 Dylan Locks'
          },
          area: {
            city_region: 'Triffid Nebula',
            continent_region: 'Omega Centauri',
            country_region: 'Sun',
            mls_area_major: 'Glapflap',
            mls_area_minor: 'Deimos',
            state_region: 'C',
            subdivision_name: 'Park Village'
          },
          gis: {
            cross_street: 'Chad Pike',
            directions: 'Come on baby, I\'m saying bing bang bloozy, you and me in the jacuzzi. Whassup?',
            elevation: 5,
            elevation_units: 'feet',
            latitude: '-23.432614625832443',
            longitude: '-61.758219258878',
            map_coordinate: '42 megaparsecs',
            map_coordinate_source: 'Hoba',
            map_url: 'http://schmeler.info/neal'
          },
          school: {
            elementary_school_district: 'New Directions Publishing',
            elementary_school: 'Jacob Have I Loved',
            high_school_district: 'Harvest House',
            high_school: 'Look to Windward',
            middle_or_junior_school_district: 'Adis International',
            middle_or_junior_school: 'The Proper Study'
          }
        },
        media: [{
          media_key: '1bec326e8df357e4999e08a8102fdb911',
          media_status: 'Active',
          modification_timestamp: '2018-09-13T04:36:18.000Z',
          media_type: 'rtf',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptates voluptatum eveniet corrupti cumque.',
          long_description: 'Cum eius eos quae. Pariatur molestiae saepe voluptates non illum. Sunt accusantium autem ut aut. Fugiat aut molestias unde quo asperiores. Cumque aut dolorem illum et nihil sit praesentium.\nIpsum non illum nemo sit atque unde. Voluptatem occaecati ullam voluptatem voluptatibus. Consectetur minus molestias voluptas autem distinctio. Rerum vel et. Commodi repellat ducimus at soluta ut qui quibusdam.\nUt aut numquam. Dicta rerum eum sit laborum hic deserunt. Quo esse soluta et tempore.'
        }, {
          media_key: '2e92894533e3e27c5dff30a9797a7d600',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-10T10:56:13.000Z',
          media_type: 'pdf',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Medium',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Omnis placeat voluptatem facere expedita at.',
          long_description: 'Consequatur est id. Iure dolorem amet fugit quibusdam adipisci numquam cupiditate. Sit optio nobis est.\nVitae harum autem quo placeat eius voluptatum quia. Ullam omnis voluptas. Officiis at ipsam sunt quod.\nAut animi et. Voluptatem sunt exercitationem. Fugiat in assumenda autem dignissimos beatae quam. Temporibus perferendis et asperiores.'
        }, {
          media_key: '3f006b1f87f04c24c52eb3ff2b41a8d58',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T02:14:43.000Z',
          media_type: 'jpeg',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'X-Large',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Soluta officia temporibus nulla id laudantium qui.',
          long_description: 'Dolor qui nihil eos. Et sit cupiditate. Repellat voluptas quisquam aspernatur ut quam quo ipsa. Eaque et delectus. Ut enim laborum.\nOptio consequatur praesentium non soluta. Laboriosam necessitatibus nihil harum aspernatur qui inventore rerum. Sint et quam repellendus iure veritatis aliquam.\nConsequuntur cumque doloremque aut. Esse voluptatem fugiat voluptas. Iure voluptas aut cum.'
        }, {
          media_key: '481a1a0512868cdbada7153ed8f87d491',
          media_status: 'Active',
          modification_timestamp: '2018-09-04T20:24:17.000Z',
          media_type: 'xls',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Totam qui aliquam aut fugiat aperiam.',
          long_description: 'Placeat est aperiam alias ut maxime amet. Nobis impedit est aut. Consequatur est aliquam quis quis dolorum.\nAccusantium vel aut dolor. Voluptas fugiat nihil minus. At quod velit excepturi doloribus fugit quia. Ex et magnam est placeat ut itaque qui. Officiis aperiam quasi aut facere.\nVoluptas rem voluptates commodi nihil repellat inventore. Pariatur molestiae impedit. Cumque est et itaque debitis et. Distinctio impedit natus placeat sit non. Accusamus illum eveniet provident qui quia.'
        }, {
          media_key: '556f44b9b2050f85b29eb0f56392b4f83',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-21T16:54:55.000Z',
          media_type: 'png',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores vitae quia quia totam rerum.',
          long_description: 'Minus consectetur sed. Voluptates itaque esse nemo labore officia eum est. Veniam pariatur recusandae rerum distinctio ipsum excepturi. Perferendis sunt nemo quo.\nRerum suscipit saepe et sit unde quam. Labore sunt voluptatibus dolores suscipit rerum id. Cupiditate quia sit id.\nCorporis laborum eos omnis. Qui soluta ipsum. Ipsam consequatur voluptas sit necessitatibus omnis ut.'
        }, {
          media_key: '6d89da516cdc4d67aafa255d504279643',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-12T20:28:49.000Z',
          media_type: 'txt',
          media_category: 'Office Photo',
          image_size_description: 'Thumbnail',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ipsam voluptatem omnis repudiandae molestiae quo dolor impedit.',
          long_description: 'Enim dolorem molestiae dignissimos ullam facilis amet expedita. Beatae ipsum quia rerum. Veniam voluptas velit dicta et.\nEum deserunt rerum dolorem dolores qui et. Adipisci distinctio numquam sint. Qui est et. Perspiciatis suscipit sunt omnis dicta facilis.\nLaborum rerum dolores. Suscipit est quis molestiae provident. Sed maiores laudantium molestiae. Nihil suscipit minima modi asperiores. Quos est laudantium earum aut.'
        }, {
          media_key: '74c0c056810d2fc16397812731922b7f9',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-20T05:56:50.000Z',
          media_type: 'rtf',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Consequatur praesentium dolore nulla ut.',
          long_description: 'Provident voluptate sit esse veritatis ipsa eum. Quae ullam quia. Et delectus illo officiis incidunt ut ut. Fugit ea laboriosam quidem voluptates.\nRepudiandae tenetur blanditiis ut esse. Qui aut ut repellat maxime harum perferendis. Consequatur rerum iusto sunt deleniti tempore. Vel consequatur expedita labore delectus.\nEt ducimus quod temporibus non repellat nisi aut. Necessitatibus omnis sequi. Quisquam recusandae velit quae.'
        }, {
          media_key: '82fe832d662eb7267e7b25748cb65d48e',
          media_status: 'Active',
          modification_timestamp: '2018-09-02T13:26:21.000Z',
          media_type: 'txt',
          media_category: 'Document',
          image_size_description: 'Thumbnail',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut iste voluptas suscipit quas reprehenderit sequi.',
          long_description: 'Modi non illo. Magni et facilis aliquid. Non sed soluta ea.\nQuasi nobis facere consectetur dolorem ipsam dolorum debitis. Sed accusamus aliquam ut eum. In autem ut magnam possimus aut nihil.\nAliquam qui qui autem nesciunt. Ut repellendus est. Et assumenda aliquid sequi.'
        }, {
          media_key: '94c9db4fc1291dc8bdf03e5517b009f70',
          media_status: 'Active',
          modification_timestamp: '2018-09-24T11:06:08.000Z',
          media_type: 'xls',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Optio sint eum nobis est.',
          long_description: 'Ea et pariatur placeat. Sint culpa sint. Modi illum veritatis atque ratione et.\nDolorem dicta numquam fugiat aut quidem et culpa. Vitae beatae temporibus corporis. Et harum veritatis laboriosam laborum. Cupiditate natus eum omnis aut. Molestias aut maxime aut aut.\nSunt magnam et aut rerum voluptatem. Repudiandae neque non aut sit eos eaque fuga. Omnis corporis esse incidunt. Iusto libero laboriosam aut.'
        }, {
          media_key: '105bf110d7008161c913db8bba00bef20c',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-06T11:51:00.000Z',
          media_type: 'txt',
          media_category: 'Floor Plan',
          image_size_description: 'Thumbnail',
          order: 15,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Velit modi aut fuga sapiente voluptas veritatis tempore.',
          long_description: 'Temporibus libero eum et quia recusandae. Consectetur distinctio qui illo. Vel dolorem sit.\nOdio quidem quia quam dolores voluptatibus possimus quo. Debitis sit libero dolores eligendi. Velit est asperiores aliquid fuga illum distinctio repudiandae. Animi cum ut impedit esse qui quia.\nOdit quae id. Reprehenderit fugiat distinctio labore dicta placeat. Quia et et. Ut soluta eos. Accusantium et odio.'
        }, {
          media_key: '110fc03d1a2534b1a73870ad3c9935311a',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T23:34:08.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Thumbnail',
          order: 20,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Animi non perspiciatis et rerum ducimus laboriosam fugiat magni.',
          long_description: 'Qui illum harum et. Cumque iusto numquam. Voluptatem commodi dolor tempore enim adipisci perspiciatis.\nFuga unde et. Alias aut excepturi voluptatibus voluptate et. Deleniti sit atque placeat dolore nam maxime molestias. Eligendi qui et vitae qui ad quis.\nQuo et architecto unde. Illo sed amet deleniti soluta tempore. Consequatur voluptatum repudiandae veniam. Molestiae qui voluptas et quae quis praesentium. Inventore odio odit molestiae aspernatur qui repellendus.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'X-Large',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '133f996d1bc5143bd6db770983ac43d557',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-22T17:49:22.000Z',
          media_type: 'mp4',
          media_category: 'Office Logo',
          image_size_description: 'Thumbnail',
          order: 13,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ducimus quidem quae ipsa enim officia quasi sed quis.',
          long_description: 'Eum explicabo nihil odio ipsa itaque at. Dolor neque perferendis aut corrupti. Corrupti commodi alias ad aliquid. Quas modi officia eaque aut quaerat nihil animi.\nNisi quia veritatis molestiae sequi. Quod quos molestiae quia. Vero distinctio ad beatae. Nihil est perferendis nemo distinctio.\nInventore modi et asperiores earum. Officiis et tempore officia. Et fugit qui. Praesentium et rerum alias quis tempore. Vitae aut praesentium maxime ex delectus.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '156433494c06c6e7346895024612480663',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-23T03:59:09.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Medium',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Officiis perferendis voluptate modi corporis necessitatibus nostrum.',
          long_description: 'Voluptas reiciendis ut. Saepe est eos. Aut voluptatibus delectus numquam qui.\nIusto minima incidunt deserunt eos vel optio. Aliquam consequatur in magni. Quas at similique deleniti et officia quo. Natus nihil unde fugit. Sed sed aut ullam.\nVel voluptas nulla reiciendis deleniti. Quos enim est est omnis corrupti cupiditate reiciendis. Impedit quo soluta repudiandae. Sunt eos labore magnam qui sed quidem cum. Dolorum voluptatum facilis nobis beatae odit.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Large',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Small',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Large',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '19b9984cf2cf5f71e0dfc42b21dd04583d',
          media_status: 'Active',
          modification_timestamp: '2018-10-05T02:03:31.000Z',
          media_type: 'wmv',
          media_category: 'Agent Photo',
          image_size_description: 'Large',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Iste eaque velit et quibusdam et sit.',
          long_description: 'Quia dolor et corporis inventore. Voluptatem non quis consequatur architecto quia velit. Deserunt amet et dolores tempore sint voluptatibus. Alias deserunt dolore est labore. Nostrum pariatur beatae repellendus accusamus praesentium.\nDignissimos saepe et in qui. Quod sed voluptate. Velit tenetur aliquid adipisci. Quisquam quae quidem facere cumque nihil vitae explicabo.\nDicta ea est. Qui magni et rerum. Dolores qui qui delectus numquam ipsa id. Voluptates minus qui eveniet aut ducimus sit. Eum sint quisquam explicabo dolorum est nulla.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Large',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Small',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Large',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '3f006b1f87f04c24c52eb3ff2b41a8d58',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-05T02:14:43.000Z',
          media_type: 'jpeg',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Thumb',
          order: 23,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Soluta officia temporibus nulla id laudantium qui.',
          long_description: 'Dolor qui nihil eos. Et sit cupiditate. Repellat voluptas quisquam aspernatur ut quam quo ipsa. Eaque et delectus. Ut enim laborum.\nOptio consequatur praesentium non soluta. Laboriosam necessitatibus nihil harum aspernatur qui inventore rerum. Sint et quam repellendus iure veritatis aliquam.\nConsequuntur cumque doloremque aut. Esse voluptatem fugiat voluptas. Iure voluptas aut cum.'
        }, {
          media_key: '74c0c056810d2fc16397812731922b7f9',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-20T05:56:50.000Z',
          media_type: 'rtf',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Consequatur praesentium dolore nulla ut.',
          long_description: 'Provident voluptate sit esse veritatis ipsa eum. Quae ullam quia. Et delectus illo officiis incidunt ut ut. Fugit ea laboriosam quidem voluptates.\nRepudiandae tenetur blanditiis ut esse. Qui aut ut repellat maxime harum perferendis. Consequatur rerum iusto sunt deleniti tempore. Vel consequatur expedita labore delectus.\nEt ducimus quod temporibus non repellat nisi aut. Necessitatibus omnis sequi. Quisquam recusandae velit quae.'
        }, {
          media_key: '2e92894533e3e27c5dff30a9797a7d600',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-10T10:56:13.000Z',
          media_type: 'pdf',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'Largest',
          order: 6,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Omnis placeat voluptatem facere expedita at.',
          long_description: 'Consequatur est id. Iure dolorem amet fugit quibusdam adipisci numquam cupiditate. Sit optio nobis est.\nVitae harum autem quo placeat eius voluptatum quia. Ullam omnis voluptas. Officiis at ipsam sunt quod.\nAut animi et. Voluptatem sunt exercitationem. Fugiat in assumenda autem dignissimos beatae quam. Temporibus perferendis et asperiores.'
        }, {
          media_key: '481a1a0512868cdbada7153ed8f87d491',
          media_status: 'Active',
          modification_timestamp: '2018-09-04T20:24:17.000Z',
          media_type: 'xls',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Totam qui aliquam aut fugiat aperiam.',
          long_description: 'Placeat est aperiam alias ut maxime amet. Nobis impedit est aut. Consequatur est aliquam quis quis dolorum.\nAccusantium vel aut dolor. Voluptas fugiat nihil minus. At quod velit excepturi doloribus fugit quia. Ex et magnam est placeat ut itaque qui. Officiis aperiam quasi aut facere.\nVoluptas rem voluptates commodi nihil repellat inventore. Pariatur molestiae impedit. Cumque est et itaque debitis et. Distinctio impedit natus placeat sit non. Accusamus illum eveniet provident qui quia.'
        }, {
          media_key: '556f44b9b2050f85b29eb0f56392b4f83',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-21T16:54:55.000Z',
          media_type: 'png',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores vitae quia quia totam rerum.',
          long_description: 'Minus consectetur sed. Voluptates itaque esse nemo labore officia eum est. Veniam pariatur recusandae rerum distinctio ipsum excepturi. Perferendis sunt nemo quo.\nRerum suscipit saepe et sit unde quam. Labore sunt voluptatibus dolores suscipit rerum id. Cupiditate quia sit id.\nCorporis laborum eos omnis. Qui soluta ipsum. Ipsam consequatur voluptas sit necessitatibus omnis ut.'
        }, {
          media_key: '156433494c06c6e7346895024612480663',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-23T03:59:09.000Z',
          media_type: 'jpeg',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Officiis perferendis voluptate modi corporis necessitatibus nostrum.',
          long_description: 'Voluptas reiciendis ut. Saepe est eos. Aut voluptatibus delectus numquam qui.\nIusto minima incidunt deserunt eos vel optio. Aliquam consequatur in magni. Quas at similique deleniti et officia quo. Natus nihil unde fugit. Sed sed aut ullam.\nVel voluptas nulla reiciendis deleniti. Quos enim est est omnis corrupti cupiditate reiciendis. Impedit quo soluta repudiandae. Sunt eos labore magnam qui sed quidem cum. Dolorum voluptatum facilis nobis beatae odit.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Thumb',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '229485436cce5579233a88ee82d3929f41',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T01:21:44.000Z',
          media_type: 'png',
          media_category: 'Floor Plan',
          image_size_description: 'Largest',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut occaecati nesciunt beatae excepturi.',
          long_description: 'Quis ut et dolor saepe dolorum. Et tempore animi est. Enim sapiente nostrum.\nSit sed aperiam earum reiciendis qui. Rerum blanditiis vero saepe itaque. Qui nemo eligendi fugit sequi dolor molestiae in. Sed perferendis eveniet sint ab iusto dolorem. Aut id ut ut.\nIpsa voluptas odio. Eum voluptas ipsa dolorum ut unde quod inventore. In non dolore. Quasi voluptatum aliquam qui consequuntur tempore quam corporis. Sed libero pariatur.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Thumb',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '17e0ff327f3744c24cc66e4b4f80826069',
          media_status: 'Active',
          modification_timestamp: '2018-09-07T16:25:47.000Z',
          media_type: 'wmv',
          media_category: 'Floor Plan',
          image_size_description: 'Largest',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Fugiat perferendis earum velit eveniet.',
          long_description: 'Autem alias consequatur cum aperiam voluptatem velit. Qui eaque fugit assumenda animi eos. Ipsum alias sapiente.\nEligendi nisi aut inventore. Dolor eos non id vitae qui dolore voluptates. Omnis eaque optio facere aperiam quas dignissimos.\nQuia a vitae dicta velit. Corrupti aliquam incidunt quia. Et eaque delectus error perspiciatis non. Incidunt optio et ex. Omnis sequi voluptate adipisci enim facere voluptatem est.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '1291ff40ce73a8bb2a93824c488671668c',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T07:16:18.000Z',
          media_type: 'mov',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ut voluptatem doloremque officiis expedita quibusdam ipsum dolorem distinctio.',
          long_description: 'Perspiciatis accusamus consequuntur corrupti. Fugiat consequatur illum laboriosam vero voluptatibus. Expedita quo rem laborum eaque qui. Nobis earum consequatur consequatur. Voluptatem ipsam nam voluptatem dolores quis voluptates illo.\nVeritatis sed ut id autem harum et consectetur. In expedita omnis ea id. Voluptatibus totam possimus a accusantium saepe magnam quod. Harum labore non quaerat consequuntur aut ratione. Aliquam nulla laborum asperiores sunt neque consectetur illum.\nArchitecto et et sit eos. Ab aut vitae in magni veritatis quibusdam. Ipsam praesentium distinctio deserunt.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Thumb',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '142950e43648233be4b50dc039f7e068f7',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-05T04:56:09.000Z',
          media_type: 'tiff',
          media_category: 'Office Photo',
          image_size_description: 'Largest',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Dolores aut nisi omnis.',
          long_description: 'Blanditiis ad asperiores illo veritatis eos et ut. Soluta et molestias hic excepturi id animi. Dolores velit tempore reprehenderit error cum officiis labore. Ducimus ut hic fugit. Quasi at autem.\nNatus voluptas voluptas necessitatibus. Ut sunt explicabo soluta est quae. Vero quis qui enim aut accusantium sunt qui. Rem quia vero sunt cupiditate sit.\nUt quas porro occaecati. Nesciunt inventore officiis. Quis et error explicabo rerum aspernatur voluptatum dolore.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Thumb',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '166a9736060f00cc4cc2628429ba56f78e',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-07T09:50:58.000Z',
          media_type: 'pdf',
          media_category: 'Photo',
          image_size_description: 'Largest',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ullam exercitationem reprehenderit totam omnis quaerat animi provident.',
          long_description: 'Ut sunt aut beatae culpa tempore voluptatibus molestiae. Quasi enim eos. Qui sed distinctio quas veniam. Voluptatem nisi neque est facilis vitae minima. Voluptas alias omnis est tempora ea minima voluptatem.\nTenetur ea tempore. Et sint eos consequatur earum dolor illum rerum. Debitis iure deleniti doloremque consequatur sed ducimus nesciunt. Tempora provident aut.\nItaque voluptatem dolores id aut et. Sint illo veritatis culpa rem at tenetur. Cumque velit repudiandae porro. Voluptatibus asperiores autem nam. Eum doloremque dolorem.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Thumb',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '181cc40d31fccf6b526c6c4dda911a3410',
          media_status: 'Active',
          modification_timestamp: '2018-09-30T13:14:42.000Z',
          media_type: 'pdf',
          media_category: 'Agent Photo',
          image_size_description: 'Largest',
          order: 29,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aliquid similique nihil omnis quis tempore.',
          long_description: 'Sunt quas perspiciatis. Ipsa sapiente delectus deserunt. Eos sequi debitis voluptas. Officia vel qui esse.\nLabore nemo sequi. Expedita neque nam placeat facilis necessitatibus. Deleniti dolorem voluptates odit. Nemo quis ut odio quisquam eaque. Et nulla quia amet.\nFacere ut dolor. Neque eligendi sed est voluptas. Minima quo itaque quis sit. Earum asperiores quibusdam eveniet ab. Similique ea iure aut eius assumenda nulla voluptatem.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Thumb',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '2007ff9eb244de945cff317c2b6a579b09',
          media_status: 'Active',
          modification_timestamp: '2018-10-04T12:11:19.000Z',
          media_type: 'mpeg',
          media_category: 'Office Logo',
          image_size_description: 'Largest',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum et voluptas amet quaerat est quia dolorum.',
          long_description: 'Fugiat officiis minus velit. Nobis repellat beatae ut dolor odit perferendis tempora. Iusto ut ratione. Mollitia ipsam officiis aperiam odit veritatis est. Itaque consequatur ut.\nEt nulla suscipit qui velit earum id placeat. Expedita id quidem ex vitae dicta repellendus. Quis excepturi numquam animi ratione ad eligendi fugiat. Pariatur qui et nihil omnis. Omnis perspiciatis libero tempore quidem ad.\nDolores numquam debitis magni voluptatum blanditiis. Sed voluptatem nemo consequatur iure eos. Voluptates ratione accusantium atque odio quaerat.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Thumb',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }, {
          media_key: '21cfeadd8f41096e47cc61001753b5ec11',
          media_status: 'Active',
          modification_timestamp: '2018-09-11T21:46:43.000Z',
          media_type: 'wmv',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 4,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum ut sapiente dolor.',
          long_description: 'Et fugiat deserunt. Rerum dolore minus omnis. Nobis maiores tenetur temporibus expedita. Facilis rerum sequi cupiditate placeat voluptatibus.\nQuis quia alias consequuntur consequatur. Eveniet minima enim suscipit sed possimus vel in. Rem deleniti molestiae perspiciatis. Voluptas sequi aut sint perspiciatis.\nMolestiae eius iusto omnis autem occaecati eveniet saepe. Sint aspernatur ut. Consequatur molestiae perferendis facere deserunt perspiciatis officia vel.'
        }]
      }
    }
  }, {
    type: 'login',
    created_at: '2018-10-15T17:16:17.066Z',
    resource: null
  }]
};

function getContactActivitiesMock() {
  return cloneDeep_1(contactActivities);
}

function getContactActivityMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(contactActivities.results[index]);
}

var properties = {
  total: 0,
  results: []
};

var property = {
  id: 1,
  property_type: 'Residential',
  property_sub_type: 'Office',
  property_universal_id: 'e820020d8a0ea9f1b64fbbbf2982a40f',
  location: {
    address: {
      carrier_route: 'MyString',
      city: 'Sydneytown',
      country: 'United States',
      county_or_parish: 'Robred Dropoff',
      postal_city: 'Ondrickachester',
      postal_code: 'MyString',
      postal_code_plus_4: 'MyString',
      state_or_province: 'MS',
      street_additional_info: 'MyString',
      street_dir_prefix: 'MyString',
      street_dir_suffix: 'MyString',
      street_name: 'MyString',
      street_number: 'MyString',
      street_number_numeric: 1,
      street_suffix: 'MyString',
      street_suffix_modifier: 'MyString',
      township: 'MyString',
      unit_number: 'MyString',
      unparsed_address: 'MyString'
    },
    area: {
      city_region: 'MyString',
      continent_region: 'MyString',
      country_region: 'MyString',
      mls_area_major: 'MyString',
      mls_area_minor: 'MyString',
      state_region: 'MyString',
      subdivision_name: 'MyString'
    },
    gis: {
      cross_street: 'MyString',
      directions: 'MyText',
      elevation: 1,
      elevation_units: 'MyString',
      latitude: '9.99',
      longitude: '9.99',
      map_coordinate: 'MyString',
      map_coordinate_source: 'MyString',
      map_url: 'MyString'
    },
    school: {
      elementary_school_district: 'MyString',
      elementary_school: 'MyString',
      high_school_district: 'MyString',
      high_school: 'MyString',
      middle_or_junior_school_district: 'MyString',
      middle_or_junior_school: 'MyString'
    }
  },
  business: {
    business_name: 'Cremin-Murphy',
    business_type: 'statistician',
    hours_days_of_operation_description: "I'm gonna get that son of a bitch.",
    hours_days_of_operation: 'Open 24 Hours',
    labor_information: 'Employee License Required',
    lease_amount: 1449,
    lease_amount_frequency: 'Bi-Monthly',
    lease_assignable_y_n: false,
    lease_expiration: '2018-11-12T00:00:00.000Z',
    lease_renewal_option_y_n: false,
    number_of_full_time_employees: 338,
    number_of_part_time_employees: 397,
    ownership_type: 'LLC',
    seating_capacity: 4379,
    special_licenses: 'Liquor 5 Years Or Less',
    year_established: 1949,
    years_current_owner: 48
  },
  characteristics: {
    anchors_co_tenants: 'Ernestina Volkman',
    community_features: "Chuck Norris's keyboard doesn't have a Ctrl key because nothing controls Chuck Norris.",
    current_use: 'Nursery',
    development_status: 'Site Plan Approved',
    fencing: 'Partial',
    frontage_length: null,
    frontage_type: 'Waterfront',
    furnished: 'Partially',
    horse_amenities: 'Sweet Bread',
    horse_y_n: false,
    land_lease_amount: 2848,
    land_lease_amount_frequency: 'Bi-Monthly',
    land_lease_expiration_date: '2019-04-30T00:00:00.000Z',
    land_lease_y_n: false,
    laundry_features: 'Gallium',
    lease_term: '24 Months',
    lot_dimensions_source: 'GIS Calculated',
    lot_features: 'Emil Kraepelin',
    lot_size_acres: 65,
    lot_size_area: 11,
    lot_size_dimensions: '81 parsecs',
    lot_size_source: 'Assessor',
    lot_size_square_feet: 12678,
    lot_size_units: 'Square Feet',
    mobile_home_remains_y_n: true,
    number_of_buildings: 4,
    number_of_lots: 2,
    number_of_pads: 10,
    number_of_units_in_community: 5,
    number_of_units_total: 9,
    park_manager_name: 'Brayan Harris',
    park_manager_phone: '482-916-4744',
    park_name: 'Oaked Arrogant Bastard Ale',
    pool_features: 'Vegetable Beer',
    pool_private_y_n: false,
    possible_use: 'Development',
    road_frontage_type: 'Alley',
    road_responsibility: 'Public Maintained Road',
    road_surface_type: 'Paved',
    senior_community_y_n: false,
    spa_features: 'dull, tea-like, hazelnut, clementine, carmel',
    spa_y_n: true,
    topography: 'Gummy Bears',
    units_furnished: 'Bass Guitar',
    view: 'Messier 70',
    view_y_n: false,
    water_body_name: 'Golding',
    waterfront_features: 'Chocolate',
    waterfront_y_n: true
  },
  equipment: {
    appliances: 'COBOL',
    other_equipment: 'typewriter',
    security_features: 'Moon'
  },
  farming: {
    crops_included_y_n: true,
    cultivated_area: '76.37',
    farm_credit_service_incl_y_n: true,
    farm_land_area_source: 'Public Records',
    farm_land_area_units: 'Square Feet',
    grazing_permits_blm_y_n: true,
    grazing_permits_forest_service_y_n: true,
    grazing_permits_private_y_n: true,
    pasture_area: '52.13',
    range_area: '74.86',
    vegetation: 'Other',
    wooded_area: '28.79'
  },
  financial: {
    cable_tv_expense: '89.31',
    cap_rate: '96.77',
    electric_expense: '29.93',
    existing_lease_type: 'NNN',
    financial_data_source: 'Accountant',
    fuel_expense: '44.32',
    furniture_replacement_expense: '86.31',
    gardener_expense: '85.57',
    gross_income: '46.98',
    gross_scheduled_income: '35.11',
    income_includes: 'RV Storage',
    insurance_expense: '31.22',
    licenses_expense: '32.02',
    maintenance_expense: '52.72',
    manager_expense: '50.83',
    net_operating_income: '96.46',
    new_taxes_expense: '30.53',
    number_of_units_leased: 5,
    number_of_units_mo_mo: 9,
    number_of_units_vacant: 4,
    operating_expense: '73.08',
    operating_expense_includes: 'Gardener',
    other_expense: '35.48',
    owner_pays: 'HVAC Maintenance',
    pest_control_expense: '88.16',
    pool_expense: '19.79',
    professional_management_expense: '94.58',
    rent_control_y_n: true,
    rent_includes: 'Electricity',
    supplies_expense: '52.17',
    tenant_pays: 'Sewer',
    total_actual_rent: '19.04',
    trash_expense: '41.23',
    vacancy_allowance: 10,
    vacancy_allowance_rate: '99.81',
    water_sewer_expense: '99.02',
    workmans_compensation_expense: '40.93'
  },
  hoa: {
    association_amenities: 'National Space Agency of Ukraine',
    association_fee_2: '966.01',
    association_fee_2_frequency: 'Daily',
    association_fee: '446.46',
    association_fee_frequency: 'Bi-Weekly',
    association_fee_includes: 'Pest Control',
    association_name_2: 'Virgo',
    association_name: "Link's Awakening",
    association_phone_2: '1-887-142-3588 x58847',
    association_phone: '236-694-9057',
    association_y_n: true,
    pets_allowed: 'Breed Restrictions'
  },
  listing: {
    copyright_notice: 'MyText',
    disclaimer: 'MyText',
    home_warranty_y_n: false,
    lease_considered_y_n: true,
    list_aor: 'MyString',
    listing_agreement: 'MyString',
    listing_id: '6154878449',
    listing_key: '53cdb938796f305e4839ffcf092810cb75',
    listing_key_numeric: 1,
    listing_service: 'MyString',
    mls_status: 'MyString',
    originating_system_id: 'MyString',
    originating_system_key: 'MyString',
    originating_system_name: 'MyString',
    source_system_id: 'MyString',
    source_system_key: 'MyString',
    source_system_name: 'MyString',
    standard_status: 'Delete',
    agent_office: {
      buyer_agent: {
        buyer_agent_aor: 'Centaurus A',
        buyer_agent_designation: 'Society of Industrial and Office REALTORS / SIOR',
        buyer_agent_direct_phone: '(142) 728-7593',
        buyer_agent_email: 'aletha_keebler@bashirianmoen.co',
        buyer_agent_fax: '163-058-4397',
        buyer_agent_first_name: 'Mckenna',
        buyer_agent_full_name: 'Mckenna Hansen',
        buyer_agent_home_phone: '(178) 773-0600',
        buyer_agent_key: '4c0d1bc1b53cc4eca11cf43a15962a52',
        buyer_agent_key_numeric: 1779725453,
        buyer_agent_last_name: 'Hansen',
        buyer_agent_middle_name: 'Xavier',
        buyer_agent_mls_id: 'd60dd4b9653317e8cc7d9409bc4debd3',
        buyer_agent_mobile_phone: '132.834.9455 x115',
        buyer_agent_name_prefix: 'Miss',
        buyer_agent_name_suffix: 'Sr.',
        buyer_agent_office_phone_ext: '7376',
        buyer_agent_office_phone: '(243) 272-6886',
        buyer_agent_pager: '(727) 394-9435 x2306',
        buyer_agent_preferred_phone_ext: '9786',
        buyer_agent_preferred_phone: '261.876.7545 x79646',
        buyer_agent_state_license: '2bb69cf1c98a13d17efbee8890fab100',
        buyer_agent_toll_free_phone: '1-852-838-5424 x3126',
        buyer_agent_url: 'http://smitham.co/barbara',
        buyer_agent_voice_mail_ext: '0637',
        buyer_agent_voice_mail: '1-445-936-1650 x2939'
      },
      buyer_office: {
        buyer_office_aor: 'MyString',
        buyer_office_email: 'MyString',
        buyer_office_fax: 'MyString',
        buyer_office_key: 'MyString',
        buyer_office_key_numeric: 1,
        buyer_office_mls_id: 'MyString',
        buyer_office_name: 'MyString',
        buyer_office_phone_ext: 'MyString',
        buyer_office_phone: 'MyString',
        buyer_office_url: 'MyText'
      },
      co_buyer_agent: {
        co_buyer_agent_aor: 'Blackeye',
        co_buyer_agent_designation: 'Society of Industrial and Office REALTORS / SIOR',
        co_buyer_agent_direct_phone: '1-648-951-4300 x75391',
        co_buyer_agent_email: 'kennedi.mueller@willms.com',
        co_buyer_agent_fax: '303-620-1884 x0487',
        co_buyer_agent_first_name: 'Annabel',
        co_buyer_agent_full_name: 'Annabel Flatley',
        co_buyer_agent_home_phone: '908-903-2015 x9060',
        co_buyer_agent_key: '65b2da75cc9d1753cbea736109de4dea',
        co_buyer_agent_key_numeric: 2360866004,
        co_buyer_agent_last_name: 'Flatley',
        co_buyer_agent_middle_name: 'Kelli',
        co_buyer_agent_mls_id: '3f8c5359e4668c46047427a1f296621a',
        co_buyer_agent_mobile_phone: '634.200.8910 x6924',
        co_buyer_agent_name_prefix: 'Miss',
        co_buyer_agent_name_suffix: 'MD',
        co_buyer_agent_office_phone_ext: '6375',
        co_buyer_agent_office_phone: '1-814-125-9509 x4852',
        co_buyer_agent_pager: '432-098-2274 x95945',
        co_buyer_agent_preferred_phone_ext: '7887',
        co_buyer_agent_preferred_phone: '500.035.0498 x686',
        co_buyer_agent_state_license: 'c000d00c79263c656d848527eb8e8d7d',
        co_buyer_agent_toll_free_phone: '(741) 533-8517 x84332',
        co_buyer_agent_url: 'http://klein.biz/bonita',
        co_buyer_agent_voice_mail_ext: '9900',
        co_buyer_agent_voice_mail: '448.768.7015 x2732'
      },
      co_buyer_office: {
        co_buyer_office_aor: 'MyString',
        co_buyer_office_email: 'MyString',
        co_buyer_office_fax: 'MyString',
        co_buyer_office_key: 'MyString',
        co_buyer_office_key_numeric: 1,
        co_buyer_office_mls_id: 'MyString',
        co_buyer_office_name: 'MyString',
        co_buyer_office_phone_ext: 'MyString',
        co_buyer_office_phone: 'MyString',
        co_buyer_office_url: 'MyText'
      },
      co_list_agent: {
        co_list_agent_aor: 'Hoags Object',
        co_list_agent_designation: 'Certified Real Estate Brokerage Manager / CRB',
        co_list_agent_direct_phone: '124.975.3529',
        co_list_agent_email: 'kameron@blick.io',
        co_list_agent_fax: '317-062-9807 x569',
        co_list_agent_first_name: 'Citlalli',
        co_list_agent_full_name: 'Citlalli Kshlerin',
        co_list_agent_home_phone: '134-160-6842',
        co_list_agent_key: '4f688b12ccd6187466d4a1d002957c1f',
        co_list_agent_key_numeric: 8581618585,
        co_list_agent_last_name: 'Kshlerin',
        co_list_agent_middle_name: 'Stephany',
        co_list_agent_mls_id: '2fa0eb5b57f5ae145833a6f61bd114f4',
        co_list_agent_mobile_phone: '999.215.2204 x1874',
        co_list_agent_name_prefix: 'Ms.',
        co_list_agent_name_suffix: 'II',
        co_list_agent_office_phone_ext: '5947',
        co_list_agent_office_phone: '362.488.9380 x10451',
        co_list_agent_pager: '1-699-380-6209 x47373',
        co_list_agent_preferred_phone_ext: '8319',
        co_list_agent_preferred_phone: '260-334-2316 x1519',
        co_list_agent_state_license: '4e5332e48ce1067c758c2d8b87544798',
        co_list_agent_toll_free_phone: '284-222-3132',
        co_list_agent_url: 'http://hirthe.name/khalid.brown',
        co_list_agent_voice_mail_ext: '8097',
        co_list_agent_voice_mail: '(601) 132-0959'
      },
      co_list_office: {
        co_list_office_aor: 'MyString',
        co_list_office_email: 'MyString',
        co_list_office_fax: 'MyString',
        co_list_office_key: 'MyString',
        co_list_office_key_numeric: 1,
        co_list_office_mls_id: 'MyString',
        co_list_office_name: 'MyString',
        co_list_office_phone_ext: 'MyString',
        co_list_office_phone: 'MyString',
        co_list_office_url: 'MyText'
      },
      list_agent: {
        list_agent_aor: 'Andromeda',
        list_agent_designation: 'Transnational Referral Certification / TRC',
        list_agent_direct_phone: '1-678-365-3896 x517',
        list_agent_email: 'demetris.zieme@hills.info',
        list_agent_fax: '(600) 137-6908 x3031',
        list_agent_first_name: 'Nellie',
        list_agent_full_name: 'Nellie Zieme',
        list_agent_home_phone: '(940) 618-4242',
        list_agent_key: '03e38494a30cd3c50e6f7a58476d8d36',
        list_agent_key_numeric: 4211528329,
        list_agent_last_name: 'Zieme',
        list_agent_middle_name: 'Antonette',
        list_agent_mls_id: '38e359cce292a7625d791b5e7edcc5e4',
        list_agent_mobile_phone: '562-071-3806 x867',
        list_agent_name_prefix: 'Mrs.',
        list_agent_name_suffix: 'IV',
        list_agent_office_phone_ext: '1190',
        list_agent_office_phone: '813.810.4830 x67298',
        list_agent_pager: '177.007.6468 x002',
        list_agent_preferred_phone_ext: '9265',
        list_agent_preferred_phone: '(531) 336-4377',
        list_agent_state_license: '798ca6a0c821d098da67f3e9b0414cb8',
        list_agent_toll_free_phone: '980-520-1355',
        list_agent_url: 'http://von.co/adolph',
        list_agent_voice_mail_ext: '1902',
        list_agent_voice_mail: '939.776.8378'
      },
      list_office: {
        list_office_aor: 'MyString',
        list_office_email: 'MyString',
        list_office_fax: 'MyString',
        list_office_key: 'MyString',
        list_office_key_numeric: 1,
        list_office_mls_id: 'MyString',
        list_office_name: 'MyString',
        list_office_phone_ext: 'MyString',
        list_office_phone: 'MyString',
        list_office_url: 'MyText'
      },
      team: {
        buyer_team_key: 'MyString',
        buyer_team_key_numeric: 1,
        buyer_team_name: 'MyString',
        list_team_key: 'MyString',
        list_team_key_numeric: 1,
        list_team_name: 'MyString'
      }
    },
    closing: {
      availability_date: '2018-04-12T18:34:08.000Z',
      buyer_financing: 'MyText',
      concessions_amount: 1,
      concessions_comments: 'MyString',
      concessions: 'MyString',
      contingency: 'MyText',
      possession: 'MyString'
    },
    compensation: {
      buyer_agency_compensation: 'MyString',
      buyer_agency_compensation_type: 'MyString',
      dual_variable_compensation_y_n: true,
      lease_renewal_compensation: 'MyString',
      sub_agency_compensation: 'MyString',
      sub_agency_compensation_type: 'MyString',
      transaction_broker_compensation: 'MyString',
      transaction_broker_compensation_type: 'MyString'
    },
    contract: {
      current_financing: 'MyText',
      disclosures: 'MyText',
      exclusions: 'MyText',
      inclusions: 'MyText',
      listing_terms: 'MyText',
      ownership: 'MyText',
      special_listing_conditions: 'MyText',
      common_interest: 'MyString'
    },
    dates: {
      cancelation_date: '2018-04-12T21:05:48.000Z',
      close_date: '2018-04-12T21:05:48.000Z',
      contingent_date: '2018-04-12T21:05:48.000Z',
      contract_status_change_date: '2018-04-12T21:05:48.000Z',
      cumulative_days_on_market: 1,
      days_on_market: 1,
      expiration_date: '2018-04-12T21:05:48.000Z',
      listing_contract_date: '2018-04-12T21:05:48.000Z',
      major_change_timestamp: '2018-04-12T21:05:48.000Z',
      major_change_type: 'MyString',
      modification_timestamp: '2018-04-18T05:47:46.000Z',
      off_market_date: '2018-04-12T21:05:48.000Z',
      off_market_timestamp: '2018-04-12T21:05:48.000Z',
      on_market_date: '2018-04-12T21:05:48.000Z',
      on_market_timestamp: '2018-04-12T21:05:48.000Z',
      original_entry_timestamp: '2018-04-12T21:05:48.000Z',
      pending_timestamp: '2018-04-12T21:05:48.000Z',
      price_change_timestamp: '2018-04-12T21:05:48.000Z',
      purchase_contract_date: '2018-04-12T21:05:48.000Z',
      status_change_timestamp: '2018-04-12T21:05:48.000Z',
      withdrawn_date: '2018-04-12T21:05:48.000Z'
    },
    marketing: {
      internet_address_display_y_n: true,
      internet_automated_valuation_display_y_n: true,
      internet_consumer_comment_y_n: false,
      internet_entire_listing_display_y_n: false,
      sign_on_property_y_n: false,
      syndicate_to: 'MyText',
      virtual_tour_url_branded: 'MyText',
      virtual_tour_url_unbranded: 'MyText'
    },
    media: {
      documents_available: 'MyText',
      documents_change_timestamp: '2018-04-13T10:56:27.000Z',
      documents_count: 1,
      photos_change_timestamp: '2018-04-19T22:24:45.000Z',
      photos_count_field: 1,
      videos_change_timestamp: '2018-04-13T10:56:27.000Z',
      videos_count: 1
    },
    price: {
      close_price: '9.99',
      list_price: '3615143.0',
      list_price_low: '9.99',
      original_list_price: '9.99',
      previous_list_price: '9.99'
    },
    remarks: {
      private_office_remarks: 'MyText',
      private_remarks: 'MyText',
      public_remarks: 'MyText',
      syndication_remarks: 'MyText'
    },
    showing: {
      access_code: 'MyString',
      lock_box_location: 'MyString',
      lock_box_serial_number: 'MyString',
      lock_box_type: 'MyText',
      showing_advance_notice: 1,
      showing_attended_y_n: false,
      showing_contact_name: 'MyString',
      showing_contact_phone_ext: 'MyString',
      showing_contact_phone: 'MyString',
      showing_contact_type: 'MyString',
      showing_days: 'MyText',
      showing_instructions: 'MyText',
      showing_requirements: 'MyText',
      showing_start_time: '2018-04-13T11:12:22.000Z',
      showing_end_time: '2018-04-13T11:12:22.000Z'
    }
  },
  occupant_owner: {
    occupant_name: 'MyString',
    occupant_phone: 'MyString',
    occupant_type: 'MyString',
    owner_name: 'MyString',
    owner_phone: 'MyString'
  },
  structure: {
    above_grade_finished_area: '9.99',
    above_grade_finished_area_source: 'MyString',
    above_grade_finished_area_units: 1,
    accessibility_features: 'MyText',
    architectural_style: 'MyText',
    attached_garage_y_n: false,
    basement: 'MyText',
    bathrooms_full: 1,
    bathrooms_half: 1,
    bathrooms_one_quarter: 1,
    bathrooms_partial: 1,
    bathrooms_three_quarter: 1,
    bathrooms_total_integer: 1,
    bedrooms_possible: 1,
    bedrooms_total: 1,
    below_grade_finished_area: '9.99',
    below_grade_finished_area_source: 'MyString',
    below_grade_finished_area_units: 'MyString',
    body_type: 'MyText',
    builder_model: 'MyString',
    builder_name: 'MyString',
    building_area_source: 'MyString',
    building_area_total: '9.99',
    building_area_units: 'MyString',
    building_features: 'MyText',
    building_name: 'MyString',
    carport_spaces: '9.99',
    carport_y_n: false,
    common_walls: 'MyText',
    construction_materials: 'MyText',
    cooling_field: 'MyText',
    cooling_y_n: true,
    covered_spaces: '9.99',
    direction_faces: 'MyString',
    doh_1: 'MyString',
    doh_2: 'MyString',
    doh_3: 'MyString',
    door_features: 'MyText',
    entry_level: 1,
    entry_location: 'MyString',
    exterior_features: 'MyText',
    fireplace_features: 'MyText',
    fireplaces_total: 1,
    fireplace_y_n: false,
    flooring: 'MyText',
    foundation_area: '9.99',
    foundation_details: 'MyText',
    garage_spaces: '9.99',
    garage_y_n: true,
    habitable_residence_y_n: false,
    heating: 'MyText',
    heating_y_n: true,
    interior_features: 'MyText',
    leasable_area: '9.99',
    leasable_area_units: 'MyString',
    levels: 'MyText',
    license_1: 'MyString',
    license_2: 'MyString',
    license_3: 'MyString',
    living_area: '9.99',
    living_area_source: 'MyString',
    living_area_units: 'MyString',
    main_level_bathrooms: 1,
    main_level_bedrooms: 1,
    make: 'MyString',
    mobile_dim_units: 'MyString',
    mobile_length: 1,
    mobile_width: 1,
    model: 'MyString',
    new_construction_y_n: false,
    open_parking_spaces: '9.99',
    open_parking_y_b: true,
    other_structures: 'MyText',
    parking_features: 'MyText',
    parking_total: '9.99',
    patio_and_porch_features: 'MyText',
    property_attached_y_n: true,
    property_condition: 'MyText',
    roof: 'MyText',
    rv_parking_dimensions: 'MyString',
    serial_u: 'MyString',
    serial_x: 'MyString',
    serial_xx: 'MyString',
    skirt: 'MyText',
    stories: 1,
    stories_total: 1,
    structure_type: 'MyString',
    window_features: 'MyText',
    year_built_details: 'MyText',
    year_built_effective: 1,
    year_built: 1,
    year_built_source: 'MyString',
    performance: {
      green_marketing: {
        green_energy_efficient: 'MyText',
        green_energy_generation: 'MyText',
        green_indoor_air_quality: 'MyText',
        green_location: 'MyText',
        green_sustainability: 'MyText',
        green_water_conservation: 'MyText'
      }
    }
  },
  tax: {
    additional_parcels_description: 'MyString',
    additional_parcels_y_n: true,
    parcel_number: 'MyString',
    public_survey_range: 'MyString',
    public_survey_section: 'MyString',
    public_survey_township: 'MyString',
    tax_annual_amount: '9.99',
    tax_assessed_value: 1,
    tax_block: 'MyString',
    tax_book_number: 'MyString',
    tax_legal_description: 'MyText',
    tax_lot_field: 'MyString',
    tax_map_number: 'MyString',
    tax_other_annual_assessment_amount: '9.99',
    tax_parcel_letter: 'MyString',
    tax_status_current: 'MyString',
    tax_tract: 'MyString',
    tax_year: 1,
    zoning_description: 'MyString',
    zoning_field: 'MyString'
  },
  utility: {
    distance_to_bus_comments: 'MyString',
    distance_to_bus_numeric: 1,
    distance_to_bus_units: 'MyString',
    distance_to_electric_comments: 'MyString',
    distance_to_electric_numeric: 1,
    distance_to_electric_units: 'MyString',
    distance_to_freeway_comments: 'MyString',
    distance_to_freeway_numeric: 1,
    distance_to_freeway_units: 'MyString',
    distance_to_gas_comments: 'MyString',
    distance_to_gas_numeric: 1,
    distance_to_gas_units: 'MyString',
    distance_to_phone_service_comments: 'MyString',
    distance_to_phone_service_numeric: 1,
    distance_to_phone_service_units: 'MyString',
    distance_to_placeof_worship_comments: 'MyString',
    distance_to_placeof_worship_numeric: 1,
    distance_to_placeof_worship_units: 'MyString',
    distance_to_school_bus_comments: 'MyString',
    distance_to_school_bus_numeric: 1,
    distance_to_school_bus_units: 'MyString',
    distance_to_schools_comments: 'MyString',
    distance_to_schools_numeric: 1,
    distance_to_schools_units: 'MyString',
    distance_to_sewer_comments: 'MyString',
    distance_to_sewer_numeric: 1,
    distance_to_sewer_units: 'MyString',
    distance_to_shopping_comments: 'MyString',
    distance_to_shopping_numeric: 1,
    distance_to_shopping_units: 'MyString',
    distance_to_street_comments: 'MyString',
    distance_to_street_numeric: 1,
    distance_to_street_units: 'MyString',
    distance_to_water_comments: 'MyString',
    distance_to_water_numeric: 1,
    distance_to_water_units: 'MyString',
    electric: 'MyText',
    electric_on_property_y_n: true,
    irrigation_source: 'MyText',
    irrigation_water_rights_acres: '9.99',
    irrigation_water_rights_y_n: false,
    number_of_separate_electric_meters: 1,
    number_of_separate_gas_meters: 1,
    number_of_separate_water_meters: 1,
    sewer: 'MyText',
    utilities: 'MyText',
    water_source: 'MyText'
  }
};

function getPropertiesMock() {
  var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var customProperties = cloneDeep_1(properties);

  for (var i = 1; i <= total; i += 1) {
    customProperties.results.push(cloneDeep_1(property));
    customProperties.results[i - 1].id = i;
  }

  customProperties.total = total;

  return cloneDeep_1(customProperties);
}

function getPropertyMock() {
  return cloneDeep_1(property);
}

var users = {
  total: 20,
  results: [{
    id: 1,
    website_id: 1,
    email: 'dev@displet.com',
    title: 'Ms.',
    first_name: 'Josiane',
    last_name: 'Hauck',
    display_name: 'Dr. Eloise Okuneva',
    realtor: true,
    mls_member: true,
    uid: '53c1514d-9089-430a-a4d2-615a6c950aac',
    biography: null,
    created_at: '2018-03-09T17:40:57.151Z',
    updated_at: '2018-03-09T17:41:44.248Z',
    agent_type: null,
    role: 'agent',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [{
      date: '1970-05-11T00:00:00.000Z',
      id: 2,
      type: 'Birthday'
    }],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 2,
    website_id: 1,
    email: 'lauriane2@gorczany.co',
    title: 'Miss',
    first_name: 'Mallory',
    last_name: 'Abbott',
    display_name: 'Damaris Gleason DVM',
    realtor: true,
    mls_member: false,
    uid: '29f51cb4-2afd-4168-88f1-4ea5db47354d',
    biography: null,
    created_at: '2018-03-09T17:40:57.242Z',
    updated_at: '2018-03-09T17:51:06.504Z',
    agent_type: null,
    role: 'lender',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 3,
    website_id: 1,
    email: 'ro3@sanford.com',
    title: 'Dr.',
    first_name: 'Hardy',
    last_name: 'Turner',
    display_name: 'Dakota Brekke DVM',
    realtor: true,
    mls_member: true,
    uid: '8b68918c-1dad-4385-94e0-e1a87f7c6ebc',
    biography: null,
    created_at: '2018-03-09T17:40:57.329Z',
    updated_at: '2018-03-09T17:40:57.329Z',
    agent_type: null,
    role: 'admin',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 4,
    website_id: 1,
    email: 'ezra_bergnaum4@halvorson.biz',
    title: 'Mrs.',
    first_name: 'Halle',
    last_name: 'Renner',
    display_name: 'Salvatore Beatty',
    realtor: false,
    mls_member: false,
    uid: 'a2fb6d1f-b5ad-46c4-9bbd-3be753acc4c3',
    biography: null,
    created_at: '2018-03-09T17:40:57.415Z',
    updated_at: '2018-03-09T17:40:57.415Z',
    agent_type: null,
    role: 'staff',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 5,
    website_id: 1,
    email: 'emmitt5@wilderman.net',
    title: 'Ms.',
    first_name: 'Jose',
    last_name: 'Kertzmann',
    display_name: 'Isaias Volkman',
    realtor: false,
    mls_member: true,
    uid: '7d8e68db-2f33-4d0d-abad-d1e30cb1344a',
    biography: null,
    created_at: '2018-03-09T17:40:57.500Z',
    updated_at: '2018-03-09T17:40:57.500Z',
    agent_type: null,
    role: 'super',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 6,
    website_id: 1,
    email: 'stevie6@treutelrippin.org',
    title: 'Dr.',
    first_name: 'Juliana',
    last_name: 'Mitchell',
    display_name: 'Xzavier Rice',
    realtor: true,
    mls_member: true,
    uid: 'a27f1715-d43e-4542-ace4-e6aaa14cfe36',
    biography: null,
    created_at: '2018-03-09T17:40:57.587Z',
    updated_at: '2018-03-09T17:40:57.587Z',
    agent_type: null,
    role: 'agent',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 7,
    website_id: 1,
    email: 'riley7@hahnprice.info',
    title: 'Miss',
    first_name: 'Johnathon',
    last_name: 'Weber',
    display_name: 'Lela Luettgen Sr.',
    realtor: false,
    mls_member: false,
    uid: 'a07245a9-ef4c-4a55-959a-3e0e1d2ef594',
    biography: null,
    created_at: '2018-03-09T17:40:57.673Z',
    updated_at: '2018-03-09T17:40:57.673Z',
    agent_type: null,
    role: 'agent',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 8,
    website_id: 1,
    email: 'stuart8@cremin.io',
    title: 'Mrs.',
    first_name: 'Keyon',
    last_name: 'Balistreri',
    display_name: 'Shane Braun',
    realtor: false,
    mls_member: false,
    uid: '52adae68-26eb-4321-925c-6eeb88131981',
    biography: null,
    created_at: '2018-03-09T17:40:57.761Z',
    updated_at: '2018-03-09T17:40:57.761Z',
    agent_type: null,
    role: 'agent',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 9,
    website_id: 1,
    email: 'peyton9@doyleherzog.io',
    title: 'Miss',
    first_name: 'Lenna',
    last_name: 'Johnston',
    display_name: 'Jaydon Sporer PhD',
    realtor: false,
    mls_member: true,
    uid: '77d0ef3e-e7c4-47c4-b06c-cb31394c9658',
    biography: null,
    created_at: '2018-03-09T17:40:57.846Z',
    updated_at: '2018-03-09T17:40:57.846Z',
    agent_type: null,
    role: 'agent',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [{
      id: 1,
      primary: true,
      type: 'Personal',
      number: '8008675309',
      extension: null
    }],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }, {
    id: 10,
    website_id: 1,
    email: 'armand_murray10@gottlieb.biz',
    title: 'Ms.',
    first_name: 'Johnnie',
    last_name: 'Heaney',
    display_name: 'Dr. Finn Medhurst',
    realtor: true,
    mls_member: true,
    uid: 'dccaac43-72a7-4168-8fff-93e965bfe7f6',
    biography: null,
    created_at: '2018-03-09T17:40:57.929Z',
    updated_at: '2018-03-09T17:40:57.929Z',
    agent_type: null,
    role: 'staff',
    additional_email_addresses: [],
    addresses: [],
    custom_identifiers: [],
    designations: [],
    important_dates: [],
    languages: [],
    licenses: [],
    phone_numbers: [{
      id: 1,
      primary: true,
      type: 'Personal',
      number: '8008675309',
      extension: '1234'
    }],
    photos: [],
    relatives: [],
    teams: [],
    urls: []
  }]
};

function getUsersMock() {
  return cloneDeep_1(users);
}

function getUserMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(users.results[index]);
}

var userActivities = {
  total: 5,
  results: [{
    type: 'login',
    created_at: '2018-10-16T14:10:57.706Z',
    resource: null
  }, {
    type: 'user_note',
    created_at: '2018-10-15T16:56:16.357Z',
    resource: {
      id: 1,
      body: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      created_at: '2018-10-15T16:56:16.357Z',
      updated_at: '2018-10-15T16:56:16.357Z',
      owner_user: {
        id: 1,
        email: 'dev@displet.com',
        title: 'Mr.',
        first_name: 'Garnet',
        last_name: 'Nikolaus',
        display_name: 'Kirstin Kessler DDS',
        realtor: false,
        mls_member: true,
        uid: '49c63bda-ca6a-4f32-a4f9-21f90e06e413',
        created_at: '2018-10-15T16:50:46.568Z',
        updated_at: '2018-10-15T16:52:02.327Z',
        role: 'admin',
        website: {
          id: 2,
          network_id: 1,
          name: 'Jar Jar Binks 2',
          url: 'https://2kihnkeler.com',
          created_at: '2018-10-15T16:50:46.496Z',
          updated_at: '2018-10-15T16:50:46.496Z',
          contact_login_url: 'http://corkerylubowitz.co/tyson',
          user_login_url: 'http://bins.io/gerardo',
          email: 'elenora.cummings@ortiz.name',
          market_id: 2,
          referer: '2wehner.net',
          contact_password_reset_url: 'http://collinsborer.co/anthony_ferry',
          user_password_reset_url: 'http://spinkalemke.name/judd.kuhic'
        },
        photos: []
      }
    }
  }, {
    type: 'property_note',
    created_at: '2018-10-15T16:56:01.494Z',
    resource: {
      id: 1,
      body: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      created_at: '2018-10-15T16:56:01.494Z',
      updated_at: '2018-10-15T16:56:01.494Z',
      property: {
        id: 69,
        property_type: 'Residential',
        property_sub_type: 'Multi Family',
        property_universal_id: 'd6e8bfc957dbd3efe60334e4fbb5a477',
        source: 'User',
        private: false,
        property_id: null,
        user_id: 1,
        location: {
          address: {
            carrier_route: 'Wood-aged Beer',
            city: 'East Annalise',
            country: 'United States',
            county_or_parish: 'Nautelle Wetlands',
            postal_city: 'Theresestad',
            postal_code: '72668-7022',
            postal_code_plus_4: '4134',
            state_or_province: 'MN',
            street_additional_info: 'Stone IPA',
            street_dir_prefix: 'SW',
            street_dir_suffix: 'N',
            street_name: 'Ronny Wall',
            street_number: '22',
            street_number_numeric: 22,
            street_suffix: 'Center',
            street_suffix_modifier: 'Bullion',
            township: '3711 - French Saison',
            unit_number: '6177',
            unparsed_address: '95115 Daniel Causeway'
          },
          area: {
            city_region: 'Dumbell Nebula',
            continent_region: 'Messier 7',
            country_region: 'Wolf 359',
            mls_area_major: 'Earth',
            mls_area_minor: 'Oberon',
            state_region: 'F',
            subdivision_name: 'Pine Court'
          },
          gis: {
            cross_street: 'Brown Summit',
            directions: 'I always knew Will was gonna be the downfall of this family, but no one ever listens to me.',
            elevation: 2,
            elevation_units: 'inches',
            latitude: '-34.33256799593338',
            longitude: '-1.6552599645422674',
            map_coordinate: '35 megaparsecs',
            map_coordinate_source: 'Qidong',
            map_url: 'http://feestoreilly.info/mathew'
          },
          school: {
            elementary_school_district: 'University of Akron Press',
            elementary_school: 'Blue Remembered Earth',
            high_school_district: 'Penguin Books',
            high_school: 'The Yellow Meads of Asphodel',
            middle_or_junior_school_district: 'Bellevue Literary Press',
            middle_or_junior_school: 'To Say Nothing of the Dog'
          }
        },
        media: [{
          id: 698,
          media_key: '69842a1b4ac57107662fdff4787821e5e3b',
          media_status: 'Active',
          modification_timestamp: '2018-10-14T00:53:41.000Z',
          media_type: 'xls',
          media_category: 'Floor Plan',
          image_size_description: 'Thumbnail',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eos illum qui atque rerum.',
          long_description: 'Ex et molestias esse aut doloribus sed tempore. Qui aliquid odio. Ullam molestias sed. Sed nulla aspernatur unde ut. Cumque sed corrupti maxime ea at autem et.\nRem molestiae qui necessitatibus quaerat tempore libero quia. Quisquam quis aut sed amet explicabo a. Qui ut modi tempora doloribus quis.\nOmnis sequi architecto. Asperiores non sit numquam ipsum quo reiciendis odio. Neque magni fuga ullam sit rerum ab.',
          created_at: '2018-10-15T16:52:02.648Z',
          updated_at: '2018-10-15T16:52:02.648Z'
        }, {
          id: 699,
          media_key: '699878a2b828f97db7d21d1fda20a29933a',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-06T07:17:06.000Z',
          media_type: 'docx',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 27,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Quos ullam architecto nihil et nobis.',
          long_description: 'Quo accusantium qui dicta animi voluptatem voluptates odit. Iusto adipisci quidem. Consequatur saepe voluptates fuga optio voluptatem. Dolore ut aliquam eum minima a deserunt.\nId ad eius earum tenetur. Cumque quo dignissimos deleniti quis aut. Esse ut in temporibus nihil aut provident. Sed voluptas ipsum quos modi doloribus.\nItaque eos consequatur repudiandae placeat non sit quibusdam. Rerum unde autem. Et dicta aut placeat blanditiis est necessitatibus. Omnis dignissimos laborum illo dolore beatae. Ea nihil deleniti qui rem optio blanditiis asperiores.',
          created_at: '2018-10-15T16:52:02.674Z',
          updated_at: '2018-10-15T16:52:02.674Z'
        }, {
          id: 700,
          media_key: '7006ebc0cb5f55b26bac0b281eb60e5d9a1',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-16T13:10:02.000Z',
          media_type: 'xls',
          media_category: 'Floor Plan',
          image_size_description: 'Large',
          order: 14,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Est dolore voluptatem minima harum eaque non.',
          long_description: 'Soluta aut ea autem et alias et. Quis minima molestiae aliquid fugit culpa omnis. Et repudiandae omnis. Perferendis sit earum in molestiae amet quis. Nam laborum voluptatibus occaecati totam excepturi itaque.\nMaxime quia ea distinctio voluptas. Animi autem aperiam eius sint eveniet est voluptas. Non ut est ab quae ut.\nAt dolores magni accusantium et possimus aut ad. Saepe libero autem. Odio atque natus corporis. Voluptates illum odit nostrum placeat vero dolor. Quia non deserunt aspernatur.',
          created_at: '2018-10-15T16:52:02.710Z',
          updated_at: '2018-10-15T16:52:02.710Z'
        }, {
          id: 701,
          media_key: '701d48ac0be3b94ee284b9b62043b463c43',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T19:03:46.000Z',
          media_type: 'txt',
          media_category: 'Floor Plan',
          image_size_description: 'Thumbnail',
          order: 5,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Aut quaerat fugiat hic est est.',
          long_description: 'Sapiente molestiae consequatur numquam ipsam maxime. Beatae sed qui minima. Officia ea nihil dicta laboriosam.\nMolestias quia eos dolor voluptatem. Doloribus voluptatem qui amet vitae. Assumenda fuga est illo est molestias nihil. Possimus laboriosam quos quia.\nNesciunt aliquam aspernatur exercitationem. Sunt explicabo est amet dicta qui. Quia aperiam in exercitationem aliquid. Impedit quo laudantium sint iusto et. Quod aliquam ut rerum sequi et.',
          created_at: '2018-10-15T16:52:02.733Z',
          updated_at: '2018-10-15T16:52:02.733Z'
        }, {
          id: 702,
          media_key: '702b09272685597416d839f73a2e0b701c9',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-03T11:50:11.000Z',
          media_type: 'rtf',
          media_category: 'Agent Photo',
          image_size_description: 'Thumbnail',
          order: 25,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Amet esse excepturi eos qui voluptates doloremque at.',
          long_description: 'Placeat fugiat et dolores. Sint temporibus reprehenderit dolores. Quo distinctio ratione. Voluptatibus ut voluptatem quia necessitatibus esse id.\nFuga quos et sit ipsa cum necessitatibus. In nisi est ipsum et a omnis dignissimos. Porro blanditiis autem officia sit consequatur expedita. Est molestias maiores. Suscipit ab earum vel accusantium totam.\nVoluptatum dolorem magnam magni. Cum mollitia quo aut velit corrupti. Perferendis voluptate molestiae assumenda nostrum autem. Numquam sint dicta. Consectetur quas odio ea provident.',
          created_at: '2018-10-15T16:52:02.755Z',
          updated_at: '2018-10-15T16:52:02.755Z'
        }, {
          id: 703,
          media_key: '703f84b6be86812ba72e2e496a565b2cff3',
          media_status: 'Active',
          modification_timestamp: '2018-09-21T20:26:17.000Z',
          media_type: 'xls',
          media_category: 'Photo',
          image_size_description: 'Large',
          order: 16,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Repellat excepturi exercitationem delectus praesentium quis nobis corrupti iste.',
          long_description: 'Ipsa eligendi sed numquam omnis voluptatem sint cupiditate. Et saepe consequatur minus aut. Eaque quibusdam eum pariatur ut aliquid.\nEnim numquam aut perspiciatis. Est sequi quia architecto fuga laudantium. Aspernatur et omnis qui tenetur aliquam nihil saepe. Enim eius quis nostrum.\nQuia repellat qui sed quaerat. Quaerat quia quis doloremque modi aut. Reiciendis voluptates iste quae rerum vel molestias. Quia fugit qui et non quidem omnis eos.',
          created_at: '2018-10-15T16:52:02.777Z',
          updated_at: '2018-10-15T16:52:02.777Z'
        }, {
          id: 704,
          media_key: '7041bf8b69adada70895e4b71101502d28f',
          media_status: 'Inactive',
          modification_timestamp: '2018-09-18T12:47:18.000Z',
          media_type: 'mp4',
          media_category: 'Floor Plan',
          image_size_description: 'X-Large',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Eum repellendus fugiat sed quia sit saepe.',
          long_description: 'Laborum et quo sit necessitatibus qui odio eius. Qui dolores beatae. Omnis nobis delectus non eveniet earum qui. Dolore corrupti voluptates.\nEarum neque in quia ducimus et deserunt. Et dolorem fugiat laborum natus. Eligendi molestias est. Architecto quo omnis aut ipsa.\nReiciendis suscipit aut voluptatum labore qui repellat. Perferendis dignissimos quaerat est. Veniam quis eius nisi pariatur accusantium. Nesciunt dolor asperiores rerum voluptas praesentium. Accusantium at quibusdam facilis.',
          created_at: '2018-10-15T16:52:02.799Z',
          updated_at: '2018-10-15T16:52:02.799Z'
        }, {
          id: 705,
          media_key: '705da1c5c928f742b326aac1d5ace6301af',
          media_status: 'Active',
          modification_timestamp: '2018-10-06T14:08:33.000Z',
          media_type: 'txt',
          media_category: 'Office Photo',
          image_size_description: 'X-Large',
          order: 2,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Atque est consequatur esse soluta voluptates.',
          long_description: 'Consequatur quae natus culpa. Tempora sint qui voluptas earum ipsam porro neque. Quia laborum eligendi blanditiis assumenda perferendis.\nRepellendus officia eaque in minus ut sapiente magnam. Facilis culpa consequatur. Eveniet illo quaerat cupiditate eligendi aut ut. Et perspiciatis quibusdam sit repellat.\nUt nostrum nisi rem. Molestias quia et suscipit et et. Veniam ab et aperiam quae exercitationem aspernatur.',
          created_at: '2018-10-15T16:52:02.821Z',
          updated_at: '2018-10-15T16:52:02.821Z'
        }, {
          id: 706,
          media_key: '706db0ea8c32453add6cf061c85d957ecf6',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-01T12:15:47.000Z',
          media_type: 'xls',
          media_category: 'Floor Plan',
          image_size_description: 'X-Large',
          order: 13,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Autem dolorum voluptatem voluptas mollitia eligendi blanditiis.',
          long_description: 'Consequatur placeat corporis sit quia voluptatem cum officiis. Beatae odio dolorem distinctio iure autem autem. Beatae omnis autem tenetur voluptas rerum molestiae. Quidem iusto deleniti et impedit vitae. Fugit reprehenderit quasi autem deleniti quidem et.\nIste voluptas illum cupiditate incidunt. Ea est sunt dolor. Fuga consequatur aspernatur quia ex. Libero molestiae et omnis adipisci. Voluptatibus odio quam quia repellat et architecto veniam.\nA voluptate corporis odit et esse voluptas rem. Ex pariatur aut aut est ut. Ullam aut dignissimos aut. Illum nam ipsa id nulla quo officia explicabo.',
          created_at: '2018-10-15T16:52:02.845Z',
          updated_at: '2018-10-15T16:52:02.845Z'
        }, {
          id: 707,
          media_key: '7075a34c451804435be40a3e331af4e7b66',
          media_status: 'Active',
          modification_timestamp: '2018-09-09T20:29:52.000Z',
          media_type: 'xlsx',
          media_category: 'Unbranded Virtual Tour',
          image_size_description: 'Small',
          order: 20,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Veniam quia alias sit.',
          long_description: 'Dolores nemo placeat. Qui quis aliquam reprehenderit esse. Quo et quod quo eveniet nisi voluptas. Aut illo atque minus.\nHarum voluptatum quia quia molestiae provident repudiandae. Eum explicabo quia eius et. Qui assumenda earum accusantium consequatur. Eos et sed nihil sed natus in. Inventore itaque magnam hic esse et.\nIpsa architecto illo aut nesciunt quibusdam minima. Voluptatum earum iste dolor minima. Enim iste quo minima ut magnam consequatur vel. Similique cupiditate aliquam natus qui maxime. Quis repellat officia est qui.',
          created_at: '2018-10-15T16:52:02.868Z',
          updated_at: '2018-10-15T16:52:02.868Z'
        }, {
          id: 708,
          media_key: '708ae12d04c7d33dd835ff86a9d4237e3a3',
          media_status: 'Active',
          modification_timestamp: '2018-09-22T20:57:16.000Z',
          media_type: 'jpeg',
          media_category: 'Agent Photo',
          image_size_description: 'Medium',
          order: 30,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Nulla nihil quas et cupiditate.',
          long_description: 'Dolore est ut quod quis rerum. Ut dolorem qui vitae rem. Nemo non incidunt quam quos. Dolorum accusantium officia magnam praesentium fugit. Et aut quis voluptas eum.\nIncidunt inventore consectetur voluptas. Eos eligendi voluptate sit est magnam. Voluptatem quos accusantium quisquam corrupti.\nDolores et autem ut enim nesciunt repellat. Magni quia repellendus alias. Id veritatis eaque ipsam quod.',
          created_at: '2018-10-15T16:52:02.891Z',
          updated_at: '2018-10-15T16:52:02.891Z'
        }, {
          id: 709,
          media_key: '709a758b13eaaf66ddb475280cc532bb0b0',
          media_status: 'Active',
          modification_timestamp: '2018-10-05T16:35:53.000Z',
          media_type: 'wmv',
          media_category: 'Photo',
          image_size_description: 'Thumbnail',
          order: 10,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Velit omnis dolores earum corrupti mollitia sapiente ex iure.',
          long_description: 'Magni id expedita explicabo adipisci aliquam suscipit dignissimos. Consequatur unde harum explicabo quae facere blanditiis. Consequatur sunt fugiat. Occaecati quidem laborum.\nFacilis voluptatibus sit qui sint sapiente. Et nihil at modi accusamus id repudiandae. At tempore et dolorem alias quasi. Labore sapiente dicta doloremque sed totam at. Sed dolorum dolores ex ducimus.\nRem eum aliquam fugit rerum velit officiis. Delectus eum voluptatem quia sint animi. Quod quaerat ea. Aliquid nulla eveniet quas molestiae et. Dolor eius et ut illum rerum voluptatem.',
          created_at: '2018-10-15T16:52:02.920Z',
          updated_at: '2018-10-15T16:52:02.920Z'
        }, {
          id: 710,
          media_key: '7104637c363371fdfcc2a89148613f42a62',
          media_status: 'Active',
          modification_timestamp: '2018-09-25T02:00:06.000Z',
          media_type: 'quicktime',
          media_category: 'Photo',
          image_size_description: 'Thumbnail',
          order: 21,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Exercitationem eum vel voluptas minima error in quia.',
          long_description: 'Asperiores enim libero labore ex expedita. Dolores magnam qui nulla fugit. Assumenda neque error nemo. Possimus quo rerum veniam accusantium porro non.\nAut quos qui. Rerum sapiente libero nihil illum consequuntur quos. Recusandae ut architecto beatae et. Maxime quaerat cum est unde saepe. Quia quis in consequatur quia praesentium.\nPossimus sit repellat dolore nobis. Omnis eum quia et doloremque. Et et voluptate.',
          created_at: '2018-10-15T16:52:02.942Z',
          updated_at: '2018-10-15T16:52:02.942Z'
        }, {
          id: 711,
          media_key: '71137bb0be6c6c98a677528ee3e320578c6',
          media_status: 'Active',
          modification_timestamp: '2018-09-26T17:18:58.000Z',
          media_type: 'xls',
          media_category: 'Photo',
          image_size_description: 'Large',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Illum quia impedit est dolorem.',
          long_description: 'Iusto architecto assumenda sint. Possimus iste et est aperiam sed reprehenderit. Ut velit similique itaque porro rem. Iste minima quis ut. Eius similique est quam dolor.\nReiciendis dignissimos numquam quia. Molestias saepe adipisci qui. Molestiae accusamus est temporibus dolore ea neque.\nAutem a voluptatem vitae enim. Nostrum magni delectus ullam cupiditate. Autem nostrum dolores itaque sint.',
          created_at: '2018-10-15T16:52:02.963Z',
          updated_at: '2018-10-15T16:52:02.963Z'
        }, {
          id: 712,
          media_key: '712d16d7bd83d888cd5ec541f4847599412',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T16:39:41.000Z',
          media_type: 'quicktime',
          media_category: 'Office Logo',
          image_size_description: 'Small',
          order: 5,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Non hic sapiente dolor repellendus expedita voluptas odio odit.',
          long_description: 'Quae ut voluptatem qui quibusdam delectus. Delectus quo enim in nemo. Ipsum aut et eum aliquam placeat eius.\nError velit quae. Ex quae illo deserunt. Maxime ab labore quibusdam molestiae quas. Possimus consequatur et. Aut hic consequatur excepturi id quis ipsam.\nDolorem dolorem quibusdam numquam aut facere. Ipsum omnis distinctio non itaque. Magnam dolor vitae delectus.',
          created_at: '2018-10-15T16:52:02.982Z',
          updated_at: '2018-10-15T16:52:02.982Z'
        }, {
          id: 713,
          media_key: '71377305e17028e43f8bb013e9f57159cf1',
          media_status: 'Active',
          modification_timestamp: '2018-09-19T18:01:11.000Z',
          media_type: 'pdf',
          media_category: 'Floor Plan',
          image_size_description: 'X-Large',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Nisi natus quis quod.',
          long_description: 'Qui enim voluptatem. Molestias deleniti doloremque quibusdam est ut quis fuga. Facere sit illo. Quos beatae suscipit dolorem labore odio.\nDeleniti dicta sint in cumque magnam modi natus. Suscipit exercitationem occaecati cum. Tenetur exercitationem quod laudantium. Nemo commodi in. Corporis quisquam quia numquam suscipit et error vero.\nAliquam quod dolorem. Voluptatum dolores qui eius aperiam omnis. Recusandae distinctio nihil officia aut eius. Quo sed quidem aut.',
          created_at: '2018-10-15T16:52:03.003Z',
          updated_at: '2018-10-15T16:52:03.003Z'
        }, {
          id: 714,
          media_key: '714ef47df72430a965ef1f005419cfb1eed',
          media_status: 'Active',
          modification_timestamp: '2018-09-19T07:13:15.000Z',
          media_type: 'jpeg',
          media_category: 'Floor Plan',
          image_size_description: 'Large',
          order: 26,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Rerum culpa voluptatum dolore cum repellat id deserunt et.',
          long_description: 'Est at sunt dolorem dolor. Impedit minima voluptas culpa ut cumque qui et. Culpa odit sit. Vel nam qui saepe dolore.\nDucimus quibusdam dicta est non animi. Itaque sunt inventore nihil exercitationem. Est numquam veritatis et deleniti facere.\nQuaerat blanditiis autem quia eum ducimus occaecati similique. Vitae voluptatem eaque dolorem. Dolor quo quis.',
          created_at: '2018-10-15T16:52:03.028Z',
          updated_at: '2018-10-15T16:52:03.028Z'
        }, {
          id: 715,
          media_key: '715c3b00ad130036ec52ea18422486a3bf8',
          media_status: 'Active',
          modification_timestamp: '2018-10-12T16:24:47.000Z',
          media_type: 'mpeg',
          media_category: 'Branded Virtual Tour',
          image_size_description: 'X-Large',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Illo sit accusamus incidunt minima voluptatem.',
          long_description: 'Nulla occaecati tenetur eos enim. Quia dolorum laudantium recusandae. Minima eius doloribus ut error voluptatem in. Ipsam ea ratione accusamus.\nFugit sit blanditiis ut. Distinctio rerum quis omnis. Accusantium modi occaecati exercitationem et voluptas accusamus. Nihil ut maxime.\nEos nam et itaque. Ullam hic eum cum qui nostrum. Et a reiciendis quidem aut. Praesentium qui ea harum quia itaque animi. Voluptates illum et non reprehenderit.',
          created_at: '2018-10-15T16:52:03.052Z',
          updated_at: '2018-10-15T16:52:03.052Z'
        }, {
          id: 716,
          media_key: '7167e3f9aa1fbc1e996dcddd93e7c4dce4d',
          media_status: 'Inactive',
          modification_timestamp: '2018-10-15T02:42:58.000Z',
          media_type: 'quicktime',
          media_category: 'Agent Photo',
          image_size_description: 'Largest',
          order: 18,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ea ut veritatis sunt fugiat ratione minima cum.',
          long_description: 'Voluptatem corrupti vel a ducimus nisi et pariatur. Et quia dicta laudantium temporibus libero non sunt. Velit autem quia qui vitae suscipit. Mollitia quo quidem asperiores a vero.\nFuga corrupti magni sunt sint quaerat enim assumenda. Et dolorem temporibus nulla eos. Natus vitae dolores tenetur consequatur dolorum consequatur facilis. Vel praesentium quam.\nCumque ab quis aut occaecati voluptas animi praesentium. Sit est dolore. Blanditiis itaque facilis rem qui.',
          created_at: '2018-10-15T16:52:03.078Z',
          updated_at: '2018-10-15T16:52:03.078Z'
        }, {
          id: 717,
          media_key: '71775f12a8f87ea2062c6fa57396bb50807',
          media_status: 'Active',
          modification_timestamp: '2018-09-17T09:08:06.000Z',
          media_type: 'xls',
          media_category: 'Video',
          image_size_description: 'Largest',
          order: 8,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Ad enim distinctio nam ratione aspernatur quidem cum aut.',
          long_description: 'Cumque sunt eveniet doloribus est ipsam quia. Soluta quo molestiae in incidunt ratione est. Ut similique deleniti laborum. Voluptatem non sed vel numquam repudiandae nemo ut.\nLaudantium ullam hic. Et sapiente non. Neque animi modi. Ut nemo et. Error placeat iste labore quia et neque.\nIpsum quas omnis eos sequi. Possimus sunt et placeat unde accusantium incidunt. Ullam dolorem omnis nihil sunt facere iusto. Et libero et voluptatem culpa repellat ipsa aut. Ea magnam officiis ut eum assumenda est.',
          created_at: '2018-10-15T16:52:03.100Z',
          updated_at: '2018-10-15T16:52:03.100Z'
        }, {
          id: 718,
          media_key: '718c6aa7695bc65defd3449a38ebafb20ae',
          media_status: 'Active',
          modification_timestamp: '2018-09-04T19:41:40.000Z',
          media_type: 'mpeg',
          media_category: 'Floor Plan',
          image_size_description: 'Thumbnail',
          order: 7,
          media_url: 'http://lorempixel.com/300/300',
          short_description: 'Quia beatae earum asperiores.',
          long_description: 'Sunt fuga et et earum quisquam perferendis temporibus. Est labore cum. Rem atque minus aperiam voluptatibus ut.\nAut est ut provident recusandae aut. Placeat possimus suscipit aut ex non dicta cum. Omnis aspernatur laborum tenetur alias ex. Non sed deserunt minima aut alias.\nQuisquam libero expedita ab cumque. Et libero deserunt aut ea. Quisquam dolore voluptates deserunt. Qui nulla exercitationem rem at. Ea voluptas sunt ipsum reiciendis sed.',
          created_at: '2018-10-15T16:52:03.122Z',
          updated_at: '2018-10-15T16:52:03.122Z'
        }]
      },
      user: {
        id: 1,
        email: 'dev@displet.com',
        title: 'Mr.',
        first_name: 'Garnet',
        last_name: 'Nikolaus',
        display_name: 'Kirstin Kessler DDS',
        realtor: false,
        mls_member: true,
        uid: '49c63bda-ca6a-4f32-a4f9-21f90e06e413',
        created_at: '2018-10-15T16:50:46.568Z',
        updated_at: '2018-10-15T16:52:02.327Z',
        role: 'admin',
        website: {
          id: 2,
          network_id: 1,
          name: 'Jar Jar Binks 2',
          url: 'https://2kihnkeler.com',
          created_at: '2018-10-15T16:50:46.496Z',
          updated_at: '2018-10-15T16:50:46.496Z',
          contact_login_url: 'http://corkerylubowitz.co/tyson',
          user_login_url: 'http://bins.io/gerardo',
          email: 'elenora.cummings@ortiz.name',
          market_id: 2,
          referer: '2wehner.net',
          contact_password_reset_url: 'http://collinsborer.co/anthony_ferry',
          user_password_reset_url: 'http://spinkalemke.name/judd.kuhic'
        },
        photos: []
      }
    }
  }, {
    type: 'contact_note',
    created_at: '2018-10-15T16:55:45.723Z',
    resource: {
      id: 1,
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      created_at: '2018-10-15T16:55:45.723Z',
      updated_at: '2018-10-15T16:55:45.723Z',
      contact: {
        id: 74,
        user_id: 102,
        email: 'brett.metz74@schultz.net',
        title: 'Miss',
        first_name: 'Letitia',
        last_name: 'Hauck',
        display_name: 'Coty Daniel',
        company: 'Smitham and Sons',
        relocation: true,
        military: true,
        source: 'Company Site',
        channel: 'Realtor.com',
        referred_by: 'http://satterfieldstehr.info/summer.abernathy',
        status: 'Past Client',
        created_at: '2018-10-15T16:51:22.394Z',
        updated_at: '2018-10-15T16:51:22.394Z'
      },
      user: {
        id: 1,
        email: 'dev@displet.com',
        title: 'Mr.',
        first_name: 'Garnet',
        last_name: 'Nikolaus',
        display_name: 'Kirstin Kessler DDS',
        realtor: false,
        mls_member: true,
        uid: '49c63bda-ca6a-4f32-a4f9-21f90e06e413',
        created_at: '2018-10-15T16:50:46.568Z',
        updated_at: '2018-10-15T16:52:02.327Z',
        role: 'admin',
        website: {
          id: 2,
          network_id: 1,
          name: 'Jar Jar Binks 2',
          url: 'https://2kihnkeler.com',
          created_at: '2018-10-15T16:50:46.496Z',
          updated_at: '2018-10-15T16:50:46.496Z',
          contact_login_url: 'http://corkerylubowitz.co/tyson',
          user_login_url: 'http://bins.io/gerardo',
          email: 'elenora.cummings@ortiz.name',
          market_id: 2,
          referer: '2wehner.net',
          contact_password_reset_url: 'http://collinsborer.co/anthony_ferry',
          user_password_reset_url: 'http://spinkalemke.name/judd.kuhic'
        },
        photos: []
      }
    }
  }, {
    type: 'property',
    created_at: '2018-10-15T16:52:03.674Z',
    resource: {
      id: 71,
      property_type: 'Residential Income',
      property_sub_type: 'Duplex',
      property_universal_id: '58acf87b2fbcf6bdf6d73572bf011626',
      source: 'User',
      private: true,
      property_id: null,
      user_id: 1,
      location: {
        address: {
          carrier_route: 'Scottish And Irish Ale',
          city: 'Darenstad',
          country: 'United States',
          county_or_parish: 'Palu Wasteland',
          postal_city: 'Mayerborough',
          postal_code: '87742-2094',
          postal_code_plus_4: '2977',
          state_or_province: 'CO',
          street_additional_info: '90 Minute IPA',
          street_dir_prefix: 'NE',
          street_dir_suffix: 'N',
          street_name: 'Wiza Center',
          street_number: '3',
          street_number_numeric: 3,
          street_suffix: 'Villages',
          street_suffix_modifier: 'Warrior',
          township: '1084 - Irish Ale',
          unit_number: '3377',
          unparsed_address: '49999 Lubowitz Islands'
        },
        area: {
          city_region: 'Triffid Nebula',
          continent_region: 'Pyxis Cluster',
          country_region: 'Wolf 359',
          mls_area_major: 'Dimension C-132',
          mls_area_minor: 'Tethys',
          state_region: 'Eb',
          subdivision_name: 'University Oaks'
        },
        gis: {
          cross_street: 'Wayne Union',
          directions: 'My brother, you wanna take this outside?!?',
          elevation: 77,
          elevation_units: 'feet',
          latitude: '-77.6047701128094',
          longitude: '-164.41493812567163',
          map_coordinate: '90 AU',
          map_coordinate_source: 'Agen',
          map_url: 'http://ledner.biz/katrine_rippin'
        },
        school: {
          elementary_school_district: 'Pavilion Books',
          elementary_school: 'Blood\'s a Rover',
          high_school_district: 'Hawthorne Books',
          high_school: 'Time of our Darkness',
          middle_or_junior_school_district: 'D. Reidel',
          middle_or_junior_school: 'Noli Me Tangere'
        }
      },
      business: {
        business_name: 'Johnson, Rolfson and Feeney',
        business_type: 'librarian',
        hours_days_of_operation_description: 'Great Scott!',
        hours_days_of_operation: 'Open 8 Hours/Day',
        labor_information: 'Union',
        lease_amount: 5860,
        lease_amount_frequency: 'Bi-Monthly',
        lease_assignable_y_n: true,
        lease_expiration: '2019-07-17T00:00:00.000Z',
        lease_renewal_option_y_n: false,
        number_of_full_time_employees: 99,
        number_of_part_time_employees: 265,
        ownership_type: 'Partnership',
        seating_capacity: 235,
        special_licenses: 'Gambling',
        year_established: 1913,
        years_current_owner: 30
      },
      characteristics: {
        anchors_co_tenants: 'Lavada Bernier',
        community_features: 'Quantum cryptography does not work on Chuck Norris. When something is being observed by Chuck it stays in the same state until he\'s finished.',
        current_use: 'Recreational',
        development_status: 'Finished Lot(s)',
        fencing: 'Perimeter',
        frontage_length: null,
        frontage_type: 'River',
        furnished: 'Unfurnished',
        horse_amenities: 'Cake',
        horse_y_n: true,
        land_lease_amount: 7733,
        land_lease_amount_frequency: 'Monthly',
        land_lease_expiration_date: '2019-03-10T00:00:00.000Z',
        land_lease_y_n: true,
        laundry_features: 'Promethium',
        lease_term: 'Weekly',
        lot_dimensions_source: 'Owner',
        lot_features: 'Robert Koch',
        lot_size_acres: 35,
        lot_size_area: 99,
        lot_size_dimensions: '19 megaparsecs',
        lot_size_source: 'Appraiser',
        lot_size_square_feet: 6970,
        lot_size_units: 'Square Meters',
        mobile_home_remains_y_n: false,
        number_of_buildings: 1,
        number_of_lots: 10,
        number_of_pads: 4,
        number_of_units_in_community: 9,
        number_of_units_total: 6,
        park_manager_name: 'Madge Turcotte',
        park_manager_phone: '598-343-6387 x01401',
        park_name: 'Hennepin',
        pool_features: 'Belgian Strong Ale',
        pool_private_y_n: true,
        possible_use: 'Timber',
        road_frontage_type: 'Other',
        road_responsibility: 'Public Maintained Road',
        road_surface_type: 'Alley Paved',
        senior_community_y_n: false,
        spa_features: 'muted, tea-like, sundried tomato, prune, lemonade',
        spa_y_n: false,
        topography: 'Frosting',
        units_furnished: 'Violin',
        view: 'Segue 3',
        view_y_n: true,
        water_body_name: 'Yakima Gol',
        waterfront_features: 'Caramel',
        waterfront_y_n: true
      },
      equipment: {
        appliances: 'Haskell',
        other_equipment: 'kogi',
        security_features: 'Proteus'
      },
      farming: {
        crops_included_y_n: false,
        cultivated_area: '41.88',
        farm_credit_service_incl_y_n: true,
        farm_land_area_source: 'Other',
        farm_land_area_units: 'Square Meters',
        grazing_permits_blm_y_n: true,
        grazing_permits_forest_service_y_n: true,
        grazing_permits_private_y_n: false,
        pasture_area: '99.57',
        range_area: '78.56',
        vegetation: 'Cleared',
        wooded_area: '67.67'
      },
      financial: {
        cable_tv_expense: '13.56',
        cap_rate: '66.52',
        electric_expense: '54.32',
        existing_lease_type: 'Ground Lease',
        financial_data_source: 'Accountant',
        fuel_expense: '48.82',
        furniture_replacement_expense: '57.59',
        gardener_expense: '49.78',
        gross_income: '24.79',
        gross_scheduled_income: '51.78',
        income_includes: 'Recreation',
        insurance_expense: '83.96',
        licenses_expense: '43.41',
        maintenance_expense: '96.51',
        manager_expense: '96.92',
        net_operating_income: '84.88',
        new_taxes_expense: '57.83',
        number_of_units_leased: 2,
        number_of_units_mo_mo: 5,
        number_of_units_vacant: 2,
        operating_expense: '68.61',
        operating_expense_includes: 'Maintenance',
        other_expense: '22.27',
        owner_pays: 'Insurance',
        pest_control_expense: '33.95',
        pool_expense: '15.21',
        professional_management_expense: '96.14',
        rent_control_y_n: true,
        rent_includes: 'Trash Collection',
        supplies_expense: '23.63',
        tenant_pays: 'Water',
        total_actual_rent: '23.69',
        trash_expense: '37.44',
        vacancy_allowance: 8,
        vacancy_allowance_rate: '89.87',
        water_sewer_expense: '59.01',
        workmans_compensation_expense: '91.41'
      },
      hoa: {
        association_amenities: 'Mexican Space Agency',
        association_fee_2: '986.71',
        association_fee_2_frequency: 'Semi-Annually',
        association_fee: '125.43',
        association_fee_frequency: 'One Time',
        association_fee_includes: 'Trash',
        association_name_2: 'Big Dipper',
        association_name: 'Four Swords',
        association_phone_2: '1-502-041-1384',
        association_phone: '1-955-910-5372 x1530',
        association_y_n: true,
        pets_allowed: 'No'
      },
      listing: {
        copyright_notice: 'Here\'s looking at you, kid.',
        disclaimer: 'He can speak Russian… in French',
        home_warranty_y_n: true,
        lease_considered_y_n: false,
        list_aor: 'Triangulum',
        listing_agreement: 'Gray 6',
        listing_id: '88562055',
        listing_key: '71b2561652c300c1eba2edbd5e9a4062c9',
        listing_key_numeric: 14918089,
        listing_service: 'Full Service',
        mls_status: 'Pending',
        originating_system_id: '1d064f40f07524b47b0576c1fcf30ebf',
        originating_system_key: '4b9ee32c6f022bb5c964b78503b0cce4',
        originating_system_name: 'Palomar 6',
        source_system_id: '6d74d38917939e729e6312db16ae70b8',
        source_system_key: '3d32155e4b80e2b4da9039b5efcbedcb',
        source_system_name: 'Owl Nebula',
        standard_status: 'Active Under Contract',
        agent_office: {
          buyer_agent: {
            buyer_agent_aor: 'Milky Way',
            buyer_agent_designation: 'Certified Residential Specialist / CRS',
            buyer_agent_direct_phone: '(517) 722-4796',
            buyer_agent_email: 'fiona@robel.org',
            buyer_agent_fax: '228-187-6357 x156',
            buyer_agent_first_name: 'Burdette',
            buyer_agent_full_name: 'Burdette Pfeffer',
            buyer_agent_home_phone: '1-573-524-2510 x7745',
            buyer_agent_key: '5f206d4bbe16495cb8af4f192172e4b1',
            buyer_agent_key_numeric: 46713218,
            buyer_agent_last_name: 'Pfeffer',
            buyer_agent_middle_name: 'Noemi',
            buyer_agent_mls_id: 'cd6427edb34d0d1c1111088bf2079bb9',
            buyer_agent_mobile_phone: '(293) 090-2806',
            buyer_agent_name_prefix: 'Miss',
            buyer_agent_name_suffix: 'Sr.',
            buyer_agent_office_phone_ext: '3711',
            buyer_agent_office_phone: '515.631.0879 x27251',
            buyer_agent_pager: '460-958-4151 x026',
            buyer_agent_preferred_phone_ext: '9008',
            buyer_agent_preferred_phone: '(524) 668-2791 x0568',
            buyer_agent_state_license: '21499b8957da19ea1c0dc38728c034fa',
            buyer_agent_toll_free_phone: '251-005-9922 x98638',
            buyer_agent_url: 'http://romagueradare.com/albert.reilly',
            buyer_agent_voice_mail_ext: '7371',
            buyer_agent_voice_mail: '(113) 298-9204'
          },
          buyer_office: {
            buyer_office_aor: 'Hoags Object',
            buyer_office_email: 'may@lemke.info',
            buyer_office_fax: '(676) 448-0749',
            buyer_office_key: '62e42c90513e5911325852cd0b2efc6f',
            buyer_office_key_numeric: 89242705,
            buyer_office_mls_id: 'b9fd857ad6163859de7cb25bdf6fc13f',
            buyer_office_name: 'Shanahan and Sons',
            buyer_office_phone_ext: '0646',
            buyer_office_phone: '632.006.1332 x45456',
            buyer_office_url: 'http://toybruen.org/columbus.volkman'
          },
          co_buyer_agent: {
            co_buyer_agent_aor: 'Messier 83',
            co_buyer_agent_designation: 'Certified International Property Specialist / CIPS',
            co_buyer_agent_direct_phone: '1-987-362-3285 x8381',
            co_buyer_agent_email: 'harry.emard@welch.net',
            co_buyer_agent_fax: '(899) 708-0975 x5914',
            co_buyer_agent_first_name: 'Don',
            co_buyer_agent_full_name: 'Don Lang',
            co_buyer_agent_home_phone: '709.989.6888 x905',
            co_buyer_agent_key: '3d6c535f9f5ccff5fc464f67be30f0f1',
            co_buyer_agent_key_numeric: 31520229,
            co_buyer_agent_last_name: 'Lang',
            co_buyer_agent_middle_name: 'Madeline',
            co_buyer_agent_mls_id: 'a36eaddfea9690c77fd89b3a77379e00',
            co_buyer_agent_mobile_phone: '(226) 916-6823 x350',
            co_buyer_agent_name_prefix: 'Dr.',
            co_buyer_agent_name_suffix: 'MD',
            co_buyer_agent_office_phone_ext: '7097',
            co_buyer_agent_office_phone: '252.819.4207',
            co_buyer_agent_pager: '1-942-138-1719',
            co_buyer_agent_preferred_phone_ext: '9456',
            co_buyer_agent_preferred_phone: '1-949-808-3630',
            co_buyer_agent_state_license: 'f0185b3dbb29d1bce0b22eafb68a9d5b',
            co_buyer_agent_toll_free_phone: '1-587-969-0906',
            co_buyer_agent_url: 'http://kuhlmanhahn.co/laurie',
            co_buyer_agent_voice_mail_ext: '1534',
            co_buyer_agent_voice_mail: '702.565.9653'
          },
          co_buyer_office: {
            co_buyer_office_aor: 'Hoags Object',
            co_buyer_office_email: 'bernadine@nienow.io',
            co_buyer_office_fax: '961-531-6696 x468',
            co_buyer_office_key: '3facb19aa3a5ac17680f6201915152fe',
            co_buyer_office_key_numeric: 22010417,
            co_buyer_office_mls_id: 'b845e6cc61a9afaf06a75ed47bae460d',
            co_buyer_office_name: 'Schmitt Group',
            co_buyer_office_phone_ext: '2058',
            co_buyer_office_phone: '221.557.9414 x68272',
            co_buyer_office_url: 'http://quitzonconn.name/cleta_oconner'
          },
          co_list_agent: {
            co_list_agent_aor: 'Messier 83',
            co_list_agent_designation: 'Certified Real Estate Team Specialist / C-RETS',
            co_list_agent_direct_phone: '(823) 911-2130 x174',
            co_list_agent_email: 'ottilie@kuhic.io',
            co_list_agent_fax: '190.486.2744',
            co_list_agent_first_name: 'Afton',
            co_list_agent_full_name: 'Afton VonRueden',
            co_list_agent_home_phone: '1-500-027-4295',
            co_list_agent_key: '549602574cbf2f86699d5e72f9af35c3',
            co_list_agent_key_numeric: 33280008,
            co_list_agent_last_name: 'VonRueden',
            co_list_agent_middle_name: 'Don',
            co_list_agent_mls_id: '4e4cab8d63fdb27cd5fe6d3de41dc14b',
            co_list_agent_mobile_phone: '343-562-0251 x87535',
            co_list_agent_name_prefix: 'Dr.',
            co_list_agent_name_suffix: 'V',
            co_list_agent_office_phone_ext: '2335',
            co_list_agent_office_phone: '1-114-974-8856',
            co_list_agent_pager: '(784) 156-2905',
            co_list_agent_preferred_phone_ext: '4450',
            co_list_agent_preferred_phone: '(504) 020-6112',
            co_list_agent_state_license: '5a86401eee7753b82d01f91df8274759',
            co_list_agent_toll_free_phone: '1-753-213-1284 x3890',
            co_list_agent_url: 'http://borer.info/krystal_bechtelar',
            co_list_agent_voice_mail_ext: '1778',
            co_list_agent_voice_mail: '1-873-161-4785 x33290'
          },
          co_list_office: {
            co_list_office_aor: 'Hoags Object',
            co_list_office_email: 'van.herzog@cronin.biz',
            co_list_office_fax: '467-882-0180',
            co_list_office_key: '5738464a30799cc04951ca7282937314',
            co_list_office_key_numeric: 58344306,
            co_list_office_mls_id: '4944361ae0a817e167f134205b2cabdf',
            co_list_office_name: 'D\'Amore, Schoen and Haley',
            co_list_office_phone_ext: '0459',
            co_list_office_phone: '972-882-9383 x7770',
            co_list_office_url: 'http://dickinson.name/emmanuel'
          },
          list_agent: {
            list_agent_aor: 'Blackeye',
            list_agent_designation: 'Performance Management Network / PMN',
            list_agent_direct_phone: '763.126.9350 x2803',
            list_agent_email: 'joanie@beatty.co',
            list_agent_fax: '325.928.4768 x195',
            list_agent_first_name: 'Ashleigh',
            list_agent_full_name: 'Ashleigh Willms',
            list_agent_home_phone: '1-174-298-1269 x8348',
            list_agent_key: '89f1fd28fe2f787eb5c2c0a20271f1d8',
            list_agent_key_numeric: 70425667,
            list_agent_last_name: 'Willms',
            list_agent_middle_name: 'Brenden',
            list_agent_mls_id: 'bffda5fcc49643428e39f4c3056eb67c',
            list_agent_mobile_phone: '(769) 738-2506 x8496',
            list_agent_name_prefix: 'Mr.',
            list_agent_name_suffix: 'Jr.',
            list_agent_office_phone_ext: '0598',
            list_agent_office_phone: '(966) 302-0078 x86704',
            list_agent_pager: '968-743-1416',
            list_agent_preferred_phone_ext: '3859',
            list_agent_preferred_phone: '855.499.1087 x74432',
            list_agent_state_license: 'a957c2799b2820c40982cea52dd1939b',
            list_agent_toll_free_phone: '270-057-8436 x802',
            list_agent_url: 'http://wuckert.io/annabelle.steuber',
            list_agent_voice_mail_ext: '5686',
            list_agent_voice_mail: '(954) 645-7441 x4082'
          },
          list_office: {
            list_office_aor: 'Blackeye',
            list_office_email: 'loy.moriette@berge.org',
            list_office_fax: '968.141.0765 x62887',
            list_office_key: '24ea6b1caba97d40880fd11716c28433',
            list_office_key_numeric: 58646012,
            list_office_mls_id: '0acf0101d323855e2508392554e20ef6',
            list_office_name: 'Hills, Larkin and Bruen',
            list_office_phone_ext: '2316',
            list_office_phone: '757-330-0287 x67323',
            list_office_url: 'http://kuhlmanpfeffer.co/matilda'
          },
          team: {
            buyer_team_key: 'c7e1b8ce171f62e3c06ca17287f0760b',
            buyer_team_key_numeric: 36352895,
            buyer_team_name: 'Virginia foxes',
            list_team_key: '72ae44514e4fd99123864b5b3d40fb47',
            list_team_key_numeric: 14532116,
            list_team_name: 'New Jersey foxes'
          }
        },
        closing: {
          availability_date: '2018-12-29T00:00:00.000Z',
          buyer_financing: 'Veranda Bean',
          concessions_amount: 4093,
          concessions_comments: 'quick, big, tamarind, soy sauce, nectarine',
          concessions: 'Raimi, Yemen',
          contingency: 'Barbuk Sudan',
          possession: 'Peanut Butter'
        },
        compensation: {
          buyer_agency_compensation: 'Butter Pecan',
          buyer_agency_compensation_type: 'Pie',
          dual_variable_compensation_y_n: false,
          lease_renewal_compensation: 'Tiramisù',
          sub_agency_compensation: 'Self Adhesive Spice Labels',
          sub_agency_compensation_type: 'Jicama',
          transaction_broker_compensation: 'All Passion Spent',
          transaction_broker_compensation_type: 'Essay'
        },
        contract: {
          current_financing: 'Chuck Norris\' keyboard doesn\'t have a F1 key, the computer asks him for help.',
          disclosures: 'Chuck Norris does not use revision control software. None of his code has ever needed revision.',
          exclusions: 'When a bug sees Chuck Norris, it flees screaming in terror, and then immediately self-destructs to avoid being roundhouse-kicked.',
          inclusions: 'Chuck Norris doesn\'t pair program.',
          listing_terms: 'Chuck Norris can binary search unsorted data.',
          ownership: 'Chuck Norris never gets a syntax error. Instead, the language gets a DoesNotConformToChuck error.',
          special_listing_conditions: 'Chuck Norris doesn\'t program with a keyboard. He stares the computer down until it does what he wants.',
          common_interest: 'olive'
        },
        dates: {
          cancelation_date: '2018-10-08T00:00:00.000Z',
          close_date: '2017-11-06T00:00:00.000Z',
          contingent_date: '2018-06-28T00:00:00.000Z',
          contract_status_change_date: '2018-03-16T00:00:00.000Z',
          cumulative_days_on_market: 131,
          days_on_market: 111,
          expiration_date: '2018-08-11T00:00:00.000Z',
          listing_contract_date: '2018-05-09T00:00:00.000Z',
          major_change_timestamp: '2018-02-14T00:00:00.000Z',
          major_change_type: 'Active',
          modification_timestamp: '2018-10-06T11:00:26.000Z',
          off_market_date: '2017-12-16T00:00:00.000Z',
          off_market_timestamp: '2018-09-12T00:00:00.000Z',
          on_market_date: '2018-08-11T00:00:00.000Z',
          on_market_timestamp: '2018-05-01T00:00:00.000Z',
          original_entry_timestamp: '2018-01-31T00:00:00.000Z',
          pending_timestamp: '2018-08-01T00:00:00.000Z',
          price_change_timestamp: '2018-03-07T00:00:00.000Z',
          purchase_contract_date: '2018-08-29T00:00:00.000Z',
          status_change_timestamp: '2018-03-31T00:00:00.000Z',
          total_days_on_market: 141,
          withdrawn_date: '2017-11-19T00:00:00.000Z'
        },
        marketing: {
          internet_address_display_y_n: false,
          internet_automated_valuation_display_y_n: true,
          internet_consumer_comment_y_n: true,
          internet_entire_listing_display_y_n: false,
          sign_on_property_y_n: false,
          syndicate_to: 'Zillow/Trulia',
          virtual_tour_url_branded: 'http://kihn.name/georgianna',
          virtual_tour_url_unbranded: 'http://gulgowski.name/lyric'
        },
        media: {
          documents_available: 'blep',
          documents_change_timestamp: '2018-09-11T02:08:04.000Z',
          documents_count: 12,
          photos_change_timestamp: '2018-10-04T02:24:36.000Z',
          photos_count: 12,
          videos_change_timestamp: '2018-09-19T11:01:58.000Z',
          videos_count: 24
        },
        price: {
          close_price: '4112261.0',
          list_price: '6893470.0',
          list_price_low: '6298639.0',
          original_list_price: '1734350.0',
          previous_list_price: '1373880.0'
        },
        remarks: {
          private_office_remarks: 'Fasten your seatbelts. It\'s going to be a bumpy night.',
          private_remarks: 'Here\'s looking at you, kid.',
          public_remarks: 'All right, Mr. DeMille, I\'m ready for my closeup.',
          syndication_remarks: 'Fasten your seatbelts. It\'s going to be a bumpy night.'
        },
        showing: {
          access_code: '3879',
          lock_box_location: 'Proteus',
          lock_box_serial_number: '0d0253d30971214f9ae460eaa2856cf8',
          lock_box_type: 'Call Listing Office',
          showing_advance_notice: 11,
          showing_attended_y_n: false,
          showing_contact_name: 'Audrey Ferry DDS',
          showing_contact_phone_ext: '3095',
          showing_contact_phone: '1-178-256-5154',
          showing_contact_type: 'Property Manager',
          showing_days: 'Wednesday, Sunday, Saturday, Friday',
          showing_instructions: 'You could not be any more wrong. You could try, but you would not be successful.',
          showing_requirements: 'No story lives unless someone wants to listen. The stories we love best do live in us forever. So whether you come back by page or by the big screen, Hogwarts will always be there to welcome you home.',
          showing_start_time: '2018-10-31T00:00:00.000Z',
          showing_end_time: '2018-11-05T00:00:00.000Z'
        }
      },
      media: [],
      occupant_owner: {
        occupant_name: 'Ms. Suzanne Conroy',
        occupant_phone: '(119) 343-4189 x4902',
        occupant_type: 'Tenant',
        owner_name: 'Magdalena Mitchell V',
        owner_phone: '402-531-4230 x937'
      },
      structure: {
        above_grade_finished_area: '439.0',
        above_grade_finished_area_source: 'Plans',
        above_grade_finished_area_units: 'Square Feet',
        accessibility_features: 'Accessible Central Living Area',
        architectural_style: 'Raichu',
        attached_garage_y_n: true,
        basement: 'Course! From a group of Lybian Nationalists They wanted me to build them a bomb, so I took their plutonium and in turn I gave them a shiny bomb caseing full of used pinball machine parts!',
        bathrooms_full: 4,
        bathrooms_half: 10,
        bathrooms_one_quarter: 7,
        bathrooms_partial: 9,
        bathrooms_three_quarter: 4,
        bathrooms_total_integer: 6,
        bedrooms_possible: 8,
        bedrooms_total: 8,
        below_grade_finished_area: '598.0',
        below_grade_finished_area_source: 'Appraiser',
        below_grade_finished_area_units: 'Square Meters',
        body_type: 'See Remarks',
        builder_model: 'Australian Mist',
        builder_name: 'Lucy',
        building_area_source: 'Estimated',
        building_area_total: '153.0',
        building_area_units: 'Square Feet',
        building_features: 'We need to parse the auxiliary USB port!',
        building_name: 'SMS',
        carport_spaces: '1.0',
        carport_y_n: true,
        common_walls: 'End Unit',
        construction_materials: 'Stucco, Wood Siding, Plaster',
        cooling: 'Harp',
        cooling_y_n: false,
        covered_spaces: '3.0',
        direction_faces: 'Northwest',
        doh_1: 'Abmaj',
        doh_2: 'Ebm7',
        doh_3: 'G#maj',
        door_features: 'Precognition',
        entry_level: 4,
        entry_location: 'east',
        exterior_features: 'quick, silky, cherry, meyer lemon, plum',
        fireplace_features: 'Fairy tale',
        fireplaces_total: 5,
        fireplace_y_n: true,
        flooring: 'Black malt',
        foundation_area: '361.0',
        foundation_details: 'Block',
        garage_spaces: '8.0',
        garage_y_n: true,
        habitable_residence_y_n: false,
        heating: '31 IBU',
        heating_y_n: true,
        interior_features: 'Pug',
        leasable_area: '866.0',
        leasable_area_units: 'Square Meters',
        levels: 'Multi/Split',
        license_1: 'B0000DHWAB',
        license_2: 'B000IAO9A4',
        license_3: 'B000BPZFNQ',
        living_area: '453.0',
        living_area_source: 'Owner',
        living_area_units: 'Square Feet',
        main_level_bathrooms: 3,
        main_level_bedrooms: 8,
        make: 'Hoeger and Sons',
        mobile_dim_units: 'Meters',
        mobile_length: 4,
        mobile_width: 1,
        model: 'Koposov II',
        new_construction_y_n: false,
        open_parking_spaces: '1.0',
        open_parking_y_b: false,
        other_structures: 'Second Garage',
        parking_features: 'Deku Sticks',
        parking_total: '9.0',
        patio_and_porch_features: 'Weihenstephaner Hefeweissbier',
        property_attached_y_n: false,
        property_condition: 'Updated/Remodeled',
        roof: 'Aluminum',
        rv_parking_dimensions: '79 AU',
        serial_u: '440629229371954',
        serial_x: '993993935808092',
        serial_xx: '456917466052002',
        skirt: 'Other',
        stories: 3,
        stories_total: 9,
        structure_type: 'Cabin',
        window_features: '4-LOM',
        year_built_details: 'Wua ur gwyaaaag wyogg wua rarr!',
        year_built_effective: 2017,
        year_built: 1974,
        year_built_source: 'Public Records',
        performance: {
          green_marketing: {
            green_energy_efficient: 'Roof',
            green_energy_generation: 'Solar',
            green_indoor_air_quality: 'Contaminant Control',
            green_location: 'Ismene',
            green_sustainability: 'Recycled Materials',
            green_water_conservation: 'Gray Water System',
            walk_score: 58
          }
        }
      },
      tax: {
        additional_parcels_description: 'Mixed Herbs',
        additional_parcels_y_n: false,
        parcel_number: '418390120-0',
        public_survey_range: 'Europium',
        public_survey_section: 'Onderon',
        public_survey_township: 'Old Forest',
        tax_annual_amount: '4716.0',
        tax_assessed_value: 115147,
        tax_block: '38d3',
        tax_book_number: '57bfa09e96bd2849cd1ab407288540f2',
        tax_legal_description: 'I am altering the deal. Pray I don\'t alter it any further.',
        tax_lot: '62-4841006',
        tax_map_number: '22371738078',
        tax_other_annual_assessment_amount: '21.0',
        tax_parcel_letter: 'Canadian Cat Association',
        tax_status_current: 'Personal And Real',
        tax_tract: 'Springfield Mall',
        tax_year: 2017,
        zoning_description: 'His sweat is the cure for the common cold',
        zoning: 'Lake Ferona'
      },
      utility: {
        distance_to_bus_comments: 'wild, watery, cream, cacao nibs, nougat',
        distance_to_bus_numeric: 35,
        distance_to_bus_units: 'Meters',
        distance_to_electric_comments: 'muted, juicy, graham cracker, figs, fresh bread',
        distance_to_electric_numeric: 1,
        distance_to_electric_units: 'Meters',
        distance_to_freeway_comments: 'crisp, silky, mint, musty, lavender',
        distance_to_freeway_numeric: 64,
        distance_to_freeway_units: 'Feet',
        distance_to_gas_comments: 'mild, big, nutmeg, cedar, banana',
        distance_to_gas_numeric: 5338,
        distance_to_gas_units: 'Feet',
        distance_to_phone_service_comments: 'astringent, creamy, raisin, cola, soil',
        distance_to_phone_service_numeric: 7565,
        distance_to_phone_service_units: 'Meters',
        distance_to_placeof_worship_comments: 'crisp, tea-like, grassy, apricot, rubber',
        distance_to_placeof_worship_numeric: 48,
        distance_to_placeof_worship_units: 'Meters',
        distance_to_school_bus_comments: 'crisp, full, orange creamsicle, white pepper, raspberry',
        distance_to_school_bus_numeric: 476,
        distance_to_school_bus_units: 'Meters',
        distance_to_schools_comments: 'dirty, round, nutmeg, quakery, medicinal',
        distance_to_schools_numeric: 60,
        distance_to_schools_units: 'Feet',
        distance_to_sewer_comments: 'astringent, creamy, lemon, red apple, soil',
        distance_to_sewer_numeric: 295,
        distance_to_sewer_units: 'Feet',
        distance_to_shopping_comments: 'lingering, silky, cashew, clove, curry',
        distance_to_shopping_numeric: 44,
        distance_to_shopping_units: 'Feet',
        distance_to_street_comments: 'astringent, big, white grape, cola, grassy',
        distance_to_street_numeric: 55,
        distance_to_street_units: 'Meters',
        distance_to_water_comments: 'vibrant, silky, cacao nibs, toast, sage',
        distance_to_water_numeric: 457,
        distance_to_water_units: 'Feet',
        electric: '100 Amp Service',
        electric_on_property_y_n: true,
        irrigation_source: 'Santander, Colombia',
        irrigation_water_rights_acres: '55.83',
        irrigation_water_rights_y_n: true,
        number_of_separate_electric_meters: 5,
        number_of_separate_gas_meters: 7,
        number_of_separate_water_meters: 4,
        sewer: 'Unknown',
        utilities: 'Natural Gas Available',
        water_source: 'Public'
      }
    }
  }]
};

function getUserActivitiesMock() {
  return cloneDeep_1(userActivities);
}

function getUserActivityMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(userActivities.results[index]);
}

var vendors = {
  total: 54,
  results: [{
    id: 1,
    contact_display_name: 'Kaya Bashirian',
    contact_first_name: 'Kaya',
    contact_last_name: 'Bashirian',
    description: 'Magnam et repellendus blanditiis nostrum animi rerum tempore. Ab pariatur enim et tenetur. Nam facilis repellendus id eaque. Autem qui quos quia.\nSuscipit earum quod. Eaque possimus saepe repellat aspernatur aut quam dolorem. Quae consequuntur eligendi fuga.\nQui excepturi impedit veritatis. Necessitatibus enim minima tempore facilis distinctio qui. Magni quis velit.',
    email: 'jayne@yundtoreilly.biz',
    name: 'Skiles-King',
    rating: null,
    created_at: '2018-07-12T15:20:16.403Z',
    updated_at: '2018-07-12T15:20:16.403Z',
    areas: [],
    categories: ['Sweet Bread'],
    user: {
      id: 83,
      email: 'swift82.lori@terry.biz',
      title: 'Mrs.',
      first_name: 'Giles',
      last_name: 'Hodkiewicz',
      display_name: 'Meredith McLaughlin DVM',
      realtor: true,
      mls_member: true,
      uid: '5ac09bed-8114-4e76-8593-c0a82530b2b9',
      created_at: '2018-07-12T15:20:16.140Z',
      updated_at: '2018-07-12T15:20:16.140Z',
      role: 'staff',
      website: {
        id: 40,
        network_id: 1,
        name: 'Ahsoka Tano 40',
        url: 'http://40rutherford.org',
        created_at: '2018-07-12T15:20:05.138Z',
        updated_at: '2018-07-12T15:20:05.138Z',
        contact_login_url: 'http://toy.com/joy.grimes',
        user_login_url: 'http://schmidt.name/koby',
        email: 'gregory_kshlerin@mcglynn.net',
        market_id: 40,
        referer: '40pouros.name',
        contact_password_reset_url: 'http://thiel.com/jerrell',
        user_password_reset_url: 'http://flatleynitzsche.biz/stacey'
      },
      photos: [{
        id: 76,
        primary: false,
        type: 'Headshot',
        url: 'http://muller.co/ferne',
        thumbnail_url: 'http://vonrueden.io/estevan'
      }]
    },
    additional_email_addresses: [],
    addresses: [{
      id: 130,
      primary: false,
      type: 'Work',
      street_address: '573 Gerlach Inlet',
      street_address_2: 'Apt. 516',
      city: 'North Shayna',
      state: 'UT',
      zip: '98852',
      country: 'United States'
    }, {
      id: 131,
      primary: false,
      type: 'Home',
      street_address: '89020 Rosendo Mill',
      street_address_2: 'Suite 155',
      city: 'Alphonsofurt',
      state: 'VA',
      zip: '94493-5904',
      country: 'United States'
    }],
    phone_numbers: [{
      id: 112,
      primary: false,
      type: 'Cell',
      number: '9955337342',
      extension: '1455'
    }, {
      id: 113,
      primary: false,
      type: 'Work',
      number: '7669118412',
      extension: '4524'
    }],
    photos: [{
      id: 78,
      primary: false,
      type: 'Lifestyle',
      url: 'http://powlowskijohnson.io/jaden.mraz',
      thumbnail_url: 'http://zieme.biz/candida'
    }],
    urls: []
  }, {
    id: 2,
    contact_display_name: 'Leo Rogahn',
    contact_first_name: 'Leo',
    contact_last_name: 'Rogahn',
    description: 'Cupiditate dolorum rerum at iusto suscipit dignissimos repellat. Vel doloremque consectetur quasi quis omnis voluptatibus voluptas. Rerum velit rerum ut voluptas.\nCommodi cupiditate repudiandae veritatis laboriosam explicabo. Amet sit eum sed facilis. Est sunt autem aut. Alias modi quos.\nRepellat quia et velit molestias non sint. Odio doloribus voluptatibus animi sequi pariatur soluta. Voluptatem quas rerum eum beatae et eaque.',
    email: 'kory.swaniawski@treutel.info',
    name: 'Gaylord LLC',
    rating: null,
    created_at: '2018-07-12T15:20:16.392Z',
    updated_at: '2018-07-12T15:20:16.392Z',
    areas: ['Autumn Oaks', 'Eagle Place'],
    categories: ['Cake', 'Pudding'],
    user: {
      id: 83,
      email: 'swift82.lori@terry.biz',
      title: 'Mrs.',
      first_name: 'Giles',
      last_name: 'Hodkiewicz',
      display_name: 'Meredith McLaughlin DVM',
      realtor: true,
      mls_member: true,
      uid: '5ac09bed-8114-4e76-8593-c0a82530b2b9',
      created_at: '2018-07-12T15:20:16.140Z',
      updated_at: '2018-07-12T15:20:16.140Z',
      role: 'staff',
      website: {
        id: 40,
        network_id: 1,
        name: 'Ahsoka Tano 40',
        url: 'http://40rutherford.org',
        created_at: '2018-07-12T15:20:05.138Z',
        updated_at: '2018-07-12T15:20:05.138Z',
        contact_login_url: 'http://toy.com/joy.grimes',
        user_login_url: 'http://schmidt.name/koby',
        email: 'gregory_kshlerin@mcglynn.net',
        market_id: 40,
        referer: '40pouros.name',
        contact_password_reset_url: 'http://thiel.com/jerrell',
        user_password_reset_url: 'http://flatleynitzsche.biz/stacey'
      },
      photos: [{
        id: 76,
        primary: false,
        type: 'Headshot',
        url: 'http://muller.co/ferne',
        thumbnail_url: 'http://vonrueden.io/estevan'
      }]
    },
    additional_email_addresses: [],
    addresses: [],
    phone_numbers: [],
    photos: [],
    urls: [{
      id: 131,
      type: 'Facebook',
      url: 'http://steuberkiehn.net/anabel_mills'
    }, {
      id: 132,
      type: 'Facebook',
      url: 'http://hilll.name/pink_kling'
    }]
  }, {
    id: 3,
    contact_display_name: 'Addie Huels',
    contact_first_name: 'Addie',
    contact_last_name: 'Huels',
    description: 'Dolor dolores error aut ipsa. Consequatur voluptatibus reprehenderit dolores aut velit asperiores. Culpa asperiores cupiditate necessitatibus. Voluptatem qui quia nihil minima assumenda. Quidem esse quia enim dolor placeat.\nNobis perspiciatis rem rerum eaque veniam veritatis. Deleniti voluptas neque ea necessitatibus et non. Quia temporibus impedit quibusdam enim quam et consequatur.\nOfficia suscipit ut molestiae unde. Mollitia rem quisquam labore quo maiores. Eius dolorem ab illo at. Et tempora qui consequatur.',
    email: 'trycia@walkermccullough.io',
    name: 'Corwin, Dickens and Kovacek',
    rating: 1,
    created_at: '2018-07-12T15:20:16.154Z',
    updated_at: '2018-07-12T15:20:16.327Z',
    areas: [],
    categories: [],
    user: {
      id: 83,
      email: 'swift82.lori@terry.biz',
      title: 'Mrs.',
      first_name: 'Giles',
      last_name: 'Hodkiewicz',
      display_name: 'Meredith McLaughlin DVM',
      realtor: true,
      mls_member: true,
      uid: '5ac09bed-8114-4e76-8593-c0a82530b2b9',
      created_at: '2018-07-12T15:20:16.140Z',
      updated_at: '2018-07-12T15:20:16.140Z',
      role: 'staff',
      website: {
        id: 40,
        network_id: 1,
        name: 'Ahsoka Tano 40',
        url: 'http://40rutherford.org',
        created_at: '2018-07-12T15:20:05.138Z',
        updated_at: '2018-07-12T15:20:05.138Z',
        contact_login_url: 'http://toy.com/joy.grimes',
        user_login_url: 'http://schmidt.name/koby',
        email: 'gregory_kshlerin@mcglynn.net',
        market_id: 40,
        referer: '40pouros.name',
        contact_password_reset_url: 'http://thiel.com/jerrell',
        user_password_reset_url: 'http://flatleynitzsche.biz/stacey'
      },
      photos: [{
        id: 76,
        primary: false,
        type: 'Headshot',
        url: 'http://muller.co/ferne',
        thumbnail_url: 'http://vonrueden.io/estevan'
      }]
    },
    additional_email_addresses: [{
      id: 119,
      type: 'Personal',
      email: 'chet@grady.co'
    }],
    addresses: [{
      id: 128,
      primary: false,
      type: 'Home',
      street_address: '93045 Legros Ports',
      street_address_2: 'Apt. 997',
      city: 'South Hailey',
      state: 'NC',
      zip: '33395-2701',
      country: 'United States'
    }, {
      id: 129,
      primary: false,
      type: 'Home',
      street_address: '814 Sydnie Avenue',
      street_address_2: 'Suite 863',
      city: 'Lake Erwintown',
      state: 'MS',
      zip: '60586-3873',
      country: 'United States'
    }],
    phone_numbers: [{
      id: 111,
      primary: false,
      type: 'Work',
      number: '3895307339',
      extension: '8492'
    }],
    photos: [{
      id: 77,
      primary: false,
      type: 'Lifestyle',
      url: 'http://quitzonblock.name/juana_becker',
      thumbnail_url: 'http://schamberger.co/hipolito'
    }],
    urls: [{
      id: 130,
      type: 'Website',
      url: 'http://bauch.io/anibal.gibson'
    }]
  }, {
    id: 4,
    contact_display_name: 'Herbert Nolan',
    contact_first_name: 'Herbert',
    contact_last_name: 'Nolan',
    description: 'At pariatur voluptatum delectus. Corporis rerum occaecati. Molestias exercitationem ut dolorem ut dignissimos. Sunt illum quo quam.\nOdio libero veniam velit tempora. Officia sint minima cupiditate. Nisi veritatis earum reiciendis et ullam vel assumenda. Ipsum sequi repellat molestias doloribus ut. A et iure.\nRecusandae voluptatem vitae itaque soluta ab. Voluptates voluptatibus doloremque laudantium. Atque voluptates exercitationem est. A quaerat ratione aspernatur voluptatum est. Vel voluptas tenetur est asperiores.',
    email: 'donnie@gusikowski.com',
    name: 'Stanton and Sons',
    rating: null,
    created_at: '2018-07-12T15:20:15.312Z',
    updated_at: '2018-07-12T15:20:15.312Z',
    areas: [],
    categories: ['Cookie', 'Ice Cream'],
    user: {
      id: 80,
      email: 'kobe79@donnelly.info',
      title: 'Miss',
      first_name: 'Joel',
      last_name: 'Dach',
      display_name: 'Dariana Emmerich',
      realtor: false,
      mls_member: true,
      uid: '43c41d74-9e90-4f89-8814-9065d8927721',
      created_at: '2018-07-12T15:20:15.021Z',
      updated_at: '2018-07-12T15:20:15.021Z',
      role: 'admin',
      website: {
        id: 40,
        network_id: 1,
        name: 'Ahsoka Tano 40',
        url: 'http://40rutherford.org',
        created_at: '2018-07-12T15:20:05.138Z',
        updated_at: '2018-07-12T15:20:05.138Z',
        contact_login_url: 'http://toy.com/joy.grimes',
        user_login_url: 'http://schmidt.name/koby',
        email: 'gregory_kshlerin@mcglynn.net',
        market_id: 40,
        referer: '40pouros.name',
        contact_password_reset_url: 'http://thiel.com/jerrell',
        user_password_reset_url: 'http://flatleynitzsche.biz/stacey'
      },
      photos: [{
        id: 70,
        primary: false,
        type: 'Headshot',
        url: 'http://romaguerahand.biz/carlo_ward',
        thumbnail_url: 'http://reichel.org/oda.larson'
      }, {
        id: 71,
        primary: false,
        type: 'Lifestyle',
        url: 'http://moenoconnell.name/clint_nolan',
        thumbnail_url: 'http://streich.name/derek.abbott'
      }]
    },
    additional_email_addresses: [],
    addresses: [{
      id: 124,
      primary: false,
      type: 'Home',
      street_address: '90588 Okuneva Via',
      street_address_2: 'Suite 229',
      city: 'North Cade',
      state: 'NM',
      zip: '99518-1021',
      country: 'United States'
    }, {
      id: 125,
      primary: false,
      type: 'Work',
      street_address: '248 Filiberto Shoal',
      street_address_2: 'Suite 731',
      city: 'North Maevefurt',
      state: 'NH',
      zip: '90325',
      country: 'United States'
    }],
    phone_numbers: [],
    photos: [{
      id: 74,
      primary: false,
      type: 'Headshot',
      url: 'http://little.net/harrison.jenkins',
      thumbnail_url: 'http://bartondaniel.io/remington'
    }, {
      id: 75,
      primary: false,
      type: 'Lifestyle',
      url: 'http://hammes.biz/jovanny',
      thumbnail_url: 'http://murphyschmitt.info/sierra'
    }],
    urls: [{
      id: 126,
      type: 'Instagram',
      url: 'http://baileychamplin.net/seth'
    }, {
      id: 127,
      type: 'Twitter',
      url: 'http://kuhic.com/darby_pacocha'
    }]
  }, {
    id: 5,
    contact_display_name: 'Laurie Altenwerth',
    contact_first_name: 'Laurie',
    contact_last_name: 'Altenwerth',
    description: 'Sed placeat rerum harum. Optio et earum beatae sed. Iste dolor autem dolores. Maxime et praesentium hic necessitatibus suscipit eum iure.\nMolestiae quia id aut cumque eligendi ipsam ipsum. Eaque et optio unde officia quibusdam est molestiae. Et nihil iste officiis vel. Blanditiis eum similique amet ut. Omnis sunt qui ab.\nNon laudantium fugit. Culpa qui totam voluptatem dolores. Quia et et officia modi. Suscipit perferendis explicabo quam sit. Est eligendi pariatur ducimus possimus qui veritatis animi.',
    email: 'reyna.schamberger@sanford.name',
    name: 'Veum LLC',
    rating: 2,
    created_at: '2018-07-12T15:20:15.290Z',
    updated_at: '2018-07-12T15:20:15.295Z',
    areas: ['Royal Pointe', 'Pine Creek'],
    categories: [],
    user: {
      id: 80,
      email: 'kobe79@donnelly.info',
      title: 'Miss',
      first_name: 'Joel',
      last_name: 'Dach',
      display_name: 'Dariana Emmerich',
      realtor: false,
      mls_member: true,
      uid: '43c41d74-9e90-4f89-8814-9065d8927721',
      created_at: '2018-07-12T15:20:15.021Z',
      updated_at: '2018-07-12T15:20:15.021Z',
      role: 'admin',
      website: {
        id: 40,
        network_id: 1,
        name: 'Ahsoka Tano 40',
        url: 'http://40rutherford.org',
        created_at: '2018-07-12T15:20:05.138Z',
        updated_at: '2018-07-12T15:20:05.138Z',
        contact_login_url: 'http://toy.com/joy.grimes',
        user_login_url: 'http://schmidt.name/koby',
        email: 'gregory_kshlerin@mcglynn.net',
        market_id: 40,
        referer: '40pouros.name',
        contact_password_reset_url: 'http://thiel.com/jerrell',
        user_password_reset_url: 'http://flatleynitzsche.biz/stacey'
      },
      photos: [{
        id: 70,
        primary: false,
        type: 'Headshot',
        url: 'http://romaguerahand.biz/carlo_ward',
        thumbnail_url: 'http://reichel.org/oda.larson'
      }, {
        id: 71,
        primary: false,
        type: 'Lifestyle',
        url: 'http://moenoconnell.name/clint_nolan',
        thumbnail_url: 'http://streich.name/derek.abbott'
      }]
    },
    additional_email_addresses: [],
    addresses: [],
    phone_numbers: [],
    photos: [],
    urls: []
  }]
};

function getVendorsMock() {
  return cloneDeep_1(vendors);
}

function getVendorMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(vendors.results[index]);
}

var vendorAreas = {
  total: 39,
  results: [{
    id: 1,
    name: 'Eagle Place',
    created_at: '2018-07-12T15:20:15.913Z',
    updated_at: '2018-07-12T15:20:15.913Z'
  }, {
    id: 2,
    name: 'Autumn Oaks',
    created_at: '2018-07-12T15:20:15.908Z',
    updated_at: '2018-07-12T15:20:15.908Z'
  }, {
    id: 3,
    name: 'Pine Creek',
    created_at: '2018-07-12T15:20:15.143Z',
    updated_at: '2018-07-12T15:20:15.143Z'
  }, {
    id: 4,
    name: 'Royal Pointe',
    created_at: '2018-07-12T15:20:15.137Z',
    updated_at: '2018-07-12T15:20:15.137Z'
  }, {
    id: 5,
    name: 'Summer Heights',
    created_at: '2018-07-12T15:20:13.482Z',
    updated_at: '2018-07-12T15:20:13.482Z'
  }]
};

function getVendorAreasMock() {
  return cloneDeep_1(vendorAreas);
}

function getVendorAreaMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(vendorAreas.results[index]);
}

var vendorCategories = {
  total: 6,
  results: [{
    id: 1,
    name: 'Pudding',
    created_at: '2018-07-12T15:19:59.883Z',
    updated_at: '2018-07-12T15:19:59.883Z'
  }, {
    id: 2,
    name: 'Ice Cream',
    created_at: '2018-07-12T15:19:54.946Z',
    updated_at: '2018-07-12T15:19:54.946Z'
  }, {
    id: 3,
    name: 'Cookie',
    created_at: '2018-07-12T15:19:53.642Z',
    updated_at: '2018-07-12T15:19:53.642Z'
  }, {
    id: 4,
    name: 'Sweet Bread',
    created_at: '2018-07-12T15:19:51.811Z',
    updated_at: '2018-07-12T15:19:51.811Z'
  }, {
    id: 5,
    name: 'Pie',
    created_at: '2018-07-12T15:19:51.129Z',
    updated_at: '2018-07-12T15:19:51.129Z'
  }]
};

function getVendorCategoriesMock() {
  return cloneDeep_1(vendorCategories);
}

function getVendorCategoryMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(vendorCategories.results[index]);
}

var vendorReviews = {
  total: 5,
  results: [{
    id: 1,
    vendor_id: 1,
    comment: 'Ipsum consequat nisl vel pretium lectus. Ac feugiat sed lectus vestibulum mattis ullamcorper. Mauris a diam maecenas sed enim ut sem.',
    rating: 5,
    created_at: '2018-07-12T15:08:14.130Z',
    updated_at: '2018-07-12T15:08:14.130Z',
    user: {
      id: 1,
      email: 'super@foo.bar',
      title: 'Ms.',
      first_name: 'Aurelie',
      last_name: 'Leannon',
      display_name: 'Alexander Lubowitz',
      realtor: true,
      mls_member: true,
      uid: '8fe0660f-778e-44b8-83f0-8b57e120e711',
      created_at: '2018-07-09T17:59:40.831Z',
      updated_at: '2018-07-11T19:48:07.743Z',
      role: 'super',
      website: {
        id: 2,
        network_id: 1,
        name: 'Lando Calrissian 2',
        url: 'http://2leuschke.co',
        created_at: '2018-07-09T17:59:40.824Z',
        updated_at: '2018-07-09T17:59:40.824Z',
        contact_login_url: 'http://stamm.info/kattie',
        user_login_url: 'http://wizacrooks.net/alvena.schmeler',
        email: 'lilian_beer@reynolds.info',
        market_id: 2,
        referer: '2smith.name',
        contact_password_reset_url: 'http://dibbert.biz/janiya.wolf',
        user_password_reset_url: 'http://goyette.io/amy.cole'
      },
      photos: []
    },
    photos: []
  }, {
    id: 2,
    vendor_id: 1,
    comment: 'Vitae congue mauris rhoncus aenean vel elit. Id donec ultrices tincidunt arcu non.',
    rating: 4,
    created_at: '2018-07-12T15:08:04.244Z',
    updated_at: '2018-07-12T15:08:04.244Z',
    user: {
      id: 1,
      email: 'super@foo.bar',
      title: 'Ms.',
      first_name: 'Aurelie',
      last_name: 'Leannon',
      display_name: 'Alexander Lubowitz',
      realtor: true,
      mls_member: true,
      uid: '8fe0660f-778e-44b8-83f0-8b57e120e711',
      created_at: '2018-07-09T17:59:40.831Z',
      updated_at: '2018-07-11T19:48:07.743Z',
      role: 'super',
      website: {
        id: 2,
        network_id: 1,
        name: 'Lando Calrissian 2',
        url: 'http://2leuschke.co',
        created_at: '2018-07-09T17:59:40.824Z',
        updated_at: '2018-07-09T17:59:40.824Z',
        contact_login_url: 'http://stamm.info/kattie',
        user_login_url: 'http://wizacrooks.net/alvena.schmeler',
        email: 'lilian_beer@reynolds.info',
        market_id: 2,
        referer: '2smith.name',
        contact_password_reset_url: 'http://dibbert.biz/janiya.wolf',
        user_password_reset_url: 'http://goyette.io/amy.cole'
      },
      photos: []
    },
    photos: []
  }, {
    id: 3,
    vendor_id: 1,
    comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Natoque penatibus et magnis dis parturient montes.',
    rating: 3,
    created_at: '2018-07-12T15:07:51.075Z',
    updated_at: '2018-07-12T15:07:51.075Z',
    user: {
      id: 1,
      email: 'super@foo.bar',
      title: 'Ms.',
      first_name: 'Aurelie',
      last_name: 'Leannon',
      display_name: 'Alexander Lubowitz',
      realtor: true,
      mls_member: true,
      uid: '8fe0660f-778e-44b8-83f0-8b57e120e711',
      created_at: '2018-07-09T17:59:40.831Z',
      updated_at: '2018-07-11T19:48:07.743Z',
      role: 'super',
      website: {
        id: 2,
        network_id: 1,
        name: 'Lando Calrissian 2',
        url: 'http://2leuschke.co',
        created_at: '2018-07-09T17:59:40.824Z',
        updated_at: '2018-07-09T17:59:40.824Z',
        contact_login_url: 'http://stamm.info/kattie',
        user_login_url: 'http://wizacrooks.net/alvena.schmeler',
        email: 'lilian_beer@reynolds.info',
        market_id: 2,
        referer: '2smith.name',
        contact_password_reset_url: 'http://dibbert.biz/janiya.wolf',
        user_password_reset_url: 'http://goyette.io/amy.cole'
      },
      photos: []
    },
    photos: []
  }, {
    id: 4,
    vendor_id: 1,
    comment: 'Toto, I\'ve got a feeling we\'re not in Kansas anymore.',
    rating: 5,
    created_at: '2018-07-09T17:59:44.435Z',
    updated_at: '2018-07-09T17:59:44.435Z',
    user: {
      id: 13,
      email: 'cecelia_rath13@glover.org',
      title: 'Dr.',
      first_name: 'Rubie',
      last_name: 'McDermott',
      display_name: 'Ford Nader',
      realtor: true,
      mls_member: false,
      uid: '98ae9888-3744-4018-b565-e6063bcff383',
      created_at: '2018-07-09T17:59:44.419Z',
      updated_at: '2018-07-09T17:59:44.419Z',
      role: 'staff',
      website: {
        id: 11,
        network_id: 1,
        name: 'Darth Vader 11',
        url: 'https://11swift.io',
        created_at: '2018-07-09T17:59:44.414Z',
        updated_at: '2018-07-09T17:59:44.414Z',
        contact_login_url: 'http://romaguera.biz/gunner.labadie',
        user_login_url: 'http://kuhlman.io/ro.raynor',
        email: 'izaiah@haley.com',
        market_id: 11,
        referer: '11mckenzie.io',
        contact_password_reset_url: 'http://hanepfannerstill.name/cathryn',
        user_password_reset_url: 'http://walsheffertz.net/solon'
      },
      photos: []
    },
    photos: []
  }, {
    id: 5,
    vendor_id: 1,
    comment: 'Fasten your seatbelts. It\'s going to be a bumpy night.',
    rating: 4,
    created_at: '2018-07-09T17:59:44.290Z',
    updated_at: '2018-07-09T17:59:44.290Z',
    user: {
      id: 12,
      email: 'vilma12@erdman.io',
      title: 'Miss',
      first_name: 'Lindsey',
      last_name: 'Heathcote',
      display_name: 'Sofia Christiansen',
      realtor: false,
      mls_member: true,
      uid: '2f25338f-eadd-45d4-ac5c-1db744ed2952',
      created_at: '2018-07-09T17:59:44.255Z',
      updated_at: '2018-07-09T17:59:44.255Z',
      role: 'super',
      website: {
        id: 10,
        network_id: 1,
        name: 'Watto 10',
        url: 'https://10cain.com',
        created_at: '2018-07-09T17:59:44.250Z',
        updated_at: '2018-07-09T17:59:44.250Z',
        contact_login_url: 'http://volkman.com/vincenzo_smith',
        user_login_url: 'http://schillerjacobs.co/brody_senger',
        email: 'blanca_bode@feilkeeling.net',
        market_id: 10,
        referer: '10nitzsche.io',
        contact_password_reset_url: 'http://torphy.io/myrtice',
        user_password_reset_url: 'http://carter.net/tierra'
      },
      photos: []
    },
    photos: []
  }]
};

function getVendorReviewsMock() {
  return cloneDeep_1(vendorReviews);
}

function getVendorReviewMock() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return cloneDeep_1(vendorReviews.results[index]);
}

var BlastTemplate = function (_AbstractModel) {
  _inherits(BlastTemplate, _AbstractModel);

  function BlastTemplate() {
    _classCallCheck(this, BlastTemplate);

    return _possibleConstructorReturn(this, (BlastTemplate.__proto__ || _Object$getPrototypeOf(BlastTemplate)).apply(this, arguments));
  }

  _createClass(BlastTemplate, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/blasts/templates';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        body: null,
        body_source: null,
        email_footer: Container.getInstance().resolve(EmailFooter),
        email_footer_id: null,
        email_header: Container.getInstance().resolve(EmailHeader),
        email_header_id: null,
        format: null,
        id: null,
        name: null,
        photos: [],
        subject: null,
        user: {},
        user_id: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'QUERY_PARAMS',
    get: function get() {
      return {
        created_after: {
          type: Date
        },
        created_before: {
          type: Date
        },
        created_since: {
          type: Number
        },
        name: {
          type: String
        },
        user_id: {
          commaSeparatedSupport: true,
          model: User,
          type: Number
        }
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        email_footer: 'email_footer_id',
        email_header: 'email_header_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        email_footer: EmailFooter,
        email_header: EmailHeader,
        user: User
      };
    }
  }]);

  return BlastTemplate;
}(AbstractModel);

var Channel = function (_AbstractModel) {
  _inherits(Channel, _AbstractModel);

  function Channel() {
    _classCallCheck(this, Channel);

    return _possibleConstructorReturn(this, (Channel.__proto__ || _Object$getPrototypeOf(Channel)).apply(this, arguments));
  }

  _createClass(Channel, [{
    key: 'subscribe',


    /** @return {Promise<any>} */
    value: function subscribe() {
      return Client.post(this.constructor.BASE_URI + '/' + this.id + '/subscribe');
    }

    /** @return {Promise<any>} */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      return Client.post(this.constructor.BASE_URI + '/' + this.id + '/unsubscribe');
    }
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/channels';
    }

    /** @return {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        mandatory_subscription: null,
        name: null,
        network_office_id: null,
        office: {},
        primary: null,
        region: {},
        region_id: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        office: 'network_office_id',
        region: 'region_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        office: Office,
        region: Region
      };
    }
  }]);

  return Channel;
}(AbstractModel);

var ChannelComment = function (_AbstractModel) {
  _inherits(ChannelComment, _AbstractModel);

  function ChannelComment() {
    _classCallCheck(this, ChannelComment);

    return _possibleConstructorReturn(this, (ChannelComment.__proto__ || _Object$getPrototypeOf(ChannelComment)).apply(this, arguments));
  }

  _createClass(ChannelComment, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/channels/:channel_id/comments';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        body: null,
        channel_id: null,
        photos: [],
        reply_comments: [],
        reply_to_comment_id: null,
        user: {},
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        reply_comments: ChannelComment,
        user: User
      };
    }
  }]);

  return ChannelComment;
}(AbstractModel);

var ContactPropertyRating = function (_AbstractModel) {
  _inherits(ContactPropertyRating, _AbstractModel);

  function ContactPropertyRating() {
    _classCallCheck(this, ContactPropertyRating);

    return _possibleConstructorReturn(this, (ContactPropertyRating.__proto__ || _Object$getPrototypeOf(ContactPropertyRating)).apply(this, arguments));
  }

  _createClass(ContactPropertyRating, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/property_ratings';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        contact_id: null,
        property_id: null,
        rating: null,
        property: {},
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        property: 'property_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        property: Property
      };
    }
  }]);

  return ContactPropertyRating;
}(AbstractModel);

var ContactPropertyTransaction = function (_AbstractModel) {
  _inherits(ContactPropertyTransaction, _AbstractModel);

  function ContactPropertyTransaction() {
    _classCallCheck(this, ContactPropertyTransaction);

    return _possibleConstructorReturn(this, (ContactPropertyTransaction.__proto__ || _Object$getPrototypeOf(ContactPropertyTransaction)).apply(this, arguments));
  }

  _createClass(ContactPropertyTransaction, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/contacts/:contact_id/property_transactions';
    }

    /** @return {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        contact_id: null,
        created_at: null,
        id: null,
        property: Container.getInstance().resolve(Property),
        property_id: null,
        type: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        property: 'property_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        property: Property
      };
    }
  }]);

  return ContactPropertyTransaction;
}(AbstractModel);

var DripCampaign = function (_AbstractModel) {
  _inherits(DripCampaign, _AbstractModel);

  function DripCampaign() {
    _classCallCheck(this, DripCampaign);

    return _possibleConstructorReturn(this, (DripCampaign.__proto__ || _Object$getPrototypeOf(DripCampaign)).apply(this, arguments));
  }

  _createClass(DripCampaign, [{
    key: 'subscribe',


    /** @return {Promise<any>} */
    value: function subscribe(contactIds) {
      return Client.post(this.constructor.BASE_URI + '/' + this.id + '/subscribe', {
        data: {
          contact_ids: contactIds
        }
      });
    }

    /** @return {Promise<any>} */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe(contactIds) {
      return Client.post(this.constructor.BASE_URI + '/' + this.id + '/unsubscribe', {
        data: {
          contact_ids: contactIds
        }
      });
    }
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/drip_campaigns';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        autosubscribe_rule: {
          channel: null,
          enabled: null,
          military: null,
          rating: null,
          relocation: null,
          source: null,
          tag_ids: [],
          tags: []
        },
        created_at: null,
        id: null,
        name: null,
        sender_email: null,
        sender_name: null,
        updated_at: null,
        user: {},
        user_id: null
      };
    }

    /** @type {object} */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {
        'autosubscribe_rule.tags': 'autosubscribe_rule.tag_ids'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        'autosubscribe_rule.tags': Tag,
        user: User
      };
    }
  }]);

  return DripCampaign;
}(AbstractModel);

var DripCampaignTemplate = function (_AbstractModel) {
  _inherits(DripCampaignTemplate, _AbstractModel);

  function DripCampaignTemplate() {
    _classCallCheck(this, DripCampaignTemplate);

    return _possibleConstructorReturn(this, (DripCampaignTemplate.__proto__ || _Object$getPrototypeOf(DripCampaignTemplate)).apply(this, arguments));
  }

  _createClass(DripCampaignTemplate, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/drip_campaigns/templates';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null,
        subject: null,
        body: null,
        body_source: null,
        email_footer: Container.getInstance().resolve(EmailFooter),
        email_footer_id: null,
        email_header: Container.getInstance().resolve(EmailHeader),
        email_header_id: null,
        format: null,
        user: {},
        user_id: null,
        created_at: null,
        updated_at: null
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        email_footer: 'email_footer_id',
        email_header: 'email_header_id',
        user: 'user_id'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        email_footer: EmailFooter,
        email_header: EmailHeader,
        user: User
      };
    }
  }]);

  return DripCampaignTemplate;
}(AbstractModel);

var FieldOption = function (_AbstractModel) {
  _inherits(FieldOption, _AbstractModel);

  function FieldOption() {
    _classCallCheck(this, FieldOption);

    return _possibleConstructorReturn(this, (FieldOption.__proto__ || _Object$getPrototypeOf(FieldOption)).apply(this, arguments));
  }

  _createClass(FieldOption, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/field_options';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        field: null,
        options: []
      };
    }
  }]);

  return FieldOption;
}(AbstractModel);

var Message = function (_AbstractModel) {
  _inherits(Message, _AbstractModel);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, (Message.__proto__ || _Object$getPrototypeOf(Message)).apply(this, arguments));
  }

  _createClass(Message, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/messages';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        body: null,
        contact_id: null,
        id: null,
        property_id: null,
        referred_by: null,
        requested_showing_at: null,
        skip_email: null,
        user_id: null
      };
    }

    /** @return {object} */

  }, {
    key: 'SERIALIZE_IDS',
    get: function get() {
      return {
        contact: 'contact_id',
        property: 'property_id'
      };
    }

    /** @return {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        contact: Contact,
        property: Property
      };
    }
  }]);

  return Message;
}(AbstractModel);

var MlsMember = function (_AbstractModel) {
  _inherits(MlsMember, _AbstractModel);

  function MlsMember() {
    _classCallCheck(this, MlsMember);

    return _possibleConstructorReturn(this, (MlsMember.__proto__ || _Object$getPrototypeOf(MlsMember)).apply(this, arguments));
  }

  _createClass(MlsMember, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/mls_members';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        created_at: null,
        updated_at: null,
        member_key: null,
        member_mls_id: null,
        member_status: null,
        modification_timestamp: null,
        member_first_name: null,
        member_last_name: null,
        member_email: null,
        job_title: null,
        last_login_timestamp: null,
        logo_change_timestamp: null,
        member_address1: null,
        member_address2: null,
        member_aor: null,
        member_aor_key: null,
        member_aor_key_numeric: null,
        member_aor_mls_id: null,
        member_association_comments: null,
        member_carrier_route: null,
        member_city: null,
        member_country: null,
        member_county_or_parish: null,
        member_designation: null,
        member_direct_phone: null,
        member_fax: null,
        member_full_name: null,
        member_home_phone: null,
        member_is_assistant_to: null,
        member_key_numeric: null,
        member_languages: null,
        member_login_id: null,
        member_middle_name: null,
        member_mls_access_y_n: null,
        member_mls_security_class: null,
        member_mobile_phone: null,
        member_name_prefix: null,
        member_name_suffix: null,
        member_national_association_id: null,
        member_nickname: null,
        member_office_phone_ext: null,
        member_office_phone: null,
        member_pager: null,
        member_password: null,
        member_phone_ttytdd: null,
        member_postal_code: null,
        member_postal_code_plus4: null,
        member_preferred_phone_ext: null,
        member_preferred_phone: null,
        member_state_license: null,
        member_state_license_state: null,
        member_state_or_province: null,
        member_toll_free_phone: null,
        member_type: null,
        member_voice_mail_ext: null,
        member_voice_mail: null,
        office_key: null,
        office_key_numeric: null,
        office_mls_id: null,
        office_name: null,
        original_entry_timestamp: null,
        originating_system_id: null,
        originating_system_member_key: null,
        originating_system_name: null,
        photos_change_timestamp: null,
        source_system_id: null,
        source_system_member_key: null,
        source_system_name: null,
        syndicate_to: null,
        biography: null,
        ams_data: {},
        board: {},
        office: {},
        media: [],
        social_media: []
      };
    }
  }]);

  return MlsMember;
}(AbstractModel);

var PropertyCustomField = function (_AbstractModel) {
  _inherits(PropertyCustomField, _AbstractModel);

  function PropertyCustomField() {
    _classCallCheck(this, PropertyCustomField);

    return _possibleConstructorReturn(this, (PropertyCustomField.__proto__ || _Object$getPrototypeOf(PropertyCustomField)).apply(this, arguments));
  }

  _createClass(PropertyCustomField, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/properties/custom_fields';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        field: null,
        label: null
      };
    }
  }]);

  return PropertyCustomField;
}(AbstractModel);

var Team = function (_AbstractModel) {
  _inherits(Team, _AbstractModel);

  function Team() {
    _classCallCheck(this, Team);

    return _possibleConstructorReturn(this, (Team.__proto__ || _Object$getPrototypeOf(Team)).apply(this, arguments));
  }

  _createClass(Team, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/teams';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        addresses: [],
        biography: null,
        contact_access: null,
        created_at: null,
        display_on_web: null,
        email: null,
        facts: [],
        id: null,
        job_title: null,
        leader_user_ids: [],
        name: null,
        office_ids: [],
        offices: [],
        phone_numbers: [],
        photos: [],
        updated_at: null,
        urls: [],
        user_ids: [],
        users: []
      };
    }

    /** @type {object} */

  }, {
    key: 'PLUCK_IDS',
    get: function get() {
      return {
        offices: 'office_ids',
        users: 'user_ids'
      };
    }

    /** @type {object} */

  }, {
    key: 'PRIMARY_MAP',
    get: function get() {
      return {
        address: 'addresses',
        phone_number: 'phone_numbers',
        photo: 'photos'
      };
    }

    /** @type {object} */

  }, {
    key: 'SERIALIZED_OBJECTS',
    get: function get() {
      return {
        users: User
      };
    }
  }]);

  return Team;
}(AbstractModel);

var UserPasskey = function (_AbstractModel) {
  _inherits(UserPasskey, _AbstractModel);

  function UserPasskey() {
    _classCallCheck(this, UserPasskey);

    return _possibleConstructorReturn(this, (UserPasskey.__proto__ || _Object$getPrototypeOf(UserPasskey)).apply(this, arguments));
  }

  _createClass(UserPasskey, null, [{
    key: 'authChallenge',


    /** @return {Promise<any>} */
    value: function authChallenge() {
      return Client.post(this.BASE_URI + '/auth_challenge', {
        withCredentials: true
      });
    }

    /** @return {Promise<any>} */

  }, {
    key: 'auth',
    value: function auth(data) {
      return Client.post(this.BASE_URI + '/auth', {
        data: data,
        withCredentials: true
      });
    }

    /** @return {Promise<any>} */

  }, {
    key: 'createChallenge',
    value: function createChallenge() {
      return Client.post(this.BASE_URI + '/create_challenge', {
        withCredentials: true
      });
    }
  }, {
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/passkeys';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        external_id: null,
        credential: null,
        label: null,
        public_key: null,
        sign_count: null,
        created_at: null,
        last_used_at: null,
        updated_at: null
      };
    }

    /** @return {boolean} */

  }, {
    key: 'WITH_CREDENTIALS',
    get: function get() {
      return true;
    }
  }]);

  return UserPasskey;
}(AbstractModel);

// @TODO: Could be considered something other than a model, but requires similar functionality.

var UserPrivate = function (_AbstractModel) {
  _inherits(UserPrivate, _AbstractModel);

  function UserPrivate() {
    _classCallCheck(this, UserPrivate);

    return _possibleConstructorReturn(this, (UserPrivate.__proto__ || _Object$getPrototypeOf(UserPrivate)).apply(this, arguments));
  }

  _createClass(UserPrivate, [{
    key: 'exists',


    /** @return {boolean} */
    // eslint-disable-next-line class-methods-use-this
    value: function exists() {
      return true;
    }

    /** @return {Promise<any>} */

  }], [{
    key: 'fetch',
    value: function fetch(userId) {
      var _this2 = this;

      return new _Promise(function (resolve, reject) {
        Client.get(_this2.BASE_URI.replace(':user_id', userId)).then(function (response) {
          var item = new _this2(cloneDeep_1(response.data)).setUriParam('user_id', userId);

          resolve(item);
        }).catch(function () {
          reject(new Error('Something unexpected happened.'));
        });
      });
    }
  }, {
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/:user_id/private';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        biometric_approved: false,
        biometric_approved_at: null,
        biometric_approved_ip: null,
        terms_of_service_accepted: false,
        terms_of_service_accepted_at: null,
        terms_of_service_accepted_ip: null,
        user_id: null
      };
    }

    /** @type {boolean} */

  }, {
    key: 'DESTROYABLE',
    get: function get() {
      return false;
    }

    /** @type {string|null} */

  }, {
    key: 'PRIMARY_KEY',
    get: function get() {
      return null;
    }
  }]);

  return UserPrivate;
}(AbstractModel);

var UserCustomField = function (_AbstractModel) {
  _inherits(UserCustomField, _AbstractModel);

  function UserCustomField() {
    _classCallCheck(this, UserCustomField);

    return _possibleConstructorReturn(this, (UserCustomField.__proto__ || _Object$getPrototypeOf(UserCustomField)).apply(this, arguments));
  }

  _createClass(UserCustomField, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/custom_fields';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        field: null,
        label: null
      };
    }
  }]);

  return UserCustomField;
}(AbstractModel);

var UserRegistrationEmail = function (_AbstractModel) {
  _inherits(UserRegistrationEmail, _AbstractModel);

  function UserRegistrationEmail() {
    _classCallCheck(this, UserRegistrationEmail);

    return _possibleConstructorReturn(this, (UserRegistrationEmail.__proto__ || _Object$getPrototypeOf(UserRegistrationEmail)).apply(this, arguments));
  }

  _createClass(UserRegistrationEmail, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/:user_id/emails/registration';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        user_id: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return UserRegistrationEmail;
}(AbstractModel);

var UserSsoServiceProvider = function (_AbstractModel) {
  _inherits(UserSsoServiceProvider, _AbstractModel);

  function UserSsoServiceProvider() {
    _classCallCheck(this, UserSsoServiceProvider);

    return _possibleConstructorReturn(this, (UserSsoServiceProvider.__proto__ || _Object$getPrototypeOf(UserSsoServiceProvider)).apply(this, arguments));
  }

  _createClass(UserSsoServiceProvider, [{
    key: 'auth',


    /** @return {Promise<any>} */
    value: function auth() {
      return Client.post(this.constructor.BASE_URI + '/' + this.id + '/auth');
    }
  }], [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/users/sso_service_providers';
    }

    /** @type {object} */

  }, {
    key: 'DEFAULTS',
    get: function get() {
      return {
        id: null,
        name: null,
        client_id: null,
        client_secret: null,
        sso_token: null,
        password: null,
        username: null,
        security_id: null,
        company_id: null,
        company_uuid: null,
        shared_key: null,
        created_at: null,
        updated_at: null
      };
    }
  }]);

  return UserSsoServiceProvider;
}(AbstractModel);

var WebsiteRouteSettings = function (_RouteSettings) {
  _inherits(WebsiteRouteSettings, _RouteSettings);

  function WebsiteRouteSettings() {
    _classCallCheck(this, WebsiteRouteSettings);

    return _possibleConstructorReturn(this, (WebsiteRouteSettings.__proto__ || _Object$getPrototypeOf(WebsiteRouteSettings)).apply(this, arguments));
  }

  _createClass(WebsiteRouteSettings, null, [{
    key: 'fetch',


    /** @return {Promise<any>} */
    value: function fetch(websiteId) {
      var _this2 = this;

      return new _Promise(function (resolve, reject) {
        Client.get(_this2.BASE_URI.replace(':website_id', websiteId)).then(function (response) {
          var item = new _this2(cloneDeep_1(response.data)).setUriParam('website_id', websiteId);

          resolve(item);
        }).catch(function () {
          reject(new Error('Something unexpected happened.'));
        });
      });
    }
  }, {
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/websites/:website_id/routes/settings';
    }
  }]);

  return WebsiteRouteSettings;
}(RouteSettings);

var WebsiteRoute = function (_Route) {
  _inherits(WebsiteRoute, _Route);

  function WebsiteRoute() {
    _classCallCheck(this, WebsiteRoute);

    return _possibleConstructorReturn(this, (WebsiteRoute.__proto__ || _Object$getPrototypeOf(WebsiteRoute)).apply(this, arguments));
  }

  _createClass(WebsiteRoute, null, [{
    key: 'BASE_URI',

    /** @type {string} */
    get: function get() {
      return '/websites/:website_id/routes';
    }

    /** @type {function} */

  }, {
    key: 'SETTINGS_MODEL',
    get: function get() {
      return WebsiteRouteSettings;
    }
  }]);

  return WebsiteRoute;
}(Route);

// Client

var defaultExport = {
  AbstractModel: AbstractModel,
  Blast: Blast,
  BlastSubscriptionIndex: BlastSubscriptionIndex,
  BlastTemplate: BlastTemplate,
  Channel: Channel,
  ChannelComment: ChannelComment,
  Client: Client,
  Contact: Contact,
  ContactActivityIndex: ContactActivityIndex,
  ContactCustomActivity: ContactCustomActivity,
  ContactGroup: ContactGroup,
  ContactEmailIndex: ContactEmailIndex,
  ContactListingReport: ContactListingReport,
  ContactMarketUpdate: ContactMarketUpdate,
  ContactMessage: ContactMessage,
  ContactNote: ContactNote,
  ContactPropertyRating: ContactPropertyRating,
  ContactPropertyTransaction: ContactPropertyTransaction,
  ContactSavedSearch: ContactSavedSearch,
  ContactSuggestionIndex: ContactSuggestionIndex,
  Container: Container,
  Content: Content,
  ContentCategory: ContentCategory,
  EmailFooter: EmailFooter,
  EmailHeader: EmailHeader,
  DripCampaign: DripCampaign,
  DripCampaignDrip: DripCampaignDrip,
  DripCampaignSubscriptionIndex: DripCampaignSubscriptionIndex,
  DripCampaignTemplate: DripCampaignTemplate,
  FieldOption: FieldOption,
  PropertyMarketingHistory: PropertyMarketingHistory,
  Message: Message,
  MlsMember: MlsMember,
  MlsOffice: MlsOffice,
  OAuthAppIndex: OAuthAppIndex,
  Office: Office,
  OfficePolicy: OfficePolicy,
  Product: Product,
  ProductCategory: ProductCategory,
  ProductRequest: ProductRequest,
  ProductRequestStatus: ProductRequestStatus,
  Property: Property,
  PropertyCustomField: PropertyCustomField,
  PropertyNote: PropertyNote,
  PropertyPolicy: PropertyPolicy,
  PropertySuggestionIndex: PropertySuggestionIndex,
  PropertyTransaction: PropertyTransaction,
  Region: Region,
  Route: Route,
  RouteSettings: RouteSettings,
  SsoAppIndex: SsoAppIndex,
  Tag: Tag,
  TagSuggestionIndex: TagSuggestionIndex,
  Task: Task,
  Team: Team,
  User: User,
  UserActivityIndex: UserActivityIndex,
  UserContactSync: UserContactSync,
  UserContactSyncProviderGroupIndex: UserContactSyncProviderGroupIndex,
  UserCustomActivity: UserCustomActivity,
  UserCustomField: UserCustomField,
  UserHotsheet: UserHotsheet,
  UserMlsMember: UserMlsMember,
  UserNote: UserNote,
  UserPasskey: UserPasskey,
  UserPolicy: UserPolicy,
  UserPrivate: UserPrivate,
  UserSsoServiceProvider: UserSsoServiceProvider,
  UserSuggestionIndex: UserSuggestionIndex,
  UserRegistrationEmail: UserRegistrationEmail,
  UserTestimonial: UserTestimonial,
  WebsiteRoute: WebsiteRoute,
  WebsiteRouteSettings: WebsiteRouteSettings,
  Vendor: Vendor,
  VendorArea: VendorArea,
  VendorCategory: VendorCategory,
  VendorReview: VendorReview,
  WebsiteSuggestionIndex: WebsiteSuggestionIndex
};

export default defaultExport;
export { AbstractModel, Blast, BlastSubscriptionIndex, BlastTemplate, Channel, ChannelComment, Client, Contact, ContactActivityIndex, ContactCustomActivity, ContactEmailIndex, ContactGroup, ContactListingReport, ContactMarketUpdate, ContactMessage, ContactNote, ContactPropertyRating, ContactPropertyTransaction, ContactSavedSearch, ContactSuggestionIndex, Container, Content, ContentCategory, DripCampaign, DripCampaignDrip, DripCampaignSubscriptionIndex, DripCampaignTemplate, EmailFooter, EmailHeader, FieldOption, Message, MlsMember, MlsOffice, OAuthAppIndex, Office, OfficePolicy, getContactMock, getContactsMock, getContactActivityMock, getContactActivitiesMock, getPropertyMock, getPropertiesMock, getUserMock, getUsersMock, getUserActivityMock, getUserActivitiesMock, getVendorMock, getVendorsMock, getVendorAreaMock, getVendorAreasMock, getVendorCategoryMock, getVendorCategoriesMock, getVendorReviewMock, getVendorReviewsMock, Product, ProductCategory, ProductRequest, ProductRequestStatus, Property, PropertyCustomField, PropertyNote, PropertyMarketingHistory, PropertyPolicy, PropertySuggestionIndex, PropertyTransaction, Region, Route, RouteSettings, SsoAppIndex, Tag, TagSuggestionIndex, Task, Team, User, UserActivityIndex, UserContactSync, UserContactSyncProviderGroupIndex, UserCustomActivity, UserCustomField, UserHotsheet, UserMlsMember, UserNote, UserPasskey, UserPolicy, UserPrivate, UserRegistrationEmail, UserSsoServiceProvider, UserSuggestionIndex, UserTestimonial, userRoles as USER_ROLES, WebsiteRoute, WebsiteRouteSettings, Vendor, VendorArea, VendorCategory, VendorReview, WebsiteSuggestionIndex };
